import React, { useState, useEffect, useCallback, useRef } from 'react'
import './../App.css';
import './Home.css';
import {CreateSearchBarWithPlaceHolder, CreateButton} from './CommonObjects';
import {SetAuditTrail} from './Reports/AuditTrailReportEmployeeSetup';
import ViewEmployee from './Personnel/ViewEmployee';
import IntroImg from '../assets/payroll-intro.jpeg';
import axios from 'axios';
import {useTable, useSortBy} from 'react-table';
import {token, domain, globalTimeFormat} from './Security';
import { BarChart, Bar, Tooltip, ResponsiveContainer } from 'recharts';
import 'react-tabs/style/react-tabs.css'; 
import loadingSpinner from './../assets/loading.gif';
// icons
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import SearchIcon from '@mui/icons-material/Search';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import StickyNote2Icon from '@mui/icons-material/StickyNote2';
import CloseIcon from "@mui/icons-material/Close";
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EditIcon from '@mui/icons-material/Edit';
import NotInterestedIcon from '@mui/icons-material/NotInterested';
import ImageIcon from '@mui/icons-material/Image';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import SaveIcon from '@mui/icons-material/Save';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ListIcon from '@mui/icons-material/List';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import AddIcon from '@mui/icons-material/Add';

//Global Variables -start
var tooltip;

const Home = ({user, 
    userAccess,
    employeePhoto,
    setEmployeePhoto,
    isHideSideMenu
}) => {
    console.log(domain)
    // Connect to API
    const [employees, setEmployees] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [searchPlaceholder, setSearchPlaceholder] = useState("name");
    //ViewEmployee
    const [showViewEmployee, setShowViewEmployee] = useState(false);
    const [viewedData, setViewedData] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);

    const [filteredEmployee, setFilteredEmployee] = useState([]);
    
    const [loading, setLoading] = useState(true);
    const [employeeStatus, setEmployeeStatus] = useState("Active");

    const handleFilter = (value) => {
        const lowercaseValue = value.toLowerCase();
        var res = [];
        setCurrentPage(1);

        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f.employeeId.toString().startsWith(lowercaseValue)
                );
                break;
            default:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                
                break;
        }
        setEmployees(res);
    }

    const apiUrl = domain +"/api/Employee";

    const fetchData = useCallback(async () => {
        try {
            setLoading(true);

            const response = await axios.get(apiUrl + `/single-data/status/${employeeStatus}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            setEmployees(response.data);
            setFilterData(response.data);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }, [apiUrl, employeeStatus]);

    const fetchDataFilteredEmployee = useCallback(async () => {
        try {
            setLoading(true);

            const response = await axios.get(apiUrl + `/${user.employeePersonalInformationId}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            return response.data;
            
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, [apiUrl, user]);

    const fetchDataEmployeeById = useCallback(async (id) => {
        try {
            const response = await axios.get(apiUrl + `/${id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            return response.data;
            
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, [apiUrl]);

    useEffect(() => {
        fetchData();
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("name");
                break;
            case 1:
                setSearchPlaceholder("employee id");
                break;
            default:
                setSearchPlaceholder("name");
                break;
        }
    }, [fetchData, filterDataIndex]);

    useEffect(() => {
        const _fetchData = async () => {
            try {
                const _filteredEmployee = await fetchDataFilteredEmployee();
                setFilteredEmployee(_filteredEmployee);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        // Call the async function
        if(!userAccess?.hasHome){
            _fetchData();
        }
    }, [userAccess, fetchDataFilteredEmployee])

    const addHandleClick = () =>{
        window.location.pathname = "/addEmployee";
    }
    const viewEmployeeHandleClick = async (data) =>{
        setLoading(true);
        const employeeInfo = await fetchDataEmployeeById(data.id);
        setViewedData(employeeInfo);

        setLoading(false);
        setShowViewEmployee(true);
    }
    const closeViewEmployeeHandleClick = () =>{
        setShowViewEmployee(false);
        setViewedData([]);
    }
    
    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <ShowIntroduction filteredEmployee={filteredEmployee} setEmployeePhoto={setEmployeePhoto} employees={employees} user={user} userAccess={userAccess}/> {/* Introduction sect */}

                    <div className="homeBody row">
                        <div className="employee">
                            {userAccess?.hasHome ?
                                (
                                    <ShowEmployeeInformation employees={employees}
                                                    handleFilter={handleFilter} 
                                                    setFilterDataIndex={setFilterDataIndex}
                                                    searchPlaceholder={searchPlaceholder}
                                                    addHandleClick={addHandleClick} 
                                                    viewEmployeeHandleClick={viewEmployeeHandleClick}
                                                    loading={loading}
                                                    userAccessData={userAccess}
                                                    currentPage={currentPage} 
                                                    setCurrentPage={setCurrentPage}
                                                    employeeStatus={employeeStatus}
                                                    setEmployeeStatus={setEmployeeStatus}
                                    /> 
                                )
                                :
                                (
                                    <ShowLatestTransactionRequests user={user} filteredEmployee={filteredEmployee}/>
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
            { showViewEmployee &&
                <ViewEmployee   user={user}
                                isOpen={showViewEmployee}
                                onClose={closeViewEmployeeHandleClick}
                                viewedData={viewedData}
                                setViewedData={setViewedData}
                                fetchData={fetchData}
                                employeePhoto={employeePhoto}
                                setEmployeePhoto={setEmployeePhoto}
                />
            }
        </div>
    )
}

function ShowIntroduction({filteredEmployee, setEmployeePhoto, employees, user, userAccess}){
    const [currentView, setCurrentView] = useState('announcement');
    const [imageSource, setImageSource] = useState([]);
    const announcementRef = useRef(null);
    const memoRef = useRef(null);
    const todayAnnouncementRef = useRef(null);
    const todayMemoRef = useRef(null);

    const [employeeInfo, setEmployeeInfo] = useState([]);
    const [generalInfo, setGeneralInfo] = useState([]);
    const [events, setEvents] = useState([]);
    const [todayAnnouncementEvents, setTodayAnnouncementEvents] = useState([]);
    const [todayMemoEvents, setTodayMemoEvents] = useState([]);
    const [selectedFile, setSelectedFile] = useState("");
    const [loadingRequest, setLoadingRequest] = useState(false);

    const [hasGeneralAnnouncement, setHasGeneralAnnouncement] = useState(false);
    const [hasGeneralMemo, setHasGeneralMemo] = useState(false);

    const [isImageModalOpen, setIsImageModalOpen] = useState(false);
    const [imageSrcModalOpen, setImageSrcModalOpen] = useState("");
    const openImage = (imageSrc) => {
        setIsImageModalOpen(true); // Open image in full view
        setImageSrcModalOpen(imageSrc)
    };
    
    const closeImageModal = () => {
        setIsImageModalOpen(false); // Close full image modal
    };

    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const apiUrl = domain + "/api/General";

    const fetchData = useCallback(async () => {
        await axios.get(`${apiUrl}/totals`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setGeneralInfo(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error); 
        });
    }, [apiUrl]);
    const fetchDataEmployeeInfo = useCallback(async () => {
        const apiUrl = domain + "/api/Employee";

        await axios.get(`${apiUrl}/${user.employeePersonalInformationId}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setEmployeeInfo(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error); 
        });
    }, [user]);

    const fetchDataTodayAnnouncementEvents = useCallback(async () => {
        const apiUrl = domain + "/api/Announcement";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
                }
            });
            let filteredData = [];
            response.data.forEach(announcement => {
                const announcementDateFrom = new Date(announcement.dateFrom);
                const announcementDateTo = new Date(announcement.dateTo);
                const thisDate = new Date();
    
                // Strip time component by setting to midnight
                const thisDateOnly = new Date(thisDate.setHours(0, 0, 0, 0));
                const announcementDateFromOnly = new Date(announcementDateFrom.setHours(0, 0, 0, 0));
                const announcementDateToOnly = new Date(announcementDateTo.setHours(23, 59, 59, 999));
    
                if (thisDateOnly >= announcementDateFromOnly && thisDateOnly <= announcementDateToOnly) {
                    filteredData.push(announcement);
                }
            });
            
            return filteredData;
        } catch (error) {
            console.error('Error fetching data:', error); 
            return [];
        }
    }, []);
    const fetchDataTodayMemoEvents = useCallback(async () => {
        const apiUrl = domain + "/api/Memo";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
                }
            });

            let filteredData = [];
            response.data.forEach(memo => {
                const memoDateFrom = new Date(memo.dateFrom);
                const memoDateTo = new Date(memo.dateTo);
                const thisDate = new Date();
    
                // Strip time component by setting to midnight
                const thisDateOnly = new Date(thisDate.setHours(0, 0, 0, 0));
                const memoDateFromOnly = new Date(memoDateFrom.setHours(0, 0, 0, 0));
                const memoDateToOnly = new Date(memoDateTo.setHours(23, 59, 59, 999));
    
                if (thisDateOnly >= memoDateFromOnly && thisDateOnly <= memoDateToOnly) {
                    filteredData.push(memo);
                }
            });
            
            return filteredData;
        } catch (error) {
            console.error('Error fetching data:', error); 
            return [];
        }
    }, []);
    const fetchDataEvents = useCallback(async () => {
        try {
            const response = await axios.get(apiUrl, {
                headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
                }
            });
            const _announcements = await fetchDataTodayAnnouncementEvents();
            const _memos = await fetchDataTodayMemoEvents();

            setTodayAnnouncementEvents(_announcements);
            setTodayMemoEvents(_memos);
            setEvents(response.data); // Set the response data to the state

            const findAnnouncement = response.data.find(event => event.key === "Announcement");
            const findMemo = response.data.find(event => event.key === "Memo");

            if(findAnnouncement){
                setHasGeneralAnnouncement(true);
            } else {
                setHasGeneralAnnouncement(false);
            }

            if(findMemo){
                setHasGeneralMemo(true);
            } else {
                setHasGeneralMemo(false);
            }

        } catch (error) {
            console.error('Error fetching data:', error); 
        }
    }, [apiUrl, fetchDataTodayAnnouncementEvents, fetchDataTodayMemoEvents]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);
    useEffect(() => {
        fetchDataEmployeeInfo();
    }, [fetchDataEmployeeInfo]);
    useEffect(() => {
        fetchDataEvents();
    }, [fetchDataEvents]);

    useEffect(() => {
        if(employeeInfo && employeeInfo.photo){
            const binaryData = atob(employeeInfo.photo);
    
            // Convert the binary data to a Uint8Array
            const arrayBuffer = new ArrayBuffer(binaryData.length);
            const uint8Array = new Uint8Array(arrayBuffer);
            for (let i = 0; i < binaryData.length; i++) {
                uint8Array[i] = binaryData.charCodeAt(i);
            }
    
            const blob = new Blob([uint8Array], { type: 'image/jpeg' }); // Adjust the MIME type as per your data
    
            const file = new File([blob], '', { type: 'image/jpeg' }); // Provide a filename and MIME type
    
            setSelectedFile(file);
        }
    }, [employeeInfo, employees, user]);

    const barData = [
        {
            name: 'Leave Request',
            amount: generalInfo.totalLeaveRequests,
            fill: '#ff4d4d'
        },
        {
            name: 'OT Request',
            amount: generalInfo.totalOTRequests,
            fill: '#47d147'
        },
        {
            name: 'Loan Request',
            amount: generalInfo.totalLoanRequests,
            fill: '#1a75ff'
        }
    ];

    function formatDate(dateString) {
        const date = new Date(dateString);
        const options = { month: 'long', day: 'numeric', year: 'numeric' };
        return date.toLocaleDateString('en-US', options);
    }

    const handleUpdate = async (event, file) => {
        const apiUrlUpdate =  domain + "/api/Employee";

        event.preventDefault();
    
        setLoadingRequest(true);
        
        const now = new Date();

        const toBase64 = (file) => new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    
        let base64String = "";
        let photoToBeSave = "";

        if(file){
            base64String = await toBase64(file);
            photoToBeSave = base64String.split(',')[1];
        }
    
        const data = {
            employeeId: employeeInfo.employeeId,
            lastName: employeeInfo.lastName,
            firstName: employeeInfo.firstName,
            middleName: employeeInfo.middleName,
            extensionName: employeeInfo.extensionName,
            fullName: employeeInfo.fullName,
            nickName: employeeInfo.nickName,
            age: employeeInfo.age? employeeInfo.age : 0,
            dateOfBirth: employeeInfo.dateOfBirth? employeeInfo.dateOfBirth : null,
            placeOfBirth: employeeInfo.placeOfBirth,
            civilStatus: employeeInfo.civilStatus,
            bloodType: employeeInfo.bloodType,
            height: employeeInfo.height,
            weight: employeeInfo.weight,
            citizenship: employeeInfo.citizenship,
            religion: employeeInfo.religion,
            gender: employeeInfo.gender,
            mobileNumber: employeeInfo.mobileNumber,
            emailAddress: employeeInfo.emailAddress,
            blkLot: employeeInfo.blkLot,
            street: employeeInfo.street,
            barangay: employeeInfo.barangay,
            city: employeeInfo.city,
            postalCode: employeeInfo.postalCode,
            yearsOfStay: employeeInfo.yearsOfStay? employeeInfo.yearsOfStay : 0,
            photo: photoToBeSave,
            deviceNumber: employeeInfo.deviceNumber,
            employeeInformation: {
                employeePersonalInformationId: employeeInfo.id,
                locationId: employeeInfo.employeeInformation.locationId ? employeeInfo.employeeInformation.locationId : null,
                dateEmployed: employeeInfo.employeeInformation.dateEmployed ? employeeInfo.employeeInformation.dateEmployed : null,
                dateRegular: employeeInfo.employeeInformation.dateRegular ? employeeInfo.employeeInformation.dateRegular : null,
                dateProbationary: employeeInfo.employeeInformation.dateProbationary ? employeeInfo.employeeInformation.dateProbationary : null,
                dateProjectBase: employeeInfo.employeeInformation.dateProjectBase ? employeeInfo.employeeInformation.dateProjectBase : null,
                dateContractual: employeeInfo.employeeInformation.dateContractual ? employeeInfo.employeeInformation.dateContractual : null,
                employmentId: employeeInfo.employeeInformation.employmentId ? employeeInfo.employeeInformation.employmentId : null,
                departmentId: employeeInfo.employeeInformation.departmentId ? employeeInfo.employeeInformation.departmentId : null,
                sectionId: employeeInfo.employeeInformation.sectionId ? employeeInfo.employeeInformation.sectionId : null,
                classificationId: employeeInfo.employeeInformation.classificationId ? employeeInfo.employeeInformation.classificationId : null,
                payTypeId: employeeInfo.employeeInformation.payTypeId ? employeeInfo.employeeInformation.payTypeId : null,
                shiftScheduleId: employeeInfo.employeeInformation.shiftScheduleId ? employeeInfo.employeeInformation.shiftScheduleId : null,
                positionId: employeeInfo.employeeInformation.positionId ? employeeInfo.employeeInformation.positionId : null,
                companyId: employeeInfo.employeeInformation.companyId ? employeeInfo.employeeInformation.companyId : null,
                salaryType: employeeInfo.employeeInformation.salaryType ? employeeInfo.employeeInformation.salaryType : null,
                createdDate: now,
                createdBy: 0,
            },
            employeeReportTo: {
                employeePersonalInformationId: employeeInfo.id,
                reportToId: null
            },
            employeeAccountInformation: {
                employeePersonalInformationId: employeeInfo.id,
                sss: employeeInfo.employeeAccountInformation.sss,
                tin: employeeInfo.employeeAccountInformation.tin,
                passport: employeeInfo.employeeAccountInformation.passport,
                philhealth: employeeInfo.employeeAccountInformation.philhealth,
                pagibig: employeeInfo.employeeAccountInformation.pagibig,
            },
            employeeEducationAttainments: employeeInfo.employeeEducationAttainments,
            employeeDependents: employeeInfo.employeeDependents,
            employeeFamilyData: employeeInfo.employeeFamilyData,
            employeeEmergencyContacts: employeeInfo.employeeEmergencyContacts,
            employeeLeave: {
                employeePersonalInformationId: employeeInfo.id,
                totalVacation: employeeInfo.employeeLeave && employeeInfo.employeeLeave.totalVacation ? employeeInfo.employeeLeave.totalVacation : 0,
                vacationRemaining: employeeInfo.employeeLeave && employeeInfo.employeeLeave.vacationRemaining ? employeeInfo.employeeLeave.vacationRemaining : 0,
                totalSick: employeeInfo.employeeLeave && employeeInfo.employeeLeave.totalSick ? employeeInfo.employeeLeave.totalSick : 0,
                sickRemaining: employeeInfo.employeeLeave && employeeInfo.employeeLeave.sickRemaining ? employeeInfo.employeeLeave.sickRemaining : 0,
                totalServiceIncentive: employeeInfo.employeeLeave && employeeInfo.employeeLeave.totalServiceIncentive ? employeeInfo.employeeLeave.totalServiceIncentive : 0,
                serviceIncentiveRemaining: employeeInfo.employeeLeave && employeeInfo.employeeLeave.serviceIncentiveRemaining ? employeeInfo.employeeLeave.serviceIncentiveRemaining : 0,
                totalSoloParent: employeeInfo.employeeLeave && employeeInfo.employeeLeave.totalSoloParent ? employeeInfo.employeeLeave.totalSoloParent : 0,
                soloParentRemaining: employeeInfo.employeeLeave && employeeInfo.employeeLeave.soloParentRemaining ? employeeInfo.employeeLeave.soloParentRemaining : 0,
            },
            employeeStatuses: {
                employeePersonalInformationId: employeeInfo.id,
                status: employeeInfo.employeeStatuses && employeeInfo.employeeStatuses.status ? employeeInfo.employeeStatuses.status : null,
            },
        };
    
        try {
            
            await axios.put(apiUrlUpdate + `/${employeeInfo.id}`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            await SetAuditTrail({
                setupArea: "Home", 
                actionTaken: "update", 
                field: "Employee's Photo", 
                newValue: "-", 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });

            setShowRequestMessage(true);
            setIsSuccess(true);

            if(data.photo){
                const binaryData = atob(data.photo);
        
                // Convert the binary data to a Uint8Array
                const arrayBuffer = new ArrayBuffer(binaryData.length);
                const uint8Array = new Uint8Array(arrayBuffer);
                for (let i = 0; i < binaryData.length; i++) {
                    uint8Array[i] = binaryData.charCodeAt(i);
                }
        
                const blob = new Blob([uint8Array], { type: 'image/jpeg' }); // Adjust the MIME type as per your data
        
                const file = new File([blob], 'filename.jpg', { type: 'image/jpeg' }); // Provide a filename and MIME type
        
                setEmployeePhoto(file);
                setSelectedFile(file);
            }

            console.log('Data updated successfully');
        } catch (error) {
            setLoadingRequest(false);
            console.error('There was a problem updating data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        // Check if the selected file is an image
        if (file && file.type.startsWith("image/")) {
            setSelectedFile(file);

            handleUpdate(event, file);
        } else {
            // Handle case where non-image file is selected
            alert("Please select an image file.");
        }
    };

    const getGeneralImageSource = useCallback((value) =>{
        let imageSrc = [];
        const findEvent = events.find(event => event.key === value);
        const findAllEvent = events.filter(event => event.key === "Announcement" || event.key === "Memo");
        
        if(findEvent){
            if(findEvent.content){
                const _imageSrc = 'data:image/jpeg;base64,' + findEvent.content;

                imageSrc.push(_imageSrc);
            }
        }

        let isThereAnImage = false;

        findAllEvent.forEach(event =>{
            if(event.content){
                isThereAnImage = true;
            }
        })

        if(!isThereAnImage){
            imageSrc.push(IntroImg);
        }
        
        return imageSrc
    }, [events]);
    const announcementContent = () =>{
        const findAnnouncement = events.find(event => event.key === "Announcement");
        if(findAnnouncement){
            const formattedDescription = findAnnouncement.description.split('\n').map((line, index) => (
                <React.Fragment key={index}>
                    {line}
                    <br />
                </React.Fragment>
            ));
            return (
                <>
                    {formattedDescription}
                </>
            );
        }
        
        return <></>
    }
    const memoContent = () =>{
        const findMemo = events.find(event => event.key === "Memo");
        if(findMemo){
            const formattedDescription = findMemo.description.split('\n').map((line, index) => (
                <React.Fragment key={index}>
                    {line}
                    <br />
                </React.Fragment>
            ));
            return (
                <>
                    {formattedDescription}
                </>
            );
        }
        
        return <></>
    } 

    function areDatesEqual(date1, date2) {
        // Create Date objects from the provided date strings or values
        const d1 = new Date(date1);
        const d2 = new Date(date2);
    
        // Compare year, month, and day of the two Date objects
        return (
            d1.getFullYear() === d2.getFullYear() &&
            d1.getMonth() === d2.getMonth() &&
            d1.getDate() === d2.getDate()
        );
    }
    const getImageSource = useCallback((value) =>{
        let events = [];
        let imageSrc = [];
        if(value === "TodayAnnouncement"){
            events = todayAnnouncementEvents;
        } else if(value === "TodayMemo"){
            events = todayMemoEvents;
        }

        const findEvent = events.filter(event => areDatesEqual(event.date, new Date()));

        if(findEvent.length > 0){
            imageSrc = findEvent
                            .filter(event => event.content)
                            .map(event => 'data:image/jpeg;base64,' + event.content);
        }
        
        return imageSrc;
    }, [todayAnnouncementEvents, todayMemoEvents]);

    // Announcement modal
    const [currentAnnouncementIndex, setCurrentAnnouncementIndex] = useState(0);
    const [openAnnouncementModals, setOpenAnnouncementModals] = useState([]);
    const [allAnnouncementsClosed, setAllAnnouncementsClosed] = useState(false); // Track if all Announcement modals are closed

    useEffect(() => {
        if (todayAnnouncementEvents.length > 0) {
            setOpenAnnouncementModals(Array(todayAnnouncementEvents.length).fill(false));
            setCurrentAnnouncementIndex(0); // Start with the first announcement
            setAllAnnouncementsClosed(false); // Reset when new announcements are loaded
        } else {
            setAllAnnouncementsClosed(true); // If no announcements, set flag to allow memos to show
        }
    }, [todayAnnouncementEvents]);

    useEffect(() => {
        if (todayAnnouncementEvents.length > 0) {
            const newOpenModals = Array(todayAnnouncementEvents.length).fill(false);
            if (currentAnnouncementIndex >= 0 && currentAnnouncementIndex < todayAnnouncementEvents.length) {
                newOpenModals[currentAnnouncementIndex] = true; // Open the current modal
            }
            setOpenAnnouncementModals(newOpenModals);
        }
    }, [currentAnnouncementIndex, todayAnnouncementEvents]);

    const handleCloseAnnouncementModal = () => {
        if (currentAnnouncementIndex < todayAnnouncementEvents.length - 1) {
            // Close current modal and open the next one
            const newOpenModals = [...openAnnouncementModals];
            newOpenModals[currentAnnouncementIndex] = false; // Close the current modal
            newOpenModals[currentAnnouncementIndex + 1] = true; // Open the next modal
            setOpenAnnouncementModals(newOpenModals);
            setCurrentAnnouncementIndex(currentAnnouncementIndex + 1);
        } else {
            // All announcements processed, close the last one
            const newOpenModals = [...openAnnouncementModals];
            newOpenModals[currentAnnouncementIndex] = false;
            setOpenAnnouncementModals(newOpenModals);
            setAllAnnouncementsClosed(true); // All announcements are now closed
        }
    };

    // Memo Modal
    const [currentMemoIndex, setCurrentMemoIndex] = useState(0);
    const [openMemoModals, setOpenMemoModals] = useState([]);

    useEffect(() => {
        if (todayMemoEvents.length > 0) {
            setOpenMemoModals(Array(todayMemoEvents.length).fill(false));
            setCurrentMemoIndex(0); // Start with the first memo
        }
    }, [todayMemoEvents, allAnnouncementsClosed]);

    useEffect(() => {
        if (allAnnouncementsClosed && todayMemoEvents.length > 0) {
            const newOpenModals = Array(todayMemoEvents.length).fill(false);
            if (currentMemoIndex >= 0 && currentMemoIndex < todayMemoEvents.length) {
                newOpenModals[currentMemoIndex] = true; // Open the current modal
            }
            setOpenMemoModals(newOpenModals);
        }
    }, [currentMemoIndex, todayMemoEvents, allAnnouncementsClosed]);

    const handleCloseMemoModal = () => {
        if (currentMemoIndex < todayMemoEvents.length - 1) {
            setCurrentMemoIndex(currentMemoIndex + 1); // Move to the next memo
        } else {
            setCurrentMemoIndex(-1); // Close all modals when done
        }
    };

    useEffect(() => {
        if(events.length > 0){
            const announcement = announcementRef.current;
            const memo = memoRef.current;
            const todayAnnouncement = todayAnnouncementRef.current;
            const todayMemo = todayMemoRef.current;

            const observerOptions = {
                root: null,
                rootMargin: '0px',
                threshold: 0.1
            };
        
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        // console.log('Visible:', entry.target.id);
                        setCurrentView(entry.target.id);
                    }
                });
            }, observerOptions);
        
            if (announcement) observer.observe(announcement);
            if (memo) observer.observe(memo);
            if (todayAnnouncement) observer.observe(todayAnnouncement);
            if (todayMemo) observer.observe(todayMemo);
        
            return () => {
                if (announcement) observer.unobserve(announcement);
                if (memo) observer.unobserve(memo);
                if (todayAnnouncement) observer.unobserve(todayAnnouncement);
                if (todayMemo) observer.unobserve(todayMemo);
            };
        }
    }, [events]);

    useEffect(() => {
        if(events.length > 0){
            if(currentView === "announcement"){
                setCurrentIndex(0);
                if(getGeneralImageSource("Announcement").length > 0){
                    setImageSource(getGeneralImageSource("Announcement"));
                }
            } else if(currentView === "memo"){
                setCurrentIndex(0);
                if(getGeneralImageSource("Memo").length > 0){
                    setImageSource(getGeneralImageSource("Memo"));
                }
            } else if(currentView === "today-announcement"){
                setCurrentIndex(0);
                if(getImageSource("TodayAnnouncement").length > 0){
                    setImageSource(getImageSource("TodayAnnouncement"));
                }
            } else if(currentView === "today-memo"){
                setCurrentIndex(0);
                if(getImageSource("TodayMemo").length > 0){
                    setImageSource(getImageSource("TodayMemo"));
                }
            }
        }
    }, [currentView, getGeneralImageSource, getImageSource, events,]);

    const [currentIndex, setCurrentIndex] = useState(0);

    const handleNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % imageSource.length);
    };

    const handlePrev = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + imageSource.length) % imageSource.length);
    };

    return(
        <>
            <div className="Introduction row">
                <div className="dashboard row" >
                    { events.length > 0 ? (
                        <>
                            <div className="Intro-img">
                                { imageSource.length > 0 && <img className='modal-events-image' src={imageSource[currentIndex]} alt="" onClick={()=>openImage(imageSource[currentIndex])}/>}
                                {imageSource.length > 1 && (
                                    <div className='imageButton'>
                                        <button onClick={handlePrev}>{`<`}</button>
                                        <button onClick={handleNext}>{`>`}</button>
                                    </div>
                                )}
                            </div>
                            <div className="Intro-content">
                                <div className="contentText">
                                    <h2 style={{margin: "10px"}}>{<TypingAnimation wordings={"Welcome Back " + (user.employeePersonalInformationFullName ? user.employeePersonalInformationFullName : user.username)}/>}</h2>
                                    {hasGeneralAnnouncement && <div id="announcement" ref={announcementRef} className='events-message'>
                                        <p><b>Announcement: </b> 
                                        {
                                            <>
                                                <br />
                                                <br />
                                                {announcementContent()}
                                            </>
                                        }
                                        </p>
                                    </div>}
                                    {hasGeneralMemo && <div id="memo" ref={memoRef} className='events-message'>
                                        <p><b>Memo: </b> 
                                        {
                                            <>
                                                <br />
                                                <br />
                                                {memoContent()}
                                            </>
                                        }
                                        </p>
                                    </div>}
                                </div>
                            </div>
                        </>
                        )
                        :
                        (
                            <div style={{display:"flex", alignItems:"center", justifyContent:"center", width:"100%", height:"100%"}}>
                                <img src={loadingSpinner} alt="Loading..." />
                            </div>
                        )
                    }
                </div>
                {/* temporary */}
                <div className="dashboard row" style={{display:"none"}}>
                    <div className="Intro-img">
                        <img  src={IntroImg}  alt=""/>
                    </div>
                    <div className="Intro-content">
                        <div className="contentText">
                            <h2>{<TypingAnimation wordings={"Welcome Back " + (user.employeePersonalInformationFullName ? user.employeePersonalInformationFullName : user.username)}/>}</h2>
                            <p><b>Announcement:</b> In observance of MECQ 
                                all employees are to wear face shields 
                                at all times.
                            </p>
                            <p>May 1, 2021. Labor Day in the Philippines is 
                                a public holiday every 1 May to celebrate 
                                the Filipino worker. It is a chance to 
                                remember hard-won workers' rights.
                            </p>
                        </div>
                    </div>
                </div>
                {userAccess?.hasHome ? 
                    (
                        <div className="statistics row">
                            <div className="totalEmployees">
                                <h3>Total Employees</h3>
                                <h1>{generalInfo.totalEmployees}</h1>
                            </div>
                            <div className="chart column">
                                <div className="barStat">
                                    <ResponsiveContainer width="100%" height="100%">
                                        <BarChart width={150} height={40} data={barData}>
                                        <Tooltip content={<CustomTooltip/>}/>
                                        <Bar dataKey="amount" 
                                            fill={"00a0fc"}
                                            name=""
                                            onMouseOver={() => tooltip = "amount"}
                                        />
                                        </BarChart>
                                    </ResponsiveContainer>
                                </div>
                                <div className="barCategory row">
                                    <div className="cat"><b>Leave Request</b></div>
                                    <div className="cat"><b>OT Request</b></div>
                                    <div className="cat"><b>Loan Request</b></div>
                                </div>
                            </div>
                        </div>
                    )
                    :
                    (
                        <div className="statistics statistics-profile column">
                            <div className='profile-header row'>
                                <AssignmentIndIcon style={{marginRight:"10px"}}/>
                                <span style={{fontSize: "1.2rem", fontWeight: "bold"}}>Your Profile</span>
                            </div>
                            <div className='profile row' style={{height:"100%", overflowY:"auto"}}>
                                {filteredEmployee ?
                                    (
                                        <>
                                            <div className='employee-basic-info'>
                                                <label htmlFor="file-input" className='column' style={{
                                                    color: "#808080b5",
                                                    fontSize: "14px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    height: "100%",
                                                    cursor: "pointer" // Add cursor pointer for better user interaction
                                                }}>
                                                    <img src={selectedFile ? URL.createObjectURL(selectedFile) : "images/sample.jpg"} alt=""></img>
                                                    {selectedFile ? "" : "Upload a picture"}
                                                </label>
                                                <input
                                                    id="file-input"
                                                    type="file"
                                                    style={{ display: "none" }}
                                                    onChange={handleFileChange}
                                                />
                                            </div>
                                            <div className='employee-basic-info' style={{justifyContent:"start"}}>
                                                <div className='profile-info'style={{maxHeight:"100%", overflowY:"auto"}}>
                                                    <p><b style={{color:"#668fca"}}>Name: </b> {filteredEmployee.fullName}</p>
                                                    <p>
                                                        <b style={{color:"#668fca"}}>Department: </b> 
                                                        {filteredEmployee.employeeInformation && filteredEmployee.employeeInformation.departmentDescription 
                                                            ? filteredEmployee.employeeInformation.departmentDescription 
                                                            : null
                                                        }
                                                    </p>
                                                    <p>
                                                        <b style={{color:"#668fca"}}>Position: </b> 
                                                        {filteredEmployee.employeeInformation && filteredEmployee.employeeInformation.positionDescription 
                                                            ? filteredEmployee.employeeInformation.positionDescription 
                                                            : null
                                                        }
                                                    </p>
                                                    <p>
                                                        <b style={{color:"#668fca"}}>Date Employed: </b> 
                                                        {filteredEmployee.employeeInformation && filteredEmployee.employeeInformation.dateEmployed 
                                                            ? formatDate(filteredEmployee.employeeInformation.dateEmployed) 
                                                            : ""
                                                        }
                                                    </p>
                                                </div>
                                            </div>
                                        </>
                                    )
                                    :
                                    (
                                        <div style={{display:"flex", alignItems:"center", justifyContent:"center", width:"100%", height:"100%"}}>
                                            <img src={loadingSpinner} alt="Loading..." />
                                        </div>
                                    )
                                }
                            </div> 
                        </div> 
                    )
                }
            </div>
            {/* Full Image Modal */}
            {isImageModalOpen && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0, 0, 0, 0.8)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 9999
                    }}
                    onClick={closeImageModal} // Click outside to close
                >
                    <img
                        src={imageSrcModalOpen}
                        alt="Full view"
                        style={{ maxWidth: "90%", maxHeight: "90%" }}
                    />
                </div>
            )}
            {allAnnouncementsClosed && todayMemoEvents.map((event, index) => (
                <MemoModal
                    key={index}
                    isOpen={openMemoModals[index]}
                    onClose={handleCloseMemoModal}
                    content={event.description}
                    image={event.content}
                />
            ))}
            {todayAnnouncementEvents.map((event, index) => (
                <AnnouncementModal
                    key={index}
                    isOpen={openAnnouncementModals[index]}
                    onClose={handleCloseAnnouncementModal}
                    content={event.description}
                    image={event.content}
                />
            ))}
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loadingRequest ? (
            <div style={{ position:"fixed", top:"50%", left:"50%", transform:"translate(-50%, -50%)", zIndex:"3005"}}>
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            ) : (
                <></>
                )
            }
        </>
    )
}
function ShowEmployeeInformation({currentPage, setCurrentPage, employees, handleFilter, setFilterDataIndex, searchPlaceholder, addHandleClick, viewEmployeeHandleClick, loading, userAccessData,
    employeeStatus, setEmployeeStatus
}){
    return(
        <div className="EmployeeInfo">
            <div className="EmployeeList">
                <div className="Header">
                    <div className="titleContainer row">
                        <PeopleAltIcon style={{padding:"0 10px 0 0"}}/>
                        <h3>List Of Employee</h3>
                    </div>
                </div>
                <div className="employeeTabs">
                    <EmployeeTabs employees={employees} 
                                handleFilter={handleFilter} 
                                setFilterDataIndex={setFilterDataIndex} 
                                searchPlaceholder={searchPlaceholder} 
                                addHandleClick={addHandleClick} 
                                viewEmployeeHandleClick={viewEmployeeHandleClick} 
                                loading={loading} 
                                userAccessData={userAccessData} 
                                currentPage={currentPage} 
                                setCurrentPage={setCurrentPage} 
                                employeeStatus={employeeStatus} setEmployeeStatus={setEmployeeStatus}
                    />
                </div>
            </div>
            
        </div>
    )
}
const EmployeeTabs = ({currentPage, setCurrentPage, employees, handleFilter, setFilterDataIndex, searchPlaceholder, addHandleClick, viewEmployeeHandleClick, loading, userAccessData,
    employeeStatus, setEmployeeStatus
}) => {
    var header = [
        // "Photo",
        "ID",
        "Full Name",
        "Department",
        "Position",
        "Section",
        "Location",
        ""
    ]
    var accessor = [
        // "avatar",
        "employeeId",
        "fullName",
        "employeeInformation.departmentDescription",
        "employeeInformation.positionDescription",
        "employeeInformation.sectionDescription",
        "employeeInformation.locationDescription",
        "manage"
    ]

    const [locationFilter, setLocationFilter] = useState("0");
    const [classificationFilter, setClassificationFilter] = useState("0");
    const [employeesInfo, setEmployeesInfo] = useState(employees);
    const [currentClassificationFilter, setCurrentClassificationFilter] = useState("");

    useEffect(()=>{
        let classificiationFilter = classificationFilter;

        setCurrentClassificationFilter(classificiationFilter);

        const classified = employees.filter(employee => {
            return  employee.employeeInformation && 
                    employee.employeeInformation.classificationId &&
                    employee.employeeInformation.classificationId.toString() === classificiationFilter.toString();
        });

        let filteredBySection = classified;

        let finalData = [];

        if (classificiationFilter.toString() === "0") {
            finalData = [...employees]; // Always copy array before sorting
        } else {
            finalData = [...filteredBySection]; // Always copy array before sorting
        }

        let lastData = finalData;

        if(locationFilter !== "0"){
            lastData = finalData.filter(i => i.employeeInformation?.locationId?.toString() === locationFilter?.toString());
        }

        if(classificiationFilter !== currentClassificationFilter){
            setLocationFilter("0");
        }
        
        setEmployeesInfo(lastData);
    }, [employees, userAccessData, currentClassificationFilter, classificationFilter, locationFilter]);

    return (
        <div>
            <div style={{padding: "0 10px"}}>
                <div className='filters-payroll'>
                    <span>Filter</span>
                    <div className="payroll-item-holder info-item-holder row" style={{padding: "0 10px 20px 10px", justifyContent: "normal"}}>
                        <div className="filter-item-payroll popUp-item info-item column">
                            <div className="info-item-label">Employee Status</div>
                            <div className="info-item-input">
                                <EmployeeStatus employeeStatus={employeeStatus} setEmployeeStatus={setEmployeeStatus} isEditMode={true}/>
                            </div>
                        </div>
                        <div className="filter-item-payroll popUp-item info-item column">
                            <div className="info-item-label">Classification Type</div>
                            <div className="info-item-input">
                                <ClassificationFilter1 classificationId={classificationFilter} setClassificationId={setClassificationFilter}/>
                            </div>
                        </div>
                        <div className="filter-item-payroll popUp-item info-item column">
                            <div className="info-item-label">Location</div>
                            <div className="info-item-input">
                                <LocationIdSelect locationId={locationFilter} setLocationId={setLocationFilter}/>
                            </div>
                        </div>
                    </div>
                    <div className="payroll-item-holder info-item-holder row" style={{padding: "0 10px 20px 10px", justifyContent: "normal"}}>
                        <div className="filter-item-payroll popUp-item info-item column">
                            <div className="info-item-label">Filter</div>
                            <div className="info-item-input">
                                {Filter(setFilterDataIndex)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="top-table row">
                <div className="left" style={{width:"50%"}}>
                    {CreateSearchBarWithPlaceHolder("", 
                                                    "mainte-search row", 
                                                    "mainte-search-icon", 
                                                    "mainte-search-input", 
                                                    (e) => handleFilter(e.target.value), 
                                                    "Search by " + searchPlaceholder, 
                                                    SearchIcon)}
                </div>
                <div className="right row" style={{width:"50%"}}>
                    {CreateButton("home-add-employee", "add row",()=>addHandleClick(), "ADD EMPLOYEE", PeopleAltIcon)}
                </div>
            </div>
                <div id="container1" className="InfoList container">
                    <CreateTable
                        dataList={employeesInfo}
                        dataHeader={header}
                        dataAccessor={accessor}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        editHandleClick={viewEmployeeHandleClick}
                    />
                    {employeesInfo.length > 0 ? (
                        <div></div>
                    )
                    :
                    (
                        <div>
                        {loading ? (
                            <div
                                style={{
                                position: "fixed",
                                top: "0",
                                left: "0",
                                width: "100vw",
                                height: "100vh",
                                zIndex: "2000",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                textAlign: "center",
                                backgroundColor: "#ffffff59",
                                }}
                            >
                                <img src={loadingSpinner} alt="Loading..." />
                            </div>
                        ) : (
                                <div> {/*<p>No records to display</p>*/}</div>
                            )
                        }
                        </div>
                    )}
                </div>
        </div>
    );
};
function ShowLatestTransactionRequests({user, filteredEmployee}){
    return(
        <div className="EmployeeInfo">
            <div className="EmployeeList">
                <div className="Header">
                    <div className="titleContainer row">
                        <StickyNote2Icon style={{padding:"0 10px 0 0"}}/>
                        <h3>My Latest Transaction Requests</h3>
                    </div>
                </div>
                <div className="employeeTabs">
                    <Transactions user={user} filteredEmployee={filteredEmployee}/>
                </div>
            </div>
            
        </div>
    )
}
const Transactions = ({user, filteredEmployee}) => {
    var header = [
        "Reference No.",
        // "Uploaded Image",
        "Request Date",
        "Request",
        // "Type",
        "Track Approvers",
        "Status",
        ""
    ]
    var accessor = [
        "id",
        // "content",
        "requestDate",
        "requestTypeDescription",
        // "type",
        "trackApprovers",
        "status",
        "manage"
    ]

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [loadingRequest, setLoadingRequest] = useState(false);
    const [filterData, setFilterData] = useState([]);
    const [transactions, setTransactions] = useState([]);

    const [overtimeRequestData, setOvertimeRequestData] = useState([]);
    const [leaveRequestData, setLeaveRequestData] = useState([]);
    const [changeOfScheduleData, setChangeOfScheduleData] = useState([]);
    const [changeLogRequestData, setChangeLogRequestData] = useState([]);
    const [requestType, setRequestType] = useState("");

    const [viewImageData, setViewImageData] = useState("");
    const [showViewImage, setShowViewImage] = useState(false);

            //OT
    const [showViewOTForm, setShowViewOTForm] = useState(false);
    const [employeePersonalInformationFullName, setEmployeePersonalInformationFullName] = useState("");
    const [employeePersonalInformationId, setEmployeePersonalInformationId] = useState("");
    const [overtimeType, setOvertimeType] = useState("");
    const [date, setDate] = useState("");
    const [hours, setHours] = useState("");
    const [hasOvertimeAllowance, setHasOvertimeAllowance] = useState(false);
    const [isAboveTwoHoursOvertime, setIsAboveTwoHoursOvertime] = useState(false);
    const [reason, setReason] = useState("");
    const [filesOT, setFilesOT] = useState("");
            //Leave
    const [showViewLeaveForm, setShowViewLeaveForm] = useState(false);
    const [employeePersonalInformationFullNameLeave, setEmployeePersonalInformationFullNameLeave] = useState("");
    const [leaveType, setLeaveType] = useState("");
    const [dateFromLeave, setDateFromLeave] = useState("");
    const [dateToLeave, setDateToLeave] = useState("");
    const [daysLeave, setDaysLeave] = useState("");
    const [isHalfDayLeave, setIsHalfDayLeave] = useState(false);
    const [withoutPayLeave, setWithoutPayLeave] = useState(false);
    const [reasonLeave, setReasonLeave] = useState("");
    const [filesLeave, setFilesLeave] = useState("");
            //Change Request
    const [showViewChangeScheduleForm, setShowViewChangeScheduleForm] = useState(false);
    const [employeePersonalInformationFullNameChangeSchedule, setEmployeePersonalInformationFullNameChangeSchedule] = useState("");
    const [dateFromChangeSchedule, setDateFromChangeSchedule] = useState("");
    const [dateToChangeSchedule, setDateToChangeSchedule] = useState("");
    const [shiftScheduleFromId, setShiftScheduleFromId] = useState("");
    const [shiftScheduleToId, setShiftScheduleToId] = useState("");
    const [reasonChangeSchedule, setReasonChangeSchedule] = useState("");
    const [filesChangeSchedule, setFilesChangeSchedule] = useState("");
        //DTR CORRECTION
    const [showViewChangeLogRequestForm, setShowViewChangeLogRequestForm] = useState(false);
    const [employeePersonalInformationIdChangeLogRequest, setEmployeePersonalInformationIdChangeLogRequest] = useState("");
    const [employeePersonalInformationFullNameChangeLogRequest, setEmployeePersonalInformationFullNameChangeLogRequest] = useState("");
    const [timeTypeChangeLogRequest, setTimeTypeChangeLogRequest] = useState("");
    const [dateChangeLogRequest, setDateChangeLogRequest] = useState("");
    const [timeRequestedChangeLogRequest, setTimeRequestedChangeLogRequest] = useState("");
    const [statusChangeLogRequest, setStatusChangeLogRequest] = useState("");
    const [reasonChangeLogRequest, setReasonChangeLogRequest] = useState("");
    const [reasonForRejectionChangeLogRequest, setReasonForRejectionChangeLogRequest] = useState("");
    const [filesChangeLog, setFilesChangeLog] = useState("");
    const [selectedItinerary, setSelectedItinerary] = useState([]);
    const [itineraryTimeIn, setItineraryTimeIn] = useState("");
    const [itineraryTimeOut, setItineraryTimeOut] = useState("");
    const [itineraryLocation, setItineraryLocation] = useState("");
    const [isItinerayAddState, setIsItinerayAddState] = useState(false);
    const [isItinerayUpdateState, setIsItinerayUpdateState] = useState(false);
    const [isItinerayDeleteState, setIsItinerayDeleteState] = useState(false);

    const [content, setContent] = useState(null);
    const [gpsCam, setGPSCam] = useState(null);
    const [medicalCertificate, setMedicalCertificate] = useState(null);

    const [deleteData, setDeleteData] = useState([]);
    const [showDeleteForm, setShowDeleteForm] = useState(false);

    const [editData, setEditData] = useState([]);
    const [showEditOTForm, setShowEditOTForm] = useState(false);
    const [showEditLeaveForm, setShowEditLeaveForm] = useState(false);
    const [showEditChangeOfScheduleForm, setShowEditChangeOfScheduleForm] = useState(false);
    const [showEditChangeLogForm, setShowEditChangeLogForm] = useState(false);
    const [showEditOffsetForm, setShowEditOffsetForm] = useState(false);
    const [showEditOBForm, setShowEditOBForm] = useState(false);
    
    //Offset
    const [showViewOffsetRequestForm, setShowViewOffsetRequestForm] =useState(false);
    const [employeePersonalInformationIdOffsetRequest, setEmployeePersonalInformationIdOffsetRequest] = useState("");
    const [employeePersonalInformationFullNameOffsetRequest, setEmployeePersonalInformationFullNameOffsetRequest,] = useState("");

    const [typeOffset, setTypeOffset] = useState("");
    const [referencesOffset, setReferencesOffset] = useState([]);
    const [dateOffset, setDateOffset] = useState("");
    const [hoursOffset, setHoursOffset] = useState("");
    const [dateFromOffset, setDateFromOffset] = useState("");
    const [dateToOffset, setDateToOffset] = useState("");
    const [daysOffset, setDaysOffset] = useState("");

    const [reasonOffsetRequest, setReasonOffsetRequest] = useState("");
    const [filesOffset, setFilesOffset] = useState("");

    //OB
    const [showViewOBForm, setShowViewOBForm] =useState(false);
    const [employeePersonalInformationIdOB, setEmployeePersonalInformationIdOB] = useState("");
    const [employeePersonalInformationFullNameOB, setEmployeePersonalInformationFullNameOB,] = useState("");
    const [reasonOB, setReasonOB] = useState("");
    const [locationOB, setLocationOB] = useState("");
    const [dateFromOB, setDateFromOB] = useState(null);
    const [dateToOB, setDateToOB] = useState(null);
    const [timeFromOB, setTimeFromOB] = useState(null);
    const [timeToOB, setTimeToOB] = useState(null);

    // const [typeOffset, setTypeOffset] = useState("");
    // const [referencesOffset, setReferencesOffset] = useState([]);
    // const [dateOffset, setDateOffset] = useState("");
    // const [hoursOffset, setHoursOffset] = useState("");
    // const [dateFromOffset, setDateFromOffset] = useState("");
    // const [dateToOffset, setDateToOffset] = useState("");
    // const [daysOffset, setDaysOffset] = useState("");

    const apiUrl =  domain + "/api/TransactionRequest";
    const overTimeApiUrl =  domain + "/api/OvertimeRequest";
    const leaveTimeApiUrl =  domain + "/api/LeaveRequest";
    const changeOfScheduleTimeApiUrl =  domain + "/api/ChangeScheduleRequest";
    const changeLogRequestTimeApiUrl =  domain + "/api/ChangeLogRequest";
    const offsetRequestTimeApiUrl = domain + "/api/OffsetRequest";
    const officialBusinessRequestTimeApiUrl = domain + "/api/OfficialBusinessRequest";

    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const [approverData, setApproverData] = useState(null);
    const fetchDataApproverData = useCallback(async () => {
        const apiUrl =  domain + "/api/ApproverHierarchy";

        try {
            const response = await axios.get(`${apiUrl}/${user.employeePersonalInformationId}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
            return response.data // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
            return null;
        }
    }, [user]);

    const generatePrimaryApprover = () => {
        return (
            <>
                { approverData?.primaryApprover?.primaryApprover1Id &&
                    <span style={{margin: "0 10px"}}>
                        {approverData?.primaryApprover?.primaryApprover1FullName}
                    </span>
                }
                { approverData?.primaryApprover?.primaryApprover2Id &&
                    <span style={{margin: "0 10px"}}>
                        {approverData?.primaryApprover?.primaryApprover2FullName}
                    </span>
                }
                { approverData?.primaryApprover?.primaryApprover3Id &&
                    <span style={{margin: "0 10px"}}>
                        {approverData?.primaryApprover?.primaryApprover3FullName}
                    </span>
                }
                { approverData?.primaryApprover?.primaryApprover4Id &&
                    <span style={{margin: "0 10px"}}>
                        {approverData?.primaryApprover?.primaryApprover4FullName}
                    </span>
                }
            </>
        )
    }
    const generateSecondaryApprover = () => {
        return (
            <>
                { approverData?.secondaryApprover?.secondaryApprover1Id &&
                    <span style={{margin: "0 10px"}}>
                        {approverData?.secondaryApprover?.secondaryApprover1FullName}
                    </span>
                }
                { approverData?.secondaryApprover?.secondaryApprover2Id &&
                    <span style={{margin: "0 10px"}}>
                        {approverData?.secondaryApprover?.secondaryApprover2FullName}
                    </span>
                }
                { approverData?.secondaryApprover?.secondaryApprover3Id &&
                    <span style={{margin: "0 10px"}}>
                        {approverData?.secondaryApprover?.secondaryApprover3FullName}
                    </span>
                }
                { approverData?.secondaryApprover?.secondaryApprover4Id &&
                    <span style={{margin: "0 10px"}}>
                        {approverData?.secondaryApprover?.secondaryApprover4FullName}
                    </span>
                }
            </>
        )
    }
    const generateTertiaryApprover = () => {
        return (
            <>
                { approverData?.tertiaryApprover?.tertiaryApprover1Id &&
                    <span style={{margin: "0 10px"}}>
                        {approverData?.tertiaryApprover?.tertiaryApprover1FullName}
                    </span>
                }
                { approverData?.tertiaryApprover?.tertiaryApprover2Id &&
                    <span style={{margin: "0 10px"}}>
                        {approverData?.tertiaryApprover?.tertiaryApprover2FullName}
                    </span>
                }
                { approverData?.tertiaryApprover?.tertiaryApprover3Id &&
                    <span style={{margin: "0 10px"}}>
                        {approverData?.tertiaryApprover?.tertiaryApprover3FullName}
                    </span>
                }
                { approverData?.tertiaryApprover?.tertiaryApprover4Id &&
                    <span style={{margin: "0 10px"}}>
                        {approverData?.tertiaryApprover?.tertiaryApprover4FullName}
                    </span>
                }
            </>
        )
    }

    const fetchDataApproverById = useCallback(async (data) => {
        const apiUrlApproverHierarchy =  domain + "/api/ApproverHierarchy";

        try {
            const response = await axios.get(apiUrlApproverHierarchy + `/${data.employeePersonalInformationId}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
                }
            });
            
            return response.data; // Return the response data
        } catch (error) {
            console.error('Error fetching data:', error);
            return []; // Return an empty array in case of error
        }
    }, []);

    const fetchData = useCallback(async () => {
        setLoading(true);
        if(!filteredEmployee) { return; }

        try {
            const response = await axios.get(apiUrl + `/my-requests/30/${user.employeePersonalInformationId}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
            }})

            const approverData = await fetchDataApproverById(user);
            const requests = response.data;

            let hasPrimary = false;
            let hasSecondary = false;
            let hasTertiary = false;

            if(approverData.primaryApprover){
                if(approverData.primaryApprover.primaryApprover1Id 
                    || approverData.primaryApprover.primaryApprover2Id
                    || approverData.primaryApprover.primaryApprover3Id
                    || approverData.primaryApprover.primaryApprover4Id
                ){
                    hasPrimary = true;
                }
            }

            if(approverData.secondaryApprover){
                if(approverData.secondaryApprover.secondaryApprover1Id 
                    || approverData.secondaryApprover.secondaryApprover2Id
                    || approverData.secondaryApprover.secondaryApprover3Id
                    || approverData.secondaryApprover.secondaryApprover4Id
                ){
                    hasSecondary = true;
                }
            }

            if(approverData.tertiaryApprover){
                if(approverData.tertiaryApprover.tertiaryApprover1Id 
                    || approverData.tertiaryApprover.tertiaryApprover2Id
                    || approverData.tertiaryApprover.tertiaryApprover3Id
                    || approverData.tertiaryApprover.tertiaryApprover4Id
                ){
                    hasTertiary = true;
                }
            }

            for (let index = 0; index < requests.length; index++) {
                if(requests[index].approval){
                    if (!hasPrimary) {
                        delete requests[index].approval.primaryApproverId;
                        delete requests[index].approval.primaryApproverFullName;
                        delete requests[index].approval.primaryApproverUpdateDate;
                        delete requests[index].approval.primaryApproverStatus;
                    }
                
                    if (!hasSecondary) {
                        delete requests[index].approval.secondaryApproverId;
                        delete requests[index].approval.secondaryApproverFullName;
                        delete requests[index].approval.secondaryApproverUpdateDate;
                        delete requests[index].approval.secondaryApproverStatus;
                    }
                
                    if (!hasTertiary) {
                        delete requests[index].approval.tertiaryApproverId;
                        delete requests[index].approval.tertiaryApproverFullName;
                        delete requests[index].approval.tertiaryApproverUpdateDate;
                        delete requests[index].approval.tertiaryApproverStatus;
                    }
                } else {
                    requests[index].approval = {
                        primaryApproverId: 0,
                        primaryApproverFullName: "",
                        primaryApproverUpdateDate: "",
                        primaryApproverStatus: "",
                        secondaryApproverId: 0,
                        secondaryApproverFullName: "",
                        secondaryApproverUpdateDate: "",
                        secondaryApproverStatus: "",
                        tertiaryApproverId: 0,
                        tertiaryApproverFullName: "",
                        tertiaryApproverUpdateDate: "",
                        tertiaryApproverStatus: ""
                    }

                    if (!hasPrimary) {
                        delete requests[index].approval.primaryApproverId;
                        delete requests[index].approval.primaryApproverFullName;
                        delete requests[index].approval.primaryApproverUpdateDate;
                        delete requests[index].approval.primaryApproverStatus;
                    }
                
                    if (!hasSecondary) {
                        delete requests[index].approval.secondaryApproverId;
                        delete requests[index].approval.secondaryApproverFullName;
                        delete requests[index].approval.secondaryApproverUpdateDate;
                        delete requests[index].approval.secondaryApproverStatus;
                    }
                
                    if (!hasTertiary) {
                        delete requests[index].approval.tertiaryApproverId;
                        delete requests[index].approval.tertiaryApproverFullName;
                        delete requests[index].approval.tertiaryApproverUpdateDate;
                        delete requests[index].approval.tertiaryApproverStatus;
                    }
                }
            }

            const _approverData = await fetchDataApproverData()
            setApproverData(_approverData);

            setTransactions(requests); // Set the response data to the state
            setFilterData(requests); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }, [apiUrl, filteredEmployee, user, fetchDataApproverById, fetchDataApproverData]);
    /* const fetchOTRequestData = useCallback(async () => {
        await axios.get(overTimeApiUrl, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setOvertimeRequestData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }, [overTimeApiUrl]);
    const fetchLeaveRequestData = useCallback(async () => {
        await axios.get(leaveTimeApiUrl, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setLeaveRequestData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }, [leaveTimeApiUrl]);
    const fetchChangeOfScheduleRequestData = useCallback(async () => {
        await axios.get(changeOfScheduleTimeApiUrl, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setChangeOfScheduleData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }, [changeOfScheduleTimeApiUrl]);
    const fetchChangeLogRequestData = useCallback(async () => {
        await axios.get(changeLogRequestTimeApiUrl, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setChangeLogRequestData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }, [changeLogRequestTimeApiUrl]); */

    const fetchOTRequestData = useCallback(async () => {
    }, []);
    const fetchLeaveRequestData = useCallback(async () => {
    }, []);
    const fetchChangeOfScheduleRequestData = useCallback(async () => {
    }, []);
    const fetchChangeLogRequestData = useCallback(async () => {
    }, []);

    useEffect(() => {
        fetchData();
        fetchOTRequestData();
        fetchLeaveRequestData();
        fetchChangeOfScheduleRequestData();
        fetchChangeLogRequestData();
        
    }, [fetchData,
        fetchOTRequestData,
        fetchLeaveRequestData,
        fetchChangeOfScheduleRequestData,
        fetchChangeLogRequestData
    ]);

    const handleFilter = (value) => {
        setCurrentPage(1);
        const res = filterData.filter((f) =>
            f.id.toString().startsWith(value)
        );

        setTransactions(res);
    };

    const fetchOTRequest = useCallback(async (data) => {
        setLoadingRequest(true);
        try {
            const response = await axios.get(overTimeApiUrl + `/${data.id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
            }})
                return response.data; // Set the response data to the state
        } catch (error) {
            setLoadingRequest(false);
            console.error('Error fetching data:', error);
            return [];
        } finally {
            setLoadingRequest(false);
        }
    }, [overTimeApiUrl]);
    const fetchLeaveRequest = useCallback(async (data) => {
        setLoadingRequest(true);
        try {
            const response = await axios.get(leaveTimeApiUrl + `/${data.id}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
            return response.data; // Set the response data to the state
        } catch (error) {
            setLoadingRequest(false);
            console.error('Error fetching data:', error);
            return [];
        } finally {
            setLoadingRequest(false);
        }
    }, [leaveTimeApiUrl]);
    const fetchChangeOfScheduleRequest = useCallback(async (data) => {
        setLoadingRequest(true);
        try {
            const response = await axios.get(changeOfScheduleTimeApiUrl + `/${data.id}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
            return response.data; // Set the response data to the state
        } catch (error) {
            setLoadingRequest(false);
            console.error('Error fetching data:', error);
            return [];
        } finally {
            setLoadingRequest(false);
        }
    }, [changeOfScheduleTimeApiUrl]);
    const fetchChangeLogRequest = useCallback(async (data) => {
        setLoadingRequest(true);
        try {
            const response = await axios.get(changeLogRequestTimeApiUrl + `/${data.id}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
            return response.data; // Set the response data to the state
        } catch (error) {
            setLoadingRequest(false);
            console.error('Error fetching data:', error);
            return [];
        } finally {
            setLoadingRequest(false);
        }
    }, [changeLogRequestTimeApiUrl]);
    const fetchOffsetRequest = useCallback(
        async (data) => {
        setLoadingRequest(true);
        try {
            const response = await axios.get(
            offsetRequestTimeApiUrl + `/${data.id}`,
            {
                headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json", // You can include other headers if needed
                },
            }
            );
            return response.data; // Set the response data to the state
        } catch (error) {
            setLoadingRequest(false);
            console.error("Error fetching data:", error);
            return [];
        } finally {
            setLoadingRequest(false);
        }
        },
        [offsetRequestTimeApiUrl]
    );
    const fetchOBRequest = useCallback(
        async (data) => {
        setLoadingRequest(true);
        try {
            const response = await axios.get(
            officialBusinessRequestTimeApiUrl + `/${data.id}`,
            {
                headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json", // You can include other headers if needed
                },
            }
            );
            return response.data; // Set the response data to the state
        } catch (error) {
            setLoadingRequest(false);
            console.error("Error fetching data:", error);
            return [];
        } finally {
            setLoadingRequest(false);
        }
        },
        [officialBusinessRequestTimeApiUrl]
    );

    const viewHandleClick = async (data) => {
        setRequestType(data.requestTypeDescription);

        if(data.requestTypeDescription === "Overtime Request"){
            setShowViewOTForm(true);
            const requestDataWithId = await fetchOTRequest(data);
            setEmployeePersonalInformationFullName(requestDataWithId.employeePersonalInformationFullName);
            setEmployeePersonalInformationId(requestDataWithId.employeePersonalInformationId);
            setOvertimeType(requestDataWithId.overtimeType);
            setDate(requestDataWithId.date);
            setHours(requestDataWithId.hours);
            setHasOvertimeAllowance(requestDataWithId.hasOvertimeAllowance);
            setIsAboveTwoHoursOvertime(requestDataWithId.isAboveTwoHoursOvertime);
            setReason(requestDataWithId.reason);
            let filesToBeSet = [];

            if(requestDataWithId.content){
                const binaryData = atob(requestDataWithId.content);
        
                // Convert the binary data to a Uint8Array
                const arrayBuffer = new ArrayBuffer(binaryData.length);
                const uint8Array = new Uint8Array(arrayBuffer);
                for (let i = 0; i < binaryData.length; i++) {
                    uint8Array[i] = binaryData.charCodeAt(i);
                }
        
                const blob = new Blob([uint8Array], { type: 'image/jpeg' }); // Adjust the MIME type as per your data
        
                const file = new File([blob], 'filename.jpg', { type: 'image/jpeg' }); // Provide a filename and MIME type
        
                filesToBeSet.push(file);
            }
            
            setFilesOT(filesToBeSet);
            setContent(requestDataWithId?.content ?? null);
            setGPSCam(requestDataWithId?.gpsCam ?? null);
        }

        if(data.requestTypeDescription === "Leave Request"){
            setShowViewLeaveForm(true);
            const requestDataWithId = await fetchLeaveRequest(data);
            setEmployeePersonalInformationFullNameLeave(requestDataWithId.employeePersonalInformationFullName);
            setLeaveType(requestDataWithId.leaveTypeId);
            setDateFromLeave(requestDataWithId.dateFrom);
            setDateToLeave(requestDataWithId.dateTo);
            setDaysLeave(requestDataWithId.days);
            setIsHalfDayLeave(requestDataWithId.isHalfDay);
            setWithoutPayLeave(requestDataWithId.withoutPay);
            setReasonLeave(requestDataWithId.reason);

            let filesToBeSet = [];

            if(requestDataWithId.content){
                const binaryData = atob(requestDataWithId.content);
        
                // Convert the binary data to a Uint8Array
                const arrayBuffer = new ArrayBuffer(binaryData.length);
                const uint8Array = new Uint8Array(arrayBuffer);
                for (let i = 0; i < binaryData.length; i++) {
                    uint8Array[i] = binaryData.charCodeAt(i);
                }
        
                const blob = new Blob([uint8Array], { type: 'image/jpeg' }); // Adjust the MIME type as per your data
        
                const file = new File([blob], 'filename.jpg', { type: 'image/jpeg' }); // Provide a filename and MIME type
        
                filesToBeSet.push(file);
            }
            
            setFilesLeave(filesToBeSet);
            setContent(requestDataWithId?.content ?? null);
            setMedicalCertificate(requestDataWithId?.medicalCertificate ?? null);
        }
        
        if(data.requestTypeDescription === "Change Schedule"){
            setShowViewChangeScheduleForm(true);
            const requestDataWithId = await fetchChangeOfScheduleRequest(data);
            setEmployeePersonalInformationFullNameChangeSchedule(requestDataWithId.employeePersonalInformationFullName);
            setDateFromChangeSchedule(requestDataWithId.dateFrom);
            setDateToChangeSchedule(requestDataWithId.dateTo);
            setShiftScheduleFromId(requestDataWithId.shiftScheduleFromId);
            setShiftScheduleToId(requestDataWithId.shiftScheduleToId);
            setReasonChangeSchedule(requestDataWithId.reason);

            let filesToBeSet = [];

            if(requestDataWithId.content){
                const binaryData = atob(requestDataWithId.content);
        
                // Convert the binary data to a Uint8Array
                const arrayBuffer = new ArrayBuffer(binaryData.length);
                const uint8Array = new Uint8Array(arrayBuffer);
                for (let i = 0; i < binaryData.length; i++) {
                    uint8Array[i] = binaryData.charCodeAt(i);
                }
        
                const blob = new Blob([uint8Array], { type: 'image/jpeg' }); // Adjust the MIME type as per your data
        
                const file = new File([blob], 'filename.jpg', { type: 'image/jpeg' }); // Provide a filename and MIME type
        
                filesToBeSet.push(file);
            }
            
            setFilesChangeSchedule(filesToBeSet);
            setContent(requestDataWithId?.content ?? null);
            setGPSCam(requestDataWithId?.gpsCam ?? null);
        }

        if(data.requestTypeDescription === "Change Log Request"){
            setShowViewChangeLogRequestForm(true);
            const requestDataWithId = await fetchChangeLogRequest(data);
            setEmployeePersonalInformationIdChangeLogRequest(requestDataWithId.employeePersonalInformationId);
            setEmployeePersonalInformationFullNameChangeLogRequest(requestDataWithId.employeePersonalInformationFullName);
            setTimeTypeChangeLogRequest(requestDataWithId.timeType);
            setDateChangeLogRequest(requestDataWithId.date);
            setTimeRequestedChangeLogRequest(requestDataWithId.timeRendered);
            setReasonChangeLogRequest(requestDataWithId.reason);
            setReasonForRejectionChangeLogRequest(requestDataWithId.reasonForRejection);
            setSelectedItinerary(requestDataWithId.changeLogItineraries);

            let filesToBeSet = [];

            if(requestDataWithId.content){
                const binaryData = atob(requestDataWithId.content);
        
                // Convert the binary data to a Uint8Array
                const arrayBuffer = new ArrayBuffer(binaryData.length);
                const uint8Array = new Uint8Array(arrayBuffer);
                for (let i = 0; i < binaryData.length; i++) {
                    uint8Array[i] = binaryData.charCodeAt(i);
                }
        
                const blob = new Blob([uint8Array], { type: 'image/jpeg' }); // Adjust the MIME type as per your data
        
                const file = new File([blob], 'filename.jpg', { type: 'image/jpeg' }); // Provide a filename and MIME type
        
                filesToBeSet.push(file);
            }
            
            setFilesChangeLog(filesToBeSet);
            setContent(requestDataWithId?.content ?? null);
            setGPSCam(requestDataWithId?.gpsCam ?? null);
        }

        if (data.requestTypeDescription === "Offset") {
            const requestDataWithId = await fetchOffsetRequest(data);
            setShowViewOffsetRequestForm(true);
            // setReferenceNumberOffset(requestDataWithId.referenceNumber);
            // setApproverIdOffset(requestDataWithId.approverId);
            // setApproverNameOffset(requestDataWithId.approverFullName);
            // setStatusOffsetRequest(requestDataWithId.status);
            setEmployeePersonalInformationFullNameOffsetRequest(
                requestDataWithId.employeePersonalInformationFullName
            );
            setEmployeePersonalInformationIdOffsetRequest(
                requestDataWithId.employeePersonalInformationId
            );
            setTypeOffset(requestDataWithId.type);
            setReferencesOffset(requestDataWithId.references);
            setDateOffset(requestDataWithId.date);
            setHoursOffset(requestDataWithId.hours);
            setDateFromOffset(requestDataWithId.dateFrom);
            setDateToOffset(requestDataWithId.dateTo);
            setDaysOffset(requestDataWithId.days);
            setReason(requestDataWithId.reason);
            // setReasonForRejection(requestDataWithId.reasonForRejection);

            let filesToBeSet = [];

            if (requestDataWithId.content) {
                const binaryData = atob(requestDataWithId.content);

                // Convert the binary data to a Uint8Array
                const arrayBuffer = new ArrayBuffer(binaryData.length);
                const uint8Array = new Uint8Array(arrayBuffer);
                for (let i = 0; i < binaryData.length; i++) {
                uint8Array[i] = binaryData.charCodeAt(i);
                }

                const blob = new Blob([uint8Array], { type: "image/jpeg" }); // Adjust the MIME type as per your data

                const file = new File([blob], "filename.jpg", { type: "image/jpeg" }); // Provide a filename and MIME type

                filesToBeSet.push(file);
            }

            setFilesOffset(filesToBeSet);
            setContent(requestDataWithId?.content ?? null);
            setGPSCam(requestDataWithId?.gpsCam ?? null);
        }

        if (data.requestTypeDescription === "Official Business") {
            const requestDataWithId = await fetchOBRequest(data);
            setShowViewOBForm(true);
            // setReferenceNumberOffset(requestDataWithId.referenceNumber);
            // setApproverIdOffset(requestDataWithId.approverId);
            // setApproverNameOffset(requestDataWithId.approverFullName);
            // setStatusOffsetRequest(requestDataWithId.status);
            setEmployeePersonalInformationFullNameOB(
                requestDataWithId.employeePersonalInformationFullName
            );
            setEmployeePersonalInformationIdOB(
                requestDataWithId.employeePersonalInformationId
            );
            setDateFromOB(requestDataWithId.dateFrom);
            setDateToOB(requestDataWithId.dateTo);
            setTimeFromOB(requestDataWithId.timeFrom);
            setTimeToOB(requestDataWithId.timeTo);
            setLocationOB(requestDataWithId.location);
            setReasonOB(requestDataWithId.reason);

            setContent(requestDataWithId?.content ?? null);
            setGPSCam(requestDataWithId?.gpsCam ?? null);
        }
    };
    const closeViewHandleClick = () => {
        if(requestType === "Overtime Request"){
            setShowViewOTForm(false);
        }

        if(requestType === "Leave Request"){
            setShowViewLeaveForm(false);
        }
        
        if(requestType === "Change Schedule"){
            setShowViewChangeScheduleForm(false);
        }

        if(requestType === "Change Log Request"){
            setShowViewChangeLogRequestForm(false);
        }

        if(requestType === "Offset"){
            setShowViewOffsetRequestForm(false);
        }

        if(requestType === "Official Business"){
            setShowViewOBForm(false);
        }

        setContent(null)
        setGPSCam(null)
        setMedicalCertificate(null)
    };

    const [approveMessage, setApproveMessage] = useState(false);
    const [disapproveMessage, setDisapproveMessage] = useState(false);
    const [cancelledMessage, setCancelledMessage] = useState(false);

    function isValidDate(dateString) {
        // Attempt to create a new Date object
        const date = new Date(dateString);
    
        // Check if the resulting date is valid
        return !isNaN(date.getTime());
    }

    const editHandleClick = async (data) => {
        if(data.status === "Approved"){
            setApproveMessage(true);
            return;
        } else if(data.status === "Disapproved"){
            setDisapproveMessage(true);
            return;
        } else if(data.status === "Cancelled"){
            setCancelledMessage(true);
            return;
        }

        setRequestType(data.requestTypeDescription);

        if(data.requestTypeDescription === "Overtime Request"){
            setShowEditOTForm(true);
            const requestDataWithId = await fetchOTRequest(data);
            setEditData(requestDataWithId);
            setEmployeePersonalInformationFullName(requestDataWithId.employeePersonalInformationFullName);
            setEmployeePersonalInformationId(requestDataWithId.employeePersonalInformationId);
            setOvertimeType(requestDataWithId.overtimeType);
            setDate(requestDataWithId.date);
            setHours(requestDataWithId.hours);
            setHasOvertimeAllowance(requestDataWithId.hasOvertimeAllowance);
            setIsAboveTwoHoursOvertime(requestDataWithId.isAboveTwoHoursOvertime);
            setReason(requestDataWithId.reason);
            
            let filesToBeSet = [];

            if(requestDataWithId.content){
                const binaryData = atob(requestDataWithId.content);
        
                // Convert the binary data to a Uint8Array
                const arrayBuffer = new ArrayBuffer(binaryData.length);
                const uint8Array = new Uint8Array(arrayBuffer);
                for (let i = 0; i < binaryData.length; i++) {
                    uint8Array[i] = binaryData.charCodeAt(i);
                }
        
                const blob = new Blob([uint8Array], { type: 'image/jpeg' }); // Adjust the MIME type as per your data
        
                const file = new File([blob], 'filename.jpg', { type: 'image/jpeg' }); // Provide a filename and MIME type
        
                filesToBeSet.push(file);
            }
            
            setFilesOT(filesToBeSet);
            setContent(requestDataWithId?.content ?? null);
            setGPSCam(requestDataWithId?.gpsCam ?? null);
        }

        if(data.requestTypeDescription === "Leave Request"){
            setShowEditLeaveForm(true);
            const requestDataWithId = await fetchLeaveRequest(data);
            setEditData(requestDataWithId);
            setEmployeePersonalInformationFullNameLeave(requestDataWithId.employeePersonalInformationFullName);
            setLeaveType(requestDataWithId.leaveTypeId);
            setDateFromLeave(requestDataWithId.dateFrom);
            setDateToLeave(requestDataWithId.dateTo);
            setDaysLeave(requestDataWithId.days);
            setIsHalfDayLeave(requestDataWithId.isHalfDay);
            setWithoutPayLeave(requestDataWithId.withoutPay);
            setReasonLeave(requestDataWithId.reason);

            let filesToBeSet = [];

            if(requestDataWithId.content){
                const binaryData = atob(requestDataWithId.content);
        
                // Convert the binary data to a Uint8Array
                const arrayBuffer = new ArrayBuffer(binaryData.length);
                const uint8Array = new Uint8Array(arrayBuffer);
                for (let i = 0; i < binaryData.length; i++) {
                    uint8Array[i] = binaryData.charCodeAt(i);
                }
        
                const blob = new Blob([uint8Array], { type: 'image/jpeg' }); // Adjust the MIME type as per your data
        
                const file = new File([blob], 'filename.jpg', { type: 'image/jpeg' }); // Provide a filename and MIME type
        
                filesToBeSet.push(file);
            }
            
            setFilesLeave(filesToBeSet);
            setContent(requestDataWithId?.content ?? null);
            setMedicalCertificate(requestDataWithId?.medicalCertificate ?? null);
        }
        
        if(data.requestTypeDescription === "Change Schedule"){
            setShowEditChangeOfScheduleForm(true);
            const requestDataWithId = await fetchChangeOfScheduleRequest(data);
            setEditData(requestDataWithId);
            setEmployeePersonalInformationFullNameChangeSchedule(requestDataWithId.employeePersonalInformationFullName);
            setDateFromChangeSchedule(requestDataWithId.dateFrom);
            setDateToChangeSchedule(requestDataWithId.dateTo);
            setShiftScheduleFromId(requestDataWithId.shiftScheduleFromId);
            setShiftScheduleToId(requestDataWithId.shiftScheduleToId);
            setReasonChangeSchedule(requestDataWithId.reason);

            let filesToBeSet = [];

            if(requestDataWithId.content){
                const binaryData = atob(requestDataWithId.content);
        
                // Convert the binary data to a Uint8Array
                const arrayBuffer = new ArrayBuffer(binaryData.length);
                const uint8Array = new Uint8Array(arrayBuffer);
                for (let i = 0; i < binaryData.length; i++) {
                    uint8Array[i] = binaryData.charCodeAt(i);
                }
        
                const blob = new Blob([uint8Array], { type: 'image/jpeg' }); // Adjust the MIME type as per your data
        
                const file = new File([blob], 'filename.jpg', { type: 'image/jpeg' }); // Provide a filename and MIME type
        
                filesToBeSet.push(file);
            }
            
            setFilesChangeSchedule(filesToBeSet);
            setContent(requestDataWithId?.content ?? null);
            setGPSCam(requestDataWithId?.gpsCam ?? null);
        }

        if(data.requestTypeDescription === "Change Log Request"){
            setShowEditChangeLogForm(true);
            const requestDataWithId = await fetchChangeLogRequest(data);
            setEditData(requestDataWithId);
            setEmployeePersonalInformationIdChangeLogRequest(requestDataWithId.employeePersonalInformationId);
            setEmployeePersonalInformationFullNameChangeLogRequest(requestDataWithId.employeePersonalInformationFullName);
            setTimeTypeChangeLogRequest(requestDataWithId.timeType);
            setDateChangeLogRequest(requestDataWithId.date);
            setTimeRequestedChangeLogRequest(requestDataWithId.timeRendered);
            setReasonChangeLogRequest(requestDataWithId.reason);
            setReasonForRejectionChangeLogRequest(requestDataWithId.reasonForRejection);
            setSelectedItinerary(requestDataWithId.changeLogItineraries);

            let filesToBeSet = [];

            if(requestDataWithId.content){
                const binaryData = atob(requestDataWithId.content);
        
                // Convert the binary data to a Uint8Array
                const arrayBuffer = new ArrayBuffer(binaryData.length);
                const uint8Array = new Uint8Array(arrayBuffer);
                for (let i = 0; i < binaryData.length; i++) {
                    uint8Array[i] = binaryData.charCodeAt(i);
                }
        
                const blob = new Blob([uint8Array], { type: 'image/jpeg' }); // Adjust the MIME type as per your data
        
                const file = new File([blob], 'filename.jpg', { type: 'image/jpeg' }); // Provide a filename and MIME type
        
                filesToBeSet.push(file);
            }
            
            setFilesChangeLog(filesToBeSet);
            setContent(requestDataWithId?.content ?? null);
            setGPSCam(requestDataWithId?.gpsCam ?? null);
        }

        if (data.requestTypeDescription === "Offset") {
            const requestDataWithId = await fetchOBRequest(data);
            setEditData(requestDataWithId);
            setShowEditOffsetForm(true);
            // setReferenceNumberOffset(requestDataWithId.referenceNumber);
            // setApproverIdOffset(requestDataWithId.approverId);
            // setApproverNameOffset(requestDataWithId.approverFullName);
            // setStatusOffsetRequest(requestDataWithId.status);
            setEmployeePersonalInformationFullNameOffsetRequest(
                requestDataWithId.employeePersonalInformationFullName
            );
            setEmployeePersonalInformationIdOffsetRequest(
                requestDataWithId.employeePersonalInformationId
            );
            setTypeOffset(requestDataWithId.type);
            setReferencesOffset(requestDataWithId.references);
            setDateOffset(requestDataWithId.date);
            setHoursOffset(requestDataWithId.hours);
            setDateFromOffset(requestDataWithId.dateFrom);
            setDateToOffset(requestDataWithId.dateTo);
            setDaysOffset(requestDataWithId.days);
            setReasonOffsetRequest(requestDataWithId.reason);
            // setReasonForRejection(requestDataWithId.reasonForRejection);

            let filesToBeSet = [];

            if (requestDataWithId.content) {
                const binaryData = atob(requestDataWithId.content);

                // Convert the binary data to a Uint8Array
                const arrayBuffer = new ArrayBuffer(binaryData.length);
                const uint8Array = new Uint8Array(arrayBuffer);
                for (let i = 0; i < binaryData.length; i++) {
                uint8Array[i] = binaryData.charCodeAt(i);
                }

                const blob = new Blob([uint8Array], { type: "image/jpeg" }); // Adjust the MIME type as per your data

                const file = new File([blob], "filename.jpg", { type: "image/jpeg" }); // Provide a filename and MIME type

                filesToBeSet.push(file);
            }

            setFilesOffset(filesToBeSet);
            setContent(requestDataWithId?.content ?? null);
            setGPSCam(requestDataWithId?.gpsCam ?? null);
        }

        if (data.requestTypeDescription === "Official Business") {
            const requestDataWithId = await fetchOBRequest(data);
            setEditData(requestDataWithId);
            setShowEditOBForm(true);
            // setReferenceNumberOffset(requestDataWithId.referenceNumber);
            // setApproverIdOffset(requestDataWithId.approverId);
            // setApproverNameOffset(requestDataWithId.approverFullName);
            // setStatusOffsetRequest(requestDataWithId.status);
            setEmployeePersonalInformationFullNameOB(
                requestDataWithId.employeePersonalInformationFullName
            );
            setEmployeePersonalInformationIdOB(
                requestDataWithId.employeePersonalInformationId
            );
            setDateFromOB(requestDataWithId.dateFrom);
            setDateToOB(requestDataWithId.dateTo);
            setTimeFromOB(requestDataWithId.timeFrom);
            setTimeToOB(requestDataWithId.timeTo);
            setReasonOB(requestDataWithId.reason);
            setLocationOB(requestDataWithId.location);

            setContent(requestDataWithId?.content ?? null);
            setGPSCam(requestDataWithId?.gpsCam ?? null);
        }
    };
    const closeEditHandleClick = () => {
        if(requestType === "Overtime Request"){
            setShowEditOTForm(false);
        }

        if(requestType === "Leave Request"){
            setShowEditLeaveForm(false);
        }
        
        if(requestType === "Change Schedule"){
            setShowEditChangeOfScheduleForm(false);
        }

        if(requestType === "Change Log Request"){
            setShowEditChangeLogForm(false);
            
            setItineraryTimeIn("");
            setItineraryTimeOut("");
            setItineraryLocation("");
            setIsItinerayAddState(false);
            setIsItinerayUpdateState(false);
            setIsItinerayDeleteState(false);
        }

        if(requestType === "Offset"){
            setShowEditOffsetForm(false);
        }

        if(requestType === "Official Business"){
            setShowEditOBForm(false);
        }

        setContent(null)
        setGPSCam(null)
        setMedicalCertificate(null)
    };
    const updateRequest = async (event) => {
        event.preventDefault();
        setLoadingRequest(true);

        const overTimeApiUrl =  domain + "/api/OvertimeRequest";
        const leaveTimeApiUrl =  domain + "/api/LeaveRequest";
        const changeOfScheduleTimeApiUrl =  domain + "/api/ChangeScheduleRequest";
        const changeLogRequestTimeApiUrl =  domain + "/api/ChangeLogRequest";
        const offsetRequestTimeApiUrl =  domain + "/api/OffsetRequest";
        const officialBusinessRequestTimeApiUrl =  domain + "/api/OfficialBusinessRequest";

        let data = {};

        var requestUrl = overTimeApiUrl;

        if(requestType === "Leave Request"){
            requestUrl = leaveTimeApiUrl;

            const toBase64 = (file) => new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        
            let base64String = "";
            let photoToBeSave = "";
        
            if(filesLeave.length > 0){
                base64String = await toBase64(filesLeave[0]);
                photoToBeSave = base64String.split(',')[1];
            }
    
            const uploadImage = filesLeave ? photoToBeSave : null;

            data = {
                referenceNumber: editData.referenceNumber,
                employeePersonalInformationId: filteredEmployee.id, //temporary
                approverId: editData.approverId,
                requestTypeId: editData.requestTypeId,
                reason: reasonLeave,
                reasonForRejection: editData.reasonForRejection,
                status: editData.status,
                dateRequested: editData.dateRequested,
                dateCompleted: editData.dateCompleted,
                _content: uploadImage,
                content: content,
                medicalCertificate: medicalCertificate,
                dateFrom: dateFromLeave,
                dateTo: dateToLeave,
                leaveTypeId: leaveType,
                days: daysLeave,
                isHalfDay: isHalfDayLeave,
                withoutPay: withoutPayLeave,
            };
        }

        if(requestType === "Change Schedule"){
            requestUrl = changeOfScheduleTimeApiUrl;

            const toBase64 = (file) => new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        
            let base64String = "";
            let photoToBeSave = "";
        
            if(filesChangeSchedule.length > 0){
                base64String = await toBase64(filesChangeSchedule[0]);
                photoToBeSave = base64String.split(',')[1];
            }
    
            const uploadImage = filesChangeSchedule ? photoToBeSave : null;

            data = {
                referenceNumber: editData.referenceNumber,
                employeePersonalInformationId: filteredEmployee.id, //temporary
                approverId: editData.approverId,
                requestTypeId: editData.requestTypeId,
                reason: reasonChangeSchedule,
                reasonForRejection: editData.reasonForRejection,
                status: editData.status,
                dateRequested: editData.dateRequested,
                dateCompleted: editData.dateCompleted,
                _content: uploadImage,
                content: content,
                gpsCam: gpsCam,
                dateFrom: dateFromChangeSchedule,
                dateTo: dateToChangeSchedule,
                shiftScheduleFromId: shiftScheduleFromId,
                shiftScheduleToId: shiftScheduleToId,
            };
        }

        if(requestType === "Overtime Request"){
            requestUrl = overTimeApiUrl;

            const toBase64 = (file) => new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        
            let base64String = "";
            let photoToBeSave = "";
        
            if(filesOT.length > 0){
                base64String = await toBase64(filesOT[0]);
                photoToBeSave = base64String.split(',')[1];
            }
    
            const uploadImage = filesOT ? photoToBeSave : null;

            data = {
                referenceNumber: editData.referenceNumber,
                employeePersonalInformationId: filteredEmployee.id, //temporary
                approverId: editData.approverId,
                requestTypeId: editData.requestTypeId,
                reason: reason,
                reasonForRejection: editData.reasonForRejection,
                status: editData.status,
                dateRequested: editData.dateRequested,
                dateCompleted: editData.dateCompleted,
                _content: uploadImage,
                content: content,
                gpsCam: gpsCam,
                date: date,
                hours: hours,
                overtimeType: overtimeType,
                hasOvertimeAllowance: hasOvertimeAllowance,
                isAboveTwoHoursOvertime: isAboveTwoHoursOvertime,
            };
        }

        if(requestType === "Change Log Request"){
            requestUrl = changeLogRequestTimeApiUrl;

            const toBase64 = (file) => new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        
            let base64String = "";
            let photoToBeSave = "";
        
            if(filesChangeLog.length > 0){
                base64String = await toBase64(filesChangeLog[0]);
                photoToBeSave = base64String.split(',')[1];
            }
    
            const uploadImage = filesChangeLog ? photoToBeSave : null;

            const _changeLogItineraries = selectedItinerary.map(item => {

                let _timeIn = item.timeIn;
                let _timeOut = item.timeOut;
                const dateLog = dateChangeLogRequest.split('T')[0]

                if(isValidDate(_timeIn)){
                    _timeIn = item.timeIn && item.timeIn.split('T')[1];
                }

                if(isValidDate(_timeOut)){
                    _timeOut = item.timeOut && item.timeOut.split('T')[1];
                }

                _timeIn = `${dateLog}T${_timeIn}`;
                _timeOut = `${dateLog}T${_timeOut}`;

                return ({
                    changeLogRequestId: item.changeLogRequestId,
                    timeIn: _timeIn, // Replace this with actual date/time if available
                    timeOut: _timeOut,// Replace this with actual date/time if available
                    location: item.location
                })}
            );

            data = {
                referenceNumber: editData.referenceNumber,
                employeePersonalInformationId: filteredEmployee.id, //temporary
                approverId: editData.approverId,
                requestTypeId: editData.requestTypeId,
                reason: reasonChangeLogRequest,
                reasonForRejection: editData.reasonForRejection,
                status: editData.status,
                dateRequested: editData.dateRequested,
                dateCompleted: editData.dateCompleted,
                _content: uploadImage,
                content: content,
                gpsCam: gpsCam,
                date: dateChangeLogRequest,
                timeRendered: timeRequestedChangeLogRequest,
                timeType: timeTypeChangeLogRequest,
                changeLogItineraries: _changeLogItineraries,
            };
        }

        if(requestType === "Offset"){
            requestUrl = offsetRequestTimeApiUrl;

            const toBase64 = (file) => new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        
            let base64String = "";
            let photoToBeSave = "";
        
            if(filesOffset.length > 0){
                base64String = await toBase64(filesOffset[0]);
                photoToBeSave = base64String.split(',')[1];
            }
    
            const uploadImage = filesOffset ? photoToBeSave : null;

            data = {
                referenceNumber: editData.referenceNumber,
                employeePersonalInformationId: filteredEmployee.id, //temporary
                approverId: editData.approverId,
                requestTypeId: editData.requestTypeId,
                reason: reasonOffsetRequest,
                reasonForRejection: editData.reasonForRejection,
                status: editData.status,
                dateRequested: editData.dateRequested,
                dateCompleted: editData.dateCompleted,
                _content: uploadImage,
                content: content,
                gpsCam: gpsCam,
                date: dateOffset,
                referenceDate: referencesOffset[0] != null ? referencesOffset[0].date : null,
                type: "Overtime",
                offsetType: typeOffset,
            };

            console.log('Final bulkData:', JSON.stringify(data, null, 2));
        }

        if(requestType === "Official Business"){
            requestUrl = officialBusinessRequestTimeApiUrl;

            const toBase64 = (file) => new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        
            let base64String = "";
            let photoToBeSave = "";
        
            if(filesOffset.length > 0){
                base64String = await toBase64(filesOffset[0]);
                photoToBeSave = base64String.split(',')[1];
            }
    
            const uploadImage = filesOffset ? photoToBeSave : null;

            data = {
                referenceNumber: editData.referenceNumber,
                employeePersonalInformationId: filteredEmployee.id, //temporary
                approverId: editData.approverId,
                requestTypeId: editData.requestTypeId,
                reason: reasonOB,
                status: editData.status,
                dateRequested: editData.dateRequested,
                dateCompleted: editData.dateCompleted,
                _content: uploadImage,
                content: content,
                gpsCam: gpsCam,
                dateFrom: dateFromOB,
                dateTo: dateToOB,
                timeFrom: timeFromOB,
                timeTo: timeToOB,
                location: locationOB,
            };

            console.log('Final bulkData:', JSON.stringify(data, null, 2));
        }

        try {
            await axios.put(requestUrl + `/${editData.id}`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            console.log('Data updated successfully');
            
            closeEditHandleClick();

            // Reload table data and reset form fields
            await fetchData(); // Assuming fetchData() fetches the updated data for the table
            await fetchOTRequestData();
            await fetchLeaveRequestData();
            await fetchChangeOfScheduleRequestData(); 
            await fetchChangeLogRequestData(); 
            setEditData([]);

            setShowRequestMessage(true);
            setIsSuccess(true);
            setRequestMessage("Request Successful");
        } catch (error) {
            console.error('There was a problem updating data:', error);
            setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
    }

    const deleteHandleClick = (data) => {
        if(data.status === "Approved"){
            setApproveMessage(true);
            return;
        } else if(data.status === "Disapproved"){
            setDisapproveMessage(true);
            return;
        } else if(data.status === "Cancelled"){
            setCancelledMessage(true);
            return;
        }

        setRequestType(data.requestTypeDescription);
        setDeleteData(data);
        setShowDeleteForm(true);
    }
    const closeDeleteHandleClick = () => {
        setShowDeleteForm(false);
    };
    const cancelRequest = async (event) => {
        event.preventDefault();
        setLoadingRequest(true);

        const overTimeApiUrl =  domain + "/api/OvertimeRequest";
        const leaveTimeApiUrl =  domain + "/api/LeaveRequest";
        const changeOfScheduleTimeApiUrl =  domain + "/api/ChangeScheduleRequest";
        const changeLogRequestTimeApiUrl =  domain + "/api/ChangeLogRequest";

        var requestUrl = overTimeApiUrl;

        if(requestType === "Leave Request"){
            requestUrl = leaveTimeApiUrl;
        }

        if(requestType === "Change Schedule"){
            requestUrl = changeOfScheduleTimeApiUrl;
        }

        if(requestType === "Overtime Request"){
            requestUrl = overTimeApiUrl;
        }

        if(requestType === "Change Log Request"){
            requestUrl = changeLogRequestTimeApiUrl;
        }

        const data = {
            id: deleteData.id,
            approverId: user.employeePersonalInformationId, //temporary
            status: "Cancelled",
            reasonForRejection: ""
        };

        try {
            await axios.put(requestUrl + "/status", data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            console.log('Data updated successfully');

            setShowDeleteForm(false);

            // Reload table data and reset form fields
            await fetchData(); // Assuming fetchData() fetches the updated data for the table
            await fetchOTRequestData();
            await fetchLeaveRequestData();
            await fetchChangeOfScheduleRequestData(); 
            await fetchChangeLogRequestData(); 
            setDeleteData([]);

            setShowRequestMessage(true);
            setIsSuccess(true);
            setRequestMessage("Request Successful");
        } catch (error) {
            console.error('There was a problem updating data:', error);
            setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
    }
    const closeViewOffsetRequestApproverForm = () => {
        setShowViewOffsetRequestForm(false);
    };
    const closeEditffsetRequestApproverForm = () => {
        setShowEditOffsetForm(false);
    };

    const viewImage = (data) => {
        setViewImageData(data);
        setShowViewImage(true);
    }
    const closeViewImage = () => {
        setShowViewImage(false);
    }

    useEffect(() => {
        if (approveMessage) {
            const timeoutId = setTimeout(() => {
                setApproveMessage(false);
            }, 5000);
    
            return () => clearTimeout(timeoutId);
        }
    }, [approveMessage]);
    useEffect(() => {
        if (disapproveMessage) {
            const timeoutId = setTimeout(() => {
                setDisapproveMessage(false);
            }, 5000);
    
            return () => clearTimeout(timeoutId);
        }
    }, [disapproveMessage]);
    useEffect(() => {
        if (cancelledMessage) {
            const timeoutId = setTimeout(() => {
                setCancelledMessage(false);
            }, 5000);
    
            return () => clearTimeout(timeoutId);
        }
    }, [cancelledMessage]);

    return (
        <div>
            <div className="Header">
                <div className="titleContainer">
                    <div classname="row" style={{margin: "5px 0"}}>
                        <span>{`Primary Approver/s: `}</span>
                        {generatePrimaryApprover()}
                    </div>
                    <div classname="row" style={{margin: "5px 0"}}>
                        <span>{`Secondary Approver/s: `}</span>
                        {generateSecondaryApprover()}
                    </div>
                    <div classname="row" style={{margin: "5px 0"}}>
                        <span>{`Tertiary Approver/s: `}</span>
                        {generateTertiaryApprover()}
                    </div>
                </div>
            </div>
            <div className="top-table row">
                <div className="left" style={{width:"50%", display:"none"}}>
                    {CreateSearchBarWithPlaceHolder("", 
                                                    "mainte-search row", 
                                                    "mainte-search-icon", 
                                                    "mainte-search-input", 
                                                    (e) => handleFilter(e.target.value), 
                                                    "Search by transaction id", 
                                                    SearchIcon)}
                </div>
            </div>

            <div id="container1" className="InfoList container">
                <CreateTableTransaction
                    dataList={transactions}
                    dataHeader={header}
                    dataAccessor={accessor}
                    viewHandleClick={viewHandleClick}
                    editHandleClick={editHandleClick}
                    deleteHandleClick={deleteHandleClick}
                    viewImage={viewImage}
                    overtimeRequestData={overtimeRequestData}
                    leaveRequestData={leaveRequestData}
                    changeOfScheduleData={changeOfScheduleData}
                    changeLogRequestData={changeLogRequestData}
                    
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}

                    //dummy
                    setOvertimeRequestData={setOvertimeRequestData}
                    setLeaveRequestData={setLeaveRequestData}
                    setChangeOfScheduleData={setChangeOfScheduleData}
                    setChangeLogRequestData={setChangeLogRequestData}
                />
            </div>
            <ViewOffsetForm
                isOpen={showViewOffsetRequestForm}
                onClose={closeViewOffsetRequestApproverForm}
                employeePersonalInformationFullName={ employeePersonalInformationFullNameOffsetRequest } setEmployeePersonalInformationFullName={ setEmployeePersonalInformationFullNameOffsetRequest }
                employeePersonalInformationId={employeePersonalInformationIdOffsetRequest} setEmployeePersonalInformationId={setEmployeePersonalInformationIdOffsetRequest}
                references={referencesOffset} setReferences={referencesOffset}
                date={dateOffset} setDate={setDateOffset}
                hours={hoursOffset} setHours={setHoursOffset}
                type={typeOffset} setType={setTypeOffset}
                dateFrom={dateFromOffset} setDateFrom={setDateFromOffset}
                dateTo={dateToOffset} setDateTo={setDateToOffset}
                days={daysOffset} setDays={setDaysOffset}
                reason={reasonOffsetRequest} setReason={setReasonOffsetRequest}
                files={filesOffset} setFiles={setFilesOffset}
                viewImage={viewImage}
                content={content} setContent={setContent}
                gpsCam={gpsCam} setGPSCam={setGPSCam}
            ></ViewOffsetForm>
            <EditOffsetForm
                isOpen={showEditOffsetForm}
                onClose={closeEditffsetRequestApproverForm}
                employeePersonalInformationFullName={ employeePersonalInformationFullNameOffsetRequest } setEmployeePersonalInformationFullName={ setEmployeePersonalInformationFullNameOffsetRequest }
                employeePersonalInformationId={employeePersonalInformationIdOffsetRequest} setEmployeePersonalInformationId={setEmployeePersonalInformationIdOffsetRequest}
                references={referencesOffset} setReferences={setReferencesOffset}
                date={dateOffset} setDate={setDateOffset}
                hours={hoursOffset} setHours={setHoursOffset}
                type={typeOffset} setType={setTypeOffset}
                dateFrom={dateFromOffset} setDateFrom={setDateFromOffset}
                dateTo={dateToOffset} setDateTo={setDateToOffset}
                days={daysOffset} setDays={setDaysOffset}
                reason={reasonOffsetRequest} setReason={setReasonOffsetRequest}
                files={filesOffset} setFiles={setFilesOffset}
                viewImage={viewImage}
                handleUpdate={updateRequest}
                isApprove={false}
                user={user}
                editData={editData}
                content={content} setContent={setContent}
                gpsCam={gpsCam} setGPSCam={setGPSCam}
            ></EditOffsetForm>
            <ViewOTForm  isOpen={showViewOTForm} 
                    onClose={closeViewHandleClick}
                    employeePersonalInformationFullName={employeePersonalInformationFullName}
                    employeePersonalInformationId={employeePersonalInformationId}
                    overtimeType={overtimeType}
                    date={date}
                    hours={hours}
                    hasOvertimeAllowance={hasOvertimeAllowance}
                    isAboveTwoHoursOvertime={isAboveTwoHoursOvertime}
                    reason={reason}
                    setEmployeePersonalInformationFullName={setEmployeePersonalInformationFullName}
                    setEmployeePersonalInformationId={setEmployeePersonalInformationId}
                    setOvertimeType={setOvertimeType}
                    setDate={setDate}
                    files={filesOT}
                    setFiles={setFilesOT}
                    viewImage={viewImage}
                    content={content} setContent={setContent}
                    gpsCam={gpsCam} setGPSCam={setGPSCam}
            >
            </ViewOTForm>
            <ViewLeaveForm  isOpen={showViewLeaveForm} 
                    onClose={closeViewHandleClick}
                    employeePersonalInformationFullNameLeave={employeePersonalInformationFullNameLeave}
                    leaveType={leaveType}
                    dateFromLeave={dateFromLeave}
                    dateToLeave={dateToLeave}
                    daysLeave={daysLeave}
                    isHalfDayLeave={isHalfDayLeave}
                    withoutPayLeave={withoutPayLeave}
                    reasonLeave={reasonLeave}
                    setEmployeePersonalInformationFullNameLeave={setEmployeePersonalInformationFullNameLeave}
                    setLeaveType={setLeaveType}
                    setDateFromLeave={setDateFromLeave}
                    setDateToLeave={setDateToLeave}
                    files={filesLeave}
                    setFiles={setFilesLeave}
                    viewImage={viewImage}
                    content={content} setContent={setContent}
                    medicalCertificate={medicalCertificate} setMedicalCertificate={setMedicalCertificate}
            >
            </ViewLeaveForm>
            <ViewChangeScheduleForm  isOpen={showViewChangeScheduleForm} 
                    onClose={closeViewHandleClick}
                    employeePersonalInformationFullNameChangeSchedule={employeePersonalInformationFullNameChangeSchedule}
                    dateFromChangeSchedule={dateFromChangeSchedule}
                    dateToChangeSchedule={dateToChangeSchedule}
                    shiftScheduleFromId={shiftScheduleFromId}
                    shiftScheduleToId={shiftScheduleToId}
                    reasonChangeSchedule={reasonChangeSchedule}
                    setEmployeePersonalInformationFullNameChangeSchedule={setEmployeePersonalInformationFullNameChangeSchedule}
                    setDateFromChangeSchedule={setDateFromChangeSchedule}
                    setDateToChangeSchedule={setDateToChangeSchedule}
                    setShiftScheduleFromId={setShiftScheduleFromId}
                    setShiftScheduleToId={setShiftScheduleToId}
                    files={filesChangeSchedule}
                    setFiles={setFilesChangeSchedule}
                    viewImage={viewImage}
                    content={content} setContent={setContent}
                    gpsCam={gpsCam} setGPSCam={setGPSCam}
            >
            </ViewChangeScheduleForm>
            <ViewChangeLogRequestForm  isOpen={showViewChangeLogRequestForm} 
                    onClose={closeViewHandleClick}
                    employeePersonalInformationIdChangeLogRequest={employeePersonalInformationIdChangeLogRequest}
                    employeePersonalInformationFullNameChangeLogRequest={employeePersonalInformationFullNameChangeLogRequest}
                    timeTypeChangeLogRequest={timeTypeChangeLogRequest}
                    dateChangeLogRequest={dateChangeLogRequest}
                    timeRequestedChangeLogRequest={timeRequestedChangeLogRequest}
                    statusChangeLogRequest={statusChangeLogRequest}
                    reasonChangeLogRequest={reasonChangeLogRequest}
                    reasonForRejectionChangeLogRequest={reasonForRejectionChangeLogRequest}
                    setEmployeePersonalInformationIdChangeLogRequest={setEmployeePersonalInformationIdChangeLogRequest}
                    setEmployeePersonalInformationFullNameChangeLogRequest={setEmployeePersonalInformationFullNameChangeLogRequest}
                    setTimeTypeChangeLogRequest={setTimeTypeChangeLogRequest}
                    setDateChangeLogRequest={setDateChangeLogRequest}
                    setTimeRequestedChangeLogRequest={setTimeRequestedChangeLogRequest}
                    setStatusChangeLogRequest={setStatusChangeLogRequest}
                    setReasonChangeLogRequest={setReasonChangeLogRequest}
                    setReasonForRejectionChangeLogRequest={setReasonForRejectionChangeLogRequest}
                    files={filesChangeLog}
                    setFiles={setFilesChangeLog}
                    data={selectedItinerary}
                    viewImage={viewImage}
                    content={content} setContent={setContent}
                    gpsCam={gpsCam} setGPSCam={setGPSCam}
            >
            </ViewChangeLogRequestForm>
            <EditOTForm  isOpen={showEditOTForm} 
                    onClose={closeEditHandleClick}
                    employeePersonalInformationFullName={employeePersonalInformationFullName}
                    employeePersonalInformationId={employeePersonalInformationId}
                    overtimeType={overtimeType}
                    date={date}
                    hours={hours}
                    hasOvertimeAllowance={hasOvertimeAllowance}
                    isAboveTwoHoursOvertime={isAboveTwoHoursOvertime}
                    reason={reason}
                    setEmployeePersonalInformationFullName={setEmployeePersonalInformationFullName}
                    setEmployeePersonalInformationId={setEmployeePersonalInformationId}
                    setOvertimeType={setOvertimeType}
                    setHasOvertimeAllowance={setHasOvertimeAllowance}
                    setIsAboveTwoHoursOvertime={setIsAboveTwoHoursOvertime}
                    setHours={setHours}
                    setReason={setReason}
                    setDate={setDate}
                    handleUpdate={updateRequest}
                    files={filesOT}
                    setFiles={setFilesOT}
                    viewImage={viewImage}
                    content={content} setContent={setContent}
                    gpsCam={gpsCam} setGPSCam={setGPSCam}
            >
            </EditOTForm>
            <EditLeaveForm  isOpen={showEditLeaveForm} 
                    onClose={closeEditHandleClick}
                    employeePersonalInformationFullNameLeave={employeePersonalInformationFullNameLeave}
                    leaveType={leaveType}
                    dateFromLeave={dateFromLeave}
                    dateToLeave={dateToLeave}
                    daysLeave={daysLeave}
                    isHalfDayLeave={isHalfDayLeave}
                    withoutPayLeave={withoutPayLeave}
                    reasonLeave={reasonLeave}
                    setEmployeePersonalInformationFullNameLeave={setEmployeePersonalInformationFullNameLeave}
                    setLeaveType={setLeaveType}
                    setDateFromLeave={setDateFromLeave}
                    setDateToLeave={setDateToLeave}
                    setDaysLeave={setDaysLeave}
                    setIsHalfDayLeave={setIsHalfDayLeave}
                    setWithoutPayLeave={setWithoutPayLeave}
                    setReasonLeave={setReasonLeave}
                    handleUpdate={updateRequest}
                    files={filesLeave}
                    setFiles={setFilesLeave}
                    viewImage={viewImage}
                    content={content} setContent={setContent}
                    medicalCertificate={medicalCertificate} setMedicalCertificate={setMedicalCertificate}
            >
            </EditLeaveForm>
            <EditChangeScheduleForm  isOpen={showEditChangeOfScheduleForm} 
                    onClose={closeEditHandleClick}
                    employeePersonalInformationFullNameChangeSchedule={employeePersonalInformationFullNameChangeSchedule}
                    dateFromChangeSchedule={dateFromChangeSchedule}
                    dateToChangeSchedule={dateToChangeSchedule}
                    shiftScheduleFromId={shiftScheduleFromId}
                    shiftScheduleToId={shiftScheduleToId}
                    reasonChangeSchedule={reasonChangeSchedule}
                    setEmployeePersonalInformationFullNameChangeSchedule={setEmployeePersonalInformationFullNameChangeSchedule}
                    setDateFromChangeSchedule={setDateFromChangeSchedule}
                    setDateToChangeSchedule={setDateToChangeSchedule}
                    setShiftScheduleFromId={setShiftScheduleFromId}
                    setShiftScheduleToId={setShiftScheduleToId}
                    setReasonChangeSchedule={setReasonChangeSchedule}
                    handleUpdate={updateRequest}
                    files={filesChangeSchedule}
                    setFiles={setFilesChangeSchedule}
                    viewImage={viewImage}
                    content={content} setContent={setContent}
                    gpsCam={gpsCam} setGPSCam={setGPSCam}
            >
            </EditChangeScheduleForm>
            <EditChangeLogRequestForm  isOpen={showEditChangeLogForm} 
                    onClose={closeEditHandleClick}
                    employeePersonalInformationIdChangeLogRequest={employeePersonalInformationIdChangeLogRequest}
                    employeePersonalInformationFullNameChangeLogRequest={employeePersonalInformationFullNameChangeLogRequest}
                    timeTypeChangeLogRequest={timeTypeChangeLogRequest}
                    dateChangeLogRequest={dateChangeLogRequest}
                    timeRequestedChangeLogRequest={timeRequestedChangeLogRequest}
                    statusChangeLogRequest={statusChangeLogRequest}
                    reasonChangeLogRequest={reasonChangeLogRequest}
                    reasonForRejectionChangeLogRequest={reasonForRejectionChangeLogRequest}
                    setEmployeePersonalInformationIdChangeLogRequest={setEmployeePersonalInformationIdChangeLogRequest}
                    setEmployeePersonalInformationFullNameChangeLogRequest={setEmployeePersonalInformationFullNameChangeLogRequest}
                    setTimeTypeChangeLogRequest={setTimeTypeChangeLogRequest}
                    setDateChangeLogRequest={setDateChangeLogRequest}
                    setTimeRequestedChangeLogRequest={setTimeRequestedChangeLogRequest}
                    setStatusChangeLogRequest={setStatusChangeLogRequest}
                    setReasonChangeLogRequest={setReasonChangeLogRequest}
                    setReasonForRejectionChangeLogRequest={setReasonForRejectionChangeLogRequest}
                    handleUpdate={updateRequest}
                    files={filesChangeLog}
                    setFiles={setFilesChangeLog}
                    data={selectedItinerary}
                    setData={setSelectedItinerary}
                    itineraryTimeIn={itineraryTimeIn}
                    setItineraryTimeIn={setItineraryTimeIn}
                    itineraryTimeOut={itineraryTimeOut}
                    setItineraryTimeOut={setItineraryTimeOut}
                    itineraryLocation={itineraryLocation}
                    setItineraryLocation={setItineraryLocation}
                    isItinerayAddState={isItinerayAddState}
                    setIsItinerayAddState={setIsItinerayAddState}
                    isItinerayUpdateState={isItinerayUpdateState}
                    setIsItinerayUpdateState={setIsItinerayUpdateState}
                    isItinerayDeleteState={isItinerayDeleteState}
                    setIsItinerayDeleteState={setIsItinerayDeleteState}
                    viewImage={viewImage}
                    content={content} setContent={setContent}
                    gpsCam={gpsCam} setGPSCam={setGPSCam}
            >
            </EditChangeLogRequestForm>
            
            <EditOBRequestForm 
                isOpen={showEditOBForm}
                onClose={closeEditHandleClick}
                employeePersonalInformationFullNameOB={employeePersonalInformationFullNameOB} setEmployeePersonalInformationFullNameOB={setEmployeePersonalInformationFullNameOB}
                reasonOB={reasonOB} setReasonOB={setReasonOB}
                locationOB={locationOB} setLocationOB={setLocationOB}
                dateFromOB={dateFromOB} setDateFromOB={setDateFromOB}
                dateToOB={dateToOB} setDateToOB={setDateToOB}
                timeFromOB={timeFromOB} setTimeFromOB={setTimeFromOB}
                timeToOB={timeToOB} setTimeToOB={setTimeToOB}

                handleUpdate={updateRequest}

                content={content} setContent={setContent}
                gpsCam={gpsCam} setGPSCam={setGPSCam}
            />
            
            <ViewOBRequestForm 
                isOpen={showViewOBForm}
                onClose={closeViewHandleClick}
                employeePersonalInformationFullNameOB={employeePersonalInformationFullNameOB} setEmployeePersonalInformationFullNameOB={setEmployeePersonalInformationFullNameOB}
                reasonOB={reasonOB} setReasonOB={setReasonOB}
                locationOB={locationOB} setLocationOB={setLocationOB}
                dateFromOB={dateFromOB} setDateFromOB={setDateFromOB}
                dateToOB={dateToOB} setDateToOB={setDateToOB}
                timeFromOB={timeFromOB} setTimeFromOB={setTimeFromOB}
                timeToOB={timeToOB} setTimeToOB={setTimeToOB}

                handleUpdate={updateRequest}

                content={content} setContent={setContent}
                gpsCam={gpsCam} setGPSCam={setGPSCam}
            />
            
            <ClearGeneralForm isOpen={showDeleteForm} onClose={closeDeleteHandleClick} handleDelete={cancelRequest}/>
            <ViewImage isOpen={showViewImage}
                        onClose={closeViewImage}
                        viewImageData={viewImageData}
                        >                
            </ViewImage>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            <GenerateMessage form={approveMessage}
                    message={"Already approved!"}
                    isSuccess={false}
            > 
            </GenerateMessage>
            <GenerateMessage form={disapproveMessage}
                    message={"Already disapproved!"}
                    isSuccess={false}
            > 
            </GenerateMessage>
            <GenerateMessage form={cancelledMessage}
                    message={"Already cancelled!"}
                    isSuccess={false}
            > 
            </GenerateMessage>
            {loadingRequest || loading ? (
                <div
                    style={{
                    position: "fixed",
                    top: "0",
                    left: "0",
                    width: "100vw",
                    height: "100vh",
                    zIndex: "9000",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    backgroundColor: "#ffffff59",
                    }}
                >
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            ) : (
                <></>
                )
            }
        </div>
    );
};

function ViewOTForm({isOpen, 
    onClose, 
    employeePersonalInformationFullName, 
    employeePersonalInformationId,
    overtimeType, 
    date, 
    hours, 
    hasOvertimeAllowance, 
    isAboveTwoHoursOvertime, 
    reason, 
    setEmployeePersonalInformationFullName,
    setEmployeePersonalInformationId,
    setOvertimeType,
    setDate,
    files,
    setFiles,
    viewImage,

    

    content, setContent,
    gpsCam, setGPSCam,
})
{
    const [attachmentType, setAttachmentType] = useState(null)
    const [showViewForm, setShowViewForm] = useState(false)
    const [selectedData, setSelectedData] = useState(null)

    const openViewForm = () => {
        setShowViewForm(true)
    }
    const closeViewForm = () => {
        setShowViewForm(false)
    }

    const viewHandleClick = async (_data, _type) => {
        setSelectedData(_data)
        setAttachmentType(_type)
        openViewForm();
    }
    const handleClose = () => {
        onClose();
        setAttachmentType(null)
        setShowViewForm(false)
        setSelectedData(null)
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Request Details</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Employee</div>
                            <div className="info-item-input">
                                <input
                                readOnly={true}
                                id="employeePersonalInformationFullName"
                                placeholder="Employee"
                                value={employeePersonalInformationFullName}
                                onChange={(e) => setEmployeePersonalInformationFullName(e.target.value)}
                                style={{cursor:"not-allowed"}}
                                />
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Employee Id</div>
                                <div className="info-item-input">
                                    <input
                                    readOnly={true}
                                    type='number'
                                    id="employeePersonalInformationId"
                                    placeholder="Employee Id"
                                    value={employeePersonalInformationId}
                                    onChange={(e) => setEmployeePersonalInformationId(e.target.value)}
                                    style={{cursor:"not-allowed"}}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Overtime Type</div>
                            <div className="info-item-input">
                                <OvertimeTypeSelect overtimeType={overtimeType} setOvertimeType={setOvertimeType} isView={true}/>
                                {/* {OvertimeTypeSelect(overtimeType, setOvertimeType, true)} */}
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Date</div>
                                <div className="info-item-input">
                                    <DateTimeInput date={date} setDate={setDate} isView={true} />
                                    {/* {DateTimeInput(date, setDate, true)} */}
                                </div>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Hours</div>
                                <div className="info-item-input">
                                    <input
                                    type='number'
                                    id="hours"
                                    placeholder="Hours"
                                    value={hours}
                                    readOnly={true}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="transaction-from-splitItem row hidden">
                            <div className="transaction-form-item row">
                                <div className="transaction-form-input" style={{width:"auto"}}>
                                    <input type="checkbox" 
                                        id="overtime-allowance" 
                                        className="checkbox"
                                        name="" 
                                        checked={hasOvertimeAllowance}
                                        readOnly={true}
                                    />
                                </div>
                                <div className="transaction-form-category" style={{padding:"0 10px"}}><h5 style={{fontWeight:"normal"}}>With overtime allowance?</h5></div>
                            </div>
                            <div className="transaction-form-item row">
                                <div className="transaction-form-input" style={{width:"auto"}}>
                                    <input type="checkbox" 
                                        id="overtime-above2" 
                                        className="checkbox" 
                                        name="" 
                                        checked={isAboveTwoHoursOvertime}
                                        readOnly={true}
                                    />
                                </div>
                                <div className="transaction-form-category" style={{padding:"0 10px"}}><h5 style={{fontWeight:"normal"}}>Above two hours overtime?</h5></div>
                            </div>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Reason</div>
                            <div className="info-item-input">
                                <textarea id="tamper" className="filterSelect"
                                        style={{width:"100%",minHeight:"50px", borderRadius:"3px", border:"1px solid #80808080",color: "rgb(104, 104, 104)"}}
                                        value={reason}
                                        readOnly={true}
                                />
                            </div>
                        </div>
                        <div className="popUp-item info-item column hidden">
                            <div className="info-item-label">Upload</div>
                            <div className="info-item-input">
                                {files.length > 0 && (
                                    <div style={{border:"1px solid #97979745", padding:"10px"}}>
                                        <span>Uploaded File:</span>
                                        <ul>
                                            {files.map((file, index) => (
                                            <img src={file ? URL.createObjectURL(file) : ""} alt="" style={{width: "150px", height: "auto"}} onClick={() => viewImage({ content: file })}></img>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className='flex flex-col gap-5'>

                            {/* GPS CAM */}
                            <div className='flex flex-col gap-1'>
                                <div className='flex flex-row gap-2 items-center'>
                                    <div className="info-item-label">GPS Cam</div>

                                    <button
                                        type="button"
                                        className='cursor-pointer rounded-sm bg-sky-400 hover:bg-sky-500 text-white px-2 py-1'
                                        onClick={() => viewHandleClick(gpsCam, "GPS Cam")}
                                        disabled={!gpsCam}
                                    >
                                        View
                                    </button>
                                </div>

                                <div className="!border !border-gray-300 rounded-md text-xs text-gray-500 mt-1 px-2 py-1">
                                    {gpsCam instanceof File
                                        ? gpsCam.name
                                        : gpsCam
                                            ? "Existing GPS Cam file"
                                            : "No file"
                                    }
                                </div>
                            </div>


                            {/* PROOF OF APPROVAL */}
                            <div className='flex flex-col gap-1'>
                                <div className='flex flex-row gap-2 items-center'>
                                    <div className="info-item-label">Proof of Approval</div>

                                    <button
                                        type="button"
                                        className='cursor-pointer rounded-sm bg-sky-400 hover:bg-sky-500 text-white px-2 py-1'
                                        onClick={() => viewHandleClick(content, "Proof of Approval")}
                                        disabled={!content}
                                    >
                                        View
                                    </button>
                                </div>

                                <div className="!border !border-gray-300 rounded-md text-xs text-gray-500 mt-1 px-2 py-1">
                                    {content instanceof File
                                        ? content.name
                                        : content
                                            ? "Existing Proof of Approval file"
                                            : "No file"
                                    }
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={handleClose}>
                                Close
                        </button>
                    </div>
                </div>
            )}
            </div>
                    
            <AttachmentForm 
                isOpen={showViewForm}
                onClose={closeViewForm}
                modalName={attachmentType}
                data={selectedData}
            />
        </>
    );
}
function ViewLeaveForm({isOpen, 
    onClose,
    employeePersonalInformationFullNameLeave, 
    leaveType, 
    dateFromLeave, 
    dateToLeave, 
    daysLeave, 
    isHalfDayLeave, 
    withoutPayLeave, 
    reasonLeave,
    setEmployeePersonalInformationFullNameLeave,
    setLeaveType,
    setDateFromLeave,
    setDateToLeave,
    files,
    setFiles,
    viewImage,

    content, setContent,
    medicalCertificate, setMedicalCertificate,
})
{
    const [attachmentType, setAttachmentType] = useState(null)
    const [showViewForm, setShowViewForm] = useState(false)
    const [selectedData, setSelectedData] = useState(null)

    const openViewForm = () => {
        setShowViewForm(true)
    }
    const closeViewForm = () => {
        setShowViewForm(false)
    }

    const viewHandleClick = async (_data, _type) => {
        setSelectedData(_data)
        setAttachmentType(_type)
        openViewForm();
    }
    const handleClose = () => {
        onClose();
        setAttachmentType(null)
        setShowViewForm(false)
        setSelectedData(null)
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Request Details</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Employee</div>
                            <div className="info-item-input">
                                <input
                                readOnly={true}
                                id="employeePersonalInformationFullNameLeave"
                                placeholder="Employee"
                                value={employeePersonalInformationFullNameLeave}
                                onChange={(e) => setEmployeePersonalInformationFullNameLeave(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Type</div>
                                <div className="info-item-input">
                                    <select
                                        value={withoutPayLeave ? "withoutPay" : "withPay"}
                                        // onChange={(e) => setWithoutPay(e.target.value === "withoutPay")}
                                        className="!p-1 w-full rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm !text-gray-500 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        disabled
                                    >
                                        <option value="withPay">With Pay</option>
                                        <option value="withoutPay">Without Pay</option>
                                    </select>
                                </div>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Leave Type</div>
                                <div className="info-item-input">
                                    <LeaveTypeSelect leaveType={leaveType} setLeaveType={setLeaveType} isView={true} />
                                    {/* {LeaveTypeSelect(leaveType, setLeaveType, true)} */}
                                </div>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Date From</div>
                                <div className="info-item-input">
                                    <DateTimeInput date={dateFromLeave} setDate={setDateFromLeave} isView={true} />
                                    {/* {DateTimeInput(dateFromLeave, setDateFromLeave, true)} */}
                                </div>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Date To</div>
                                <div className="info-item-input">
                                    <DateTimeInput date={dateToLeave} setDate={setDateToLeave} isView={true} />
                                    {/* {DateTimeInput(dateToLeave, setDateToLeave, true)} */}
                                </div>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Days</div>
                                <div className="info-item-input">
                                    <input
                                    readOnly
                                    type="number"
                                    id="daysLeave"
                                    placeholder="Days"
                                    value={daysLeave}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="transaction-from-splitItem row hidden">
                            <div className="transaction-form-item row">
                                <div className="transaction-form-input" style={{width:"auto"}}>
                                    <input type="checkbox" 
                                        readOnly
                                        id="overtime-allowance" 
                                        className="checkbox"
                                        name="" 
                                        checked={isHalfDayLeave}
                                    />
                                </div>
                                <div className="transaction-form-category" style={{padding:"0 10px"}}><h5 style={{fontWeight:"normal"}}>Half Day?</h5></div>
                            </div>
                            <div className="transaction-form-item row">
                                <div className="transaction-form-input" style={{width:"auto"}}>
                                    <input type="checkbox" 
                                        readOnly
                                        id="overtime-allowance" 
                                        className="checkbox"
                                        name="" 
                                        checked={withoutPayLeave}
                                    />
                                </div>
                                <div className="transaction-form-category" style={{padding:"0 10px"}}><h5 style={{fontWeight:"normal"}}>Without Pay?</h5></div>
                            </div>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Reason</div>
                            <div className="info-item-input">
                                <textarea id="tamper" className="filterSelect"
                                        style={{width:"100%",minHeight:"50px", borderRadius:"3px", border:"1px solid #80808080",color: "rgb(104, 104, 104)"}}
                                        value={reasonLeave}
                                        readOnly
                                />
                            </div>
                        </div>
                        <div className="popUp-item info-item column hidden">
                            <div className="info-item-label">Upload</div>
                            <div className="info-item-input">
                                {files.length > 0 && (
                                    <div style={{border:"1px solid #97979745", padding:"10px"}}>
                                        <span>Uploaded File:</span>
                                        <ul>
                                            {files.map((file, index) => (
                                            <img src={file ? URL.createObjectURL(file) : ""} alt="" style={{width: "150px", height: "auto"}}></img>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className='flex flex-col gap-5'>
                            {/* PROOF OF APPROVAL */}
                            <div className='flex flex-col gap-1'>
                                <div className='flex flex-row gap-2 items-center'>
                                    <div className="info-item-label">Proof of Approval</div>

                                    <button
                                        type="button"
                                        className='cursor-pointer rounded-sm bg-sky-400 hover:bg-sky-500 text-white px-2 py-1'
                                        onClick={() => viewHandleClick(content, "Proof of Approval")}
                                        disabled={!content}
                                    >
                                        View
                                    </button>
                                </div>

                                <div className="!border !border-gray-300 rounded-md text-xs text-gray-500 mt-1 px-2 py-1">
                                    {content instanceof File
                                        ? content.name
                                        : content
                                            ? "Existing Proof of Approval file"
                                            : "No file"
                                    }
                                </div>
                            </div>

                            

                            {/* Medical Cert */}
                            <div className='flex flex-col gap-1'>
                                <div className='flex flex-row gap-2 items-center'>
                                    <div className="info-item-label">Medical Certificate</div>

                                    <button
                                        type="button"
                                        className='cursor-pointer rounded-sm bg-sky-400 hover:bg-sky-500 text-white px-2 py-1'
                                        onClick={() => viewHandleClick(medicalCertificate, "Medical Certificate")}
                                        disabled={!medicalCertificate}
                                    >
                                        View
                                    </button>
                                </div>

                                <div className="!border !border-gray-300 rounded-md text-xs text-gray-500 mt-1 px-2 py-1">
                                    {medicalCertificate instanceof File
                                        ? medicalCertificate.name
                                        : medicalCertificate
                                            ? "Existing Med Cert file"
                                            : "No file"
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={handleClose}>
                                Close
                        </button>
                    </div>
                </div>
            )}
            </div>
                    
            <AttachmentForm 
                isOpen={showViewForm}
                onClose={closeViewForm}
                modalName={attachmentType}
                data={selectedData}
            />
        </>
    );
}
function ViewChangeScheduleForm({isOpen, 
    onClose,
    employeePersonalInformationFullNameChangeSchedule, 
    dateFromChangeSchedule, 
    dateToChangeSchedule, 
    shiftScheduleFromId, 
    shiftScheduleToId, 
    reasonChangeSchedule,
    setDateFromChangeSchedule,
    setDateToChangeSchedule,
    setShiftScheduleFromId,
    setShiftScheduleToId,
    files,
    setFiles,
    viewImage
})
{
    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Request Details</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Employee</div>
                            <div className="info-item-input">
                                <input
                                readOnly={true}
                                id="employeePersonalInformationFullNameChangeSchedule"
                                placeholder="Employee"
                                value={employeePersonalInformationFullNameChangeSchedule}
                                />
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Date From</div>
                                <div className="info-item-input">
                                    <DateTimeInput date={dateFromChangeSchedule} setDate={setDateFromChangeSchedule} isView={true} />
                                    {/* {DateTimeInput(dateFromChangeSchedule, setDateFromChangeSchedule, true)} */}
                                </div>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Date To</div>
                                <div className="info-item-input">
                                    <DateTimeInput date={dateToChangeSchedule} setDate={setDateToChangeSchedule} isView={true} />
                                    {/* {DateTimeInput(dateToChangeSchedule, setDateToChangeSchedule, true)} */}
                                </div>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Shift Schedule From</div>
                                <div className="info-item-input">
                                    {ShiftScheduleIdSelect(shiftScheduleFromId, setShiftScheduleFromId, true)}
                                </div>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Shift Schedule To</div>
                                <div className="info-item-input">
                                    {ShiftScheduleIdSelect(shiftScheduleToId, setShiftScheduleToId, true)}
                                </div>
                            </div>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Reason</div>
                            <div className="info-item-input">
                                <textarea id="tamper" className="filterSelect"
                                        style={{width:"100%",minHeight:"50px", borderRadius:"3px", border:"1px solid #80808080",color: "rgb(104, 104, 104)"}}
                                        value={reasonChangeSchedule}
                                        readOnly
                                />
                            </div>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Upload</div>
                            <div className="info-item-input">
                                {files.length > 0 && (
                                    <div style={{border:"1px solid #97979745", padding:"10px"}}>
                                        <span>Uploaded File:</span>
                                        <ul>
                                            {files.map((file, index) => (
                                            <img src={file ? URL.createObjectURL(file) : ""} alt="" style={{width: "150px", height: "auto"}}></img>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={handleClose}>
                                Close
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function ViewChangeLogRequestForm({isOpen, 
    onClose, 
    employeePersonalInformationFullNameChangeLogRequest,
    timeTypeChangeLogRequest,
    dateChangeLogRequest,
    timeRequestedChangeLogRequest,
    reasonChangeLogRequest,
    setTimeTypeChangeLogRequest,
    setDateChangeLogRequest,
    setTimeRequestedChangeLogRequest,
    files,
    setFiles,
    data,
    viewImage,

    content, setContent,
    gpsCam, setGPSCam,
})
{
    var header = [
        "Time In",
        "Time Out",
        "Location",
    ]
    var accessor = [
        "timeIn",
        "timeOut",
        "location",
    ]

    const [attachmentType, setAttachmentType] = useState(null)
    const [showViewForm, setShowViewForm] = useState(false)
    const [selectedData, setSelectedData] = useState(null)

    const openViewForm = () => {
        setShowViewForm(true)
    }
    const closeViewForm = () => {
        setShowViewForm(false)
    }

    const viewHandleClick = async (_data, _type) => {
        setSelectedData(_data)
        setAttachmentType(_type)
        openViewForm();
    }

    const handleClose = () => {
        onClose();
        setAttachmentType(null)
        setShowViewForm(false)
        setSelectedData(null)
    };
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <>
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Request Details</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Employee</div>
                                <div className="info-item-input">
                                    <input
                                    readOnly={true}
                                    id="employeePersonalInformationFullNameChangeSchedule"
                                    placeholder="Employee"
                                    value={employeePersonalInformationFullNameChangeLogRequest}
                                    />
                                </div>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Time Type</div>
                                <div className="info-item-input">
                                    <TimeTypeSelect timeType={timeTypeChangeLogRequest} setTimeType={setTimeTypeChangeLogRequest} isView={true}/>
                                </div>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Date</div>
                                <div className="info-item-input">
                                    <DateTimeInput date={dateChangeLogRequest} setDate={setDateChangeLogRequest} isView={true} />
                                    {/* {DateTimeInput(dateChangeLogRequest, setDateChangeLogRequest, true)} */}
                                </div>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Time Requested</div>
                                <div className="info-item-input">
                                    <TimeInput date={timeRequestedChangeLogRequest} setDate={setTimeRequestedChangeLogRequest} isView={true}/>
                                </div>
                            </div>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Reason</div>
                            <div className="info-item-input">
                                <textarea id="tamper" className="filterSelect"
                                        style={{width:"100%",minHeight:"50px", borderRadius:"3px", border:"1px solid #80808080",color: "rgb(104, 104, 104)"}}
                                        value={reasonChangeLogRequest}
                                        readOnly
                                />
                            </div>
                        </div>
                        <div className="popUp-item info-item column hidden">
                            <div className="info-item-label">Upload</div>
                            <div className="info-item-input">
                                {files.length > 0 && (
                                    <div style={{border:"1px solid #97979745", padding:"10px"}}>
                                        <span>Uploaded File:</span>
                                        <ul>
                                            {files.map((file, index) => (
                                            <img src={file ? URL.createObjectURL(file) : ""} alt="" style={{width: "150px", height: "auto"}}></img>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </div>
                        </div>

                        

                            <div className='flex flex-col gap-5'>

                                {/* GPS CAM */}
                                <div className='flex flex-col gap-1'>
                                    <div className='flex flex-row gap-2 items-center'>
                                        <div className="info-item-label">GPS Cam</div>

                                        <button
                                            type="button"
                                            className='cursor-pointer rounded-sm bg-sky-400 hover:bg-sky-500 text-white px-2 py-1'
                                            onClick={() => viewHandleClick(gpsCam, "GPS Cam")}
                                            disabled={!gpsCam}
                                        >
                                            View
                                        </button>
                                    </div>

                                    <div className="!border !border-gray-300 rounded-md text-xs text-gray-500 mt-1 px-2 py-1">
                                        {gpsCam instanceof File
                                            ? gpsCam.name
                                            : gpsCam
                                                ? "Existing GPS Cam file"
                                                : "No file"
                                        }
                                    </div>
                                </div>


                                {/* PROOF OF APPROVAL */}
                                <div className='flex flex-col gap-1'>
                                    <div className='flex flex-row gap-2 items-center'>
                                        <div className="info-item-label">Proof of Approval</div>

                                        <button
                                            type="button"
                                            className='cursor-pointer rounded-sm bg-sky-400 hover:bg-sky-500 text-white px-2 py-1'
                                            onClick={() => viewHandleClick(content, "Proof of Approval")}
                                            disabled={!content}
                                        >
                                            View
                                        </button>
                                    </div>

                                    <div className="!border !border-gray-300 rounded-md text-xs text-gray-500 mt-1 px-2 py-1">
                                        {content instanceof File
                                            ? content.name
                                            : content
                                                ? "Existing Proof of Approval file"
                                                : "No file"
                                        }
                                    </div>
                                </div>

                            </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Itinerary</div>
                            <div className="info-item-input">
                                <div className="users-table container" style={{overflow:"unset"}}>
                                    <CreateTableItinerary
                                        dataList={data}
                                        dataHeader={header}
                                        dataAccessor={accessor}
                                    />
                                </div>
                                {data && data.length > 0 ? (
                                <div></div>
                                )
                                :
                                (
                                    <div style={{display:"flex", alignItems:"center", justifyContent:"center"}}> {/*<p>No records to display</p>*/}</div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="cancel row"
                            style={{height: "34px", borderRadius: "3px"}}
                            onClick={handleClose}>
                                Close
                        </button>
                    </div>
                </div>
                    
                <AttachmentForm 
                    isOpen={showViewForm}
                    onClose={closeViewForm}
                    modalName={attachmentType}
                    data={selectedData}
                />
                </>
            )}
            </div>
        </>
    );
}
function EditOTForm({isOpen, 
    onClose, 
    employeePersonalInformationFullName, 
    employeePersonalInformationId,
    overtimeType, 
    date, 
    hours, 
    hasOvertimeAllowance, 
    isAboveTwoHoursOvertime, 
    reason, 
    setEmployeePersonalInformationFullName,
    setEmployeePersonalInformationId,
    setOvertimeType,
    setHasOvertimeAllowance,
    setReason,
    setIsAboveTwoHoursOvertime,
    setHours,
    setDate,
    handleUpdate,
    files,
    setFiles,
    viewImage,

    content, setContent,
    gpsCam, setGPSCam,
})
{

    const [attachmentType, setAttachmentType] = useState(null)
    const [showViewForm, setShowViewForm] = useState(false)
    const [selectedData, setSelectedData] = useState(null)

    const openViewForm = () => {
        setShowViewForm(true)
    }
    const closeViewForm = () => {
        setShowViewForm(false)
    }

    const viewHandleClick = async (_data, _type) => {
        setSelectedData(_data)
        setAttachmentType(_type)
        openViewForm();
    }
    
    

    const [fileNameGPS, setFileNameGPS] = useState("")
    const [fileNameContent, setFileNameContent] = useState("")
    const handleBrowseGPSCam = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const reader = new FileReader();

        reader.onload = () => {
            const base64 = reader.result.split(",")[1];

            setGPSCam(base64);
            setFileNameGPS(file.name)
        };

        reader.readAsDataURL(file);
    };
    const handleBrowseProofApproval = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const reader = new FileReader();

        reader.onload = () => {
            const base64 = reader.result.split(",")[1];

            setContent(base64);
            setFileNameContent(file.name)
        };

        reader.readAsDataURL(file);
    };
    const handleClose = () => {
        onClose();
        setAttachmentType(null)
        setShowViewForm(false)
        setSelectedData(null)
        setFileNameGPS("")
        setFileNameContent("")
    };

    // for upload
    const handleBrowse = (e) => {
        const fileList = Array.from(e.target.files);

        setFiles(fileList);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        
        const fileList = Array.from(e.dataTransfer.files);
        e.currentTarget.style.backgroundColor = "white";

        setFiles(fileList);
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#bdbdbd7d";
    };
    const handleDragOut = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "white";
    };
    const clearFiles = () => {
        // Clear the files state
        setFiles([]);
        // Reset the value of the file input
        document.getElementById('fileInput').value = '';
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <>
                    <div className="modal">
                        <div className="popUp-header row">
                            <div className="popUp-title">
                                <h3 style={{ color: "#668fca" }}>Update Details</h3>
                            </div>
                            <div className="popUp-close">
                                <CloseIcon onClick={()=>handleClose()} />
                            </div>
                        </div>
                        <div className="popUp-body">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Employee</div>
                                <div className="info-item-input">
                                    <input
                                    readOnly={true}
                                    id="employeePersonalInformationFullName"
                                    placeholder="Employee"
                                    value={employeePersonalInformationFullName}
                                    onChange={(e) => setEmployeePersonalInformationFullName(e.target.value)}
                                    style={{cursor:"not-allowed"}}
                                    />
                                </div>
                            </div>
                            <div className="info-item-holder row hidden">
                                <div className="popUp-item info-item column">
                                    <div className="info-item-label">Employee Id</div>
                                    <div className="info-item-input">
                                        <input
                                        readOnly={true}
                                        type='number'
                                        id="employeePersonalInformationId"
                                        placeholder="Employee Id"
                                        value={employeePersonalInformationId}
                                        onChange={(e) => setEmployeePersonalInformationId(e.target.value)}
                                        style={{cursor:"not-allowed"}}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Overtime Type</div>
                                <div className="info-item-input">
                                    <OvertimeTypeSelect overtimeType={overtimeType} setOvertimeType={setOvertimeType} isView={false}/>
                                    {/* {OvertimeTypeSelect(overtimeType, setOvertimeType, false)} */}
                                </div>
                            </div>
                            <div className="info-item-holder row">
                                <div className="popUp-item info-item column">
                                    <div className="info-item-label">Date</div>
                                    <div className="info-item-input">
                                        <DateTimeInput date={date} setDate={setDate} isView={false} />
                                        {/* {DateTimeInput(date, setDate, false)} */}
                                    </div>
                                </div>
                                <div className="popUp-item info-item column">
                                    <div className="info-item-label">Hours</div>
                                    <div className="info-item-input">
                                        <input
                                        type='number'
                                        id="hours"
                                        placeholder="Hours"
                                        value={hours}
                                        onChange={(e) => setHours(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="transaction-from-splitItem row hidden">
                                <div className="transaction-form-item row">
                                    <div className="transaction-form-input" style={{width:"auto"}}>
                                        <input type="checkbox" 
                                            id="overtime-allowance" 
                                            className="checkbox"
                                            name="" 
                                            checked={hasOvertimeAllowance}
                                            onChange={(e) => setHasOvertimeAllowance(e.target.checked)}
                                        />
                                    </div>
                                    <div className="transaction-form-category" style={{padding:"0 10px"}}><h5 style={{fontWeight:"normal"}}>With overtime allowance?</h5></div>
                                </div>
                                <div className="transaction-form-item row">
                                    <div className="transaction-form-input" style={{width:"auto"}}>
                                        <input type="checkbox" 
                                            id="overtime-above2" 
                                            className="checkbox" 
                                            name="" 
                                            checked={isAboveTwoHoursOvertime}
                                            onChange={(e) => setIsAboveTwoHoursOvertime(e.target.checked)}
                                        />
                                    </div>
                                    <div className="transaction-form-category" style={{padding:"0 10px"}}><h5 style={{fontWeight:"normal"}}>Above two hours overtime?</h5></div>
                                </div>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Reason</div>
                                <div className="info-item-input">
                                    <textarea id="tamper" className="filterSelect"
                                            style={{width:"100%",minHeight:"50px", borderRadius:"3px", border:"1px solid #80808080",color: "rgb(104, 104, 104)"}}
                                            value={reason}
                                            onChange={(e) => setReason(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="popUp-item info-item column hidden">
                                <div className="info-item-label">Upload</div>
                                <div className="info-item-input">
                                    <label htmlFor="fileInput" className='browse'>Browse...</label>
                                    <input
                                        type="file"
                                        id="fileInput"
                                        onChange={(e)=> handleBrowse(e)}
                                        style={{ display: 'none' }}
                                    />
                                    
                                    {files.length > 0 ? (
                                        <div style={{border:"1px solid #97979745", padding:"10px"}}>
                                            <span>Uploaded File:</span>
                                            <ul>
                                                {files.map((file, index) => (
                                                <img src={file ? URL.createObjectURL(file) : "images/sample.jpg"} alt="" style={{width: "150px", height: "auto"}} onClick={() => viewImage({ content: file })}></img>
                                                ))}
                                            </ul>
                                            <div className="buttons row" style={{display:"flex", justifyContent:"end"}}>
                                                <button id="add-family" 
                                                className="cancel row"
                                                onClick={()=>clearFiles()}
                                                style={{marginRight:"5px"}}>
                                                    CLEAR
                                                </button>
                                            </div>
                                        </div>
                                    )
                                    :
                                    (
                                        <div
                                            id='drop-files-here'
                                            onDrop={(e)=>handleDrop(e)}
                                            onDragOver={(e)=>handleDragOver(e)}
                                            onDragLeave={(e)=>handleDragOut(e)}
                                            style={{
                                            border: '2px dashed #ccc',
                                            borderRadius: '5px',
                                            padding: '20px',
                                            marginTop: '10px',
                                            textAlign: 'center',
                                            }}
                                        >
                                            Drop files here
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className='flex flex-col gap-5'>

                                {/* GPS CAM */}
                                <div className='flex flex-col gap-1'>
                                    <div className='flex flex-row gap-2 items-center'>
                                        <div className="info-item-label">GPS Cam</div>

                                        <button
                                            type="button"
                                            className='cursor-pointer rounded-sm bg-sky-400 hover:bg-sky-500 text-white px-2 py-1'
                                            onClick={() => viewHandleClick(gpsCam, "GPS Cam")}
                                            disabled={!gpsCam}
                                        >
                                            View
                                        </button>

                                        <button
                                            type="button"
                                            className='cursor-pointer rounded-sm bg-green-400 hover:bg-green-500 text-white px-2 py-1'
                                            onClick={() => document.getElementById("gpsCamInput").click()}
                                        >
                                            Browse
                                        </button>

                                        <input
                                            id="gpsCamInput"
                                            type="file"
                                            className="hidden"
                                            accept="image/*,.pdf"
                                            onChange={handleBrowseGPSCam}
                                        />
                                    </div>

                                    <div className="!border !border-gray-300 rounded-md text-xs text-gray-500 mt-1 px-2 py-1">
                                        {gpsCam instanceof File
                                            ? gpsCam.name
                                            : gpsCam
                                                ? fileNameGPS || "Existing GPS Cam file"
                                                : "No file"
                                        }
                                    </div>
                                </div>


                                {/* PROOF OF APPROVAL */}
                                <div className='flex flex-col gap-1'>
                                    <div className='flex flex-row gap-2 items-center'>
                                        <div className="info-item-label">Proof of Approval</div>

                                        <button
                                            type="button"
                                            className='cursor-pointer rounded-sm bg-sky-400 hover:bg-sky-500 text-white px-2 py-1'
                                            onClick={() => viewHandleClick(content, "Proof of Approval")}
                                            disabled={!content}
                                        >
                                            View
                                        </button>

                                        <button
                                            type="button"
                                            className='cursor-pointer rounded-sm bg-green-400 hover:bg-green-500 text-white px-2 py-1'
                                            onClick={() => document.getElementById("contentInput").click()}
                                        >
                                            Browse
                                        </button>

                                        <input
                                            id="contentInput"
                                            type="file"
                                            className="hidden"
                                            accept="image/*,.pdf,.doc,.docx,.xls,.xlsx"
                                            onChange={handleBrowseProofApproval}
                                        />
                                    </div>

                                    <div className="!border !border-gray-300 rounded-md text-xs text-gray-500 mt-1 px-2 py-1">
                                        {content instanceof File
                                            ? content.name
                                            : content
                                                ? fileNameContent || "Existing Proof of Approval file"
                                                : "No file"
                                        }
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                            <button id="add-family" 
                                className="save row"
                                style={{marginRight: "5px"}}
                                onClick={handleUpdate}>
                                    Update
                            </button>
                            <button id="add-family" 
                                className="cancel row"
                                onClick={handleClose}>
                                    Close
                            </button>
                        </div>
                    </div>
                    
                    <AttachmentForm 
                        isOpen={showViewForm}
                        onClose={closeViewForm}
                        modalName={attachmentType}
                        data={selectedData}
                    />
                </>
            )}
            </div>
        </>
    );
}
function EditLeaveForm({isOpen, 
    onClose,
    employeePersonalInformationFullNameLeave, 
    leaveType, 
    dateFromLeave, 
    dateToLeave, 
    daysLeave, 
    isHalfDayLeave, 
    withoutPayLeave, 
    reasonLeave,
    setEmployeePersonalInformationFullNameLeave,
    setLeaveType,
    setDateFromLeave,
    setDaysLeave,
    setIsHalfDayLeave,
    setWithoutPayLeave,
    setReasonLeave,
    setDateToLeave,
    handleUpdate,
    files,
    setFiles,
    viewImage,

    

    content, setContent,
    medicalCertificate, setMedicalCertificate,
})
{
    const [attachmentType, setAttachmentType] = useState(null)
    const [showViewForm, setShowViewForm] = useState(false)
    const [selectedData, setSelectedData] = useState(null)

    const openViewForm = () => {
        setShowViewForm(true)
    }
    const closeViewForm = () => {
        setShowViewForm(false)
    }

    const viewHandleClick = async (_data, _type) => {
        setSelectedData(_data)
        setAttachmentType(_type)
        openViewForm();
    }
    const [fileNameMedicalCertificate, setFileNameMedicalCertificate] = useState("")
    const [fileNameContent, setFileNameContent] = useState("")
    const handleBrowseMedicalCertificate = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const reader = new FileReader();

        reader.onload = () => {
            const base64 = reader.result.split(",")[1];

            setMedicalCertificate(base64);
            setFileNameMedicalCertificate(file.name)
        };

        reader.readAsDataURL(file);
    };
    const handleBrowseProofApproval = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const reader = new FileReader();

        reader.onload = () => {
            const base64 = reader.result.split(",")[1];

            setContent(base64);
            setFileNameContent(file.name)
        };

        reader.readAsDataURL(file);
    };
    const handleClose = () => {
        onClose();
        setAttachmentType(null)
        setShowViewForm(false)
        setSelectedData(null)
        setFileNameMedicalCertificate("")
        setFileNameContent("")
    };

    // for upload
    const handleBrowse = (e) => {
        const fileList = Array.from(e.target.files);

        if (fileList.length > 0) {
            if(!fileList[0].type.startsWith("image/")){
                alert("Please select an image file.");
                setFiles("");
                return;
            }
        }

        setFiles(fileList);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        
        const fileList = Array.from(e.dataTransfer.files);
        e.currentTarget.style.backgroundColor = "white";

        if (fileList.length > 0) {
            if(!fileList[0].type.startsWith("image/")){
                alert("Please select an image file.");
                setFiles("");
                return;
            }
        }

        setFiles(fileList);
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#bdbdbd7d";
    };
    const handleDragOut = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "white";
    };
    const clearFiles = () => {
        // Clear the files state
        setFiles([]);
        // Reset the value of the file input
        document.getElementById('fileInput').value = '';
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <>
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Update Details</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Employee</div>
                            <div className="info-item-input">
                                <input
                                readOnly={true}
                                id="employeePersonalInformationFullNameLeave"
                                placeholder="Employee"
                                value={employeePersonalInformationFullNameLeave}
                                onChange={(e) => setEmployeePersonalInformationFullNameLeave(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Type</div>
                                <div className="info-item-input">
                                    <select
                                        value={withoutPayLeave ? "withoutPay" : "withPay"}
                                        onChange={(e) => setWithoutPayLeave(e.target.value === "withoutPay")}
                                        className="!p-1 w-full rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm !text-gray-500 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    >
                                        <option value="withPay">With Pay</option>
                                        <option value="withoutPay">Without Pay</option>
                                    </select>
                                </div>
                            </div>
                            
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Leave Type</div>
                                <div className="info-item-input">
                                    {/* {LeaveTypeSelect(leaveType, setLeaveType, false)} */}
                                    <LeaveTypeSelect leaveType={leaveType} setLeaveType={setLeaveType} isView={false} />
                                </div>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Date From</div>
                                <div className="info-item-input">
                                    <DateTimeInput date={dateFromLeave} setDate={setDateFromLeave} isView={false} />
                                    {/* {DateTimeInput(dateFromLeave, setDateFromLeave, false)} */}
                                </div>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Date To</div>
                                <div className="info-item-input">
                                    <DateTimeInput date={dateToLeave} setDate={setDateToLeave} isView={false} />
                                    {/* {DateTimeInput(dateToLeave, setDateToLeave, false)} */}
                                </div>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Days</div>
                                <div className="info-item-input">
                                    <input
                                    type="number"
                                    id="daysLeave"
                                    placeholder="Days"
                                    value={daysLeave}
                                    onChange={(e) => setDaysLeave(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="transaction-from-splitItem row hidden">
                            <div className="transaction-form-item row">
                                <div className="transaction-form-input" style={{width:"auto"}}>
                                    <input type="checkbox" 
                                        onChange={(e) => setIsHalfDayLeave(e.target.checked)}
                                        id="overtime-allowance" 
                                        className="checkbox"
                                        name="" 
                                        checked={isHalfDayLeave}
                                    />
                                </div>
                                <div className="transaction-form-category" style={{padding:"0 10px"}}><h5 style={{fontWeight:"normal"}}>Half Day?</h5></div>
                            </div>
                            <div className="transaction-form-item row">
                                <div className="transaction-form-input" style={{width:"auto"}}>
                                    <input type="checkbox" 
                                        onChange={(e) => setWithoutPayLeave(e.target.checked)}
                                        id="overtime-allowance" 
                                        className="checkbox"
                                        name="" 
                                        checked={withoutPayLeave}
                                    />
                                </div>
                                <div className="transaction-form-category" style={{padding:"0 10px"}}><h5 style={{fontWeight:"normal"}}>Without Pay?</h5></div>
                            </div>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Reason</div>
                            <div className="info-item-input">
                                <textarea id="tamper" className="filterSelect"
                                        style={{width:"100%",minHeight:"50px", borderRadius:"3px", border:"1px solid #80808080",color: "rgb(104, 104, 104)"}}
                                        value={reasonLeave}
                                        onChange={(e) => setReasonLeave(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="popUp-item info-item column hidden">
                            <div className="info-item-label">Upload</div>
                            <div className="info-item-input">
                                <label htmlFor="fileInput" className='browse'>Browse...</label>
                                <input
                                    type="file"
                                    id="fileInput"
                                    onChange={(e)=> handleBrowse(e)}
                                    style={{ display: 'none' }}
                                />
                                
                                {files.length > 0 ? (
                                    <div style={{border:"1px solid #97979745", padding:"10px"}}>
                                        <span>Uploaded File:</span>
                                        <ul>
                                            {files.map((file, index) => (
                                            <img src={file ? URL.createObjectURL(file) : "images/sample.jpg"} alt="" style={{width: "150px", height: "auto"}} onClick={() => viewImage({ content: file })}></img>
                                            ))}
                                        </ul>
                                        <div className="buttons row" style={{display:"flex", justifyContent:"end"}}>
                                            <button id="add-family" 
                                            className="cancel row"
                                            onClick={()=>clearFiles()}
                                            style={{marginRight:"5px"}}>
                                                CLEAR
                                            </button>
                                        </div>
                                    </div>
                                )
                                :
                                (
                                    <div
                                        id='drop-files-here'
                                        onDrop={(e)=>handleDrop(e)}
                                        onDragOver={(e)=>handleDragOver(e)}
                                        onDragLeave={(e)=>handleDragOut(e)}
                                        style={{
                                        border: '2px dashed #ccc',
                                        borderRadius: '5px',
                                        padding: '20px',
                                        marginTop: '10px',
                                        textAlign: 'center',
                                        }}
                                    >
                                        Drop files here
                                    </div>
                                )}
                            </div>
                        </div>
                        

                        <div className='flex flex-col gap-5'>
                            {/* PROOF OF APPROVAL */}
                            <div className='flex flex-col gap-1'>
                                <div className='flex flex-row gap-2 items-center'>
                                    <div className="info-item-label">Proof of Approval</div>

                                    <button
                                        type="button"
                                        className='cursor-pointer rounded-sm bg-sky-400 hover:bg-sky-500 text-white px-2 py-1'
                                        onClick={() => viewHandleClick(content, "Proof of Approval")}
                                        disabled={!content}
                                    >
                                        View
                                    </button>

                                    <button
                                        type="button"
                                        className='cursor-pointer rounded-sm bg-green-400 hover:bg-green-500 text-white px-2 py-1'
                                        onClick={() => document.getElementById("contentInput").click()}
                                    >
                                        Browse
                                    </button>

                                    <input
                                        id="contentInput"
                                        type="file"
                                        className="hidden"
                                        accept="image/*,.pdf,.doc,.docx,.xls,.xlsx"
                                        onChange={handleBrowseProofApproval}
                                    />
                                </div>

                                <div className="!border !border-gray-300 rounded-md text-xs text-gray-500 mt-1 px-2 py-1">
                                    {content instanceof File
                                        ? content.name
                                        : content
                                            ? fileNameContent || "Existing Proof of Approval file"
                                            : "No file"
                                    }
                                </div>
                            </div>

                            

                            {/* Medical Cert */}
                            <div className='flex flex-col gap-1'>
                                <div className='flex flex-row gap-2 items-center'>
                                    <div className="info-item-label">Medical Certificate</div>

                                    <button
                                        type="button"
                                        className='cursor-pointer rounded-sm bg-sky-400 hover:bg-sky-500 text-white px-2 py-1'
                                        onClick={() => viewHandleClick(medicalCertificate, "Medical Certificate")}
                                        disabled={!medicalCertificate}
                                    >
                                        View
                                    </button>

                                    <button
                                        type="button"
                                        className='cursor-pointer rounded-sm bg-green-400 hover:bg-green-500 text-white px-2 py-1'
                                        onClick={() => document.getElementById("gpsCamInput").click()}
                                    >
                                        Browse
                                    </button>

                                    <input
                                        id="gpsCamInput"
                                        type="file"
                                        className="hidden"
                                        accept="image/*,.pdf"
                                        onChange={handleBrowseMedicalCertificate}
                                    />
                                </div>

                                <div className="!border !border-gray-300 rounded-md text-xs text-gray-500 mt-1 px-2 py-1">
                                    {medicalCertificate instanceof File
                                        ? medicalCertificate.name
                                        : medicalCertificate
                                            ? fileNameMedicalCertificate || "Existing Med Cert file"
                                            : "No file"
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            style={{marginRight: "5px"}}
                            onClick={handleUpdate}>
                                Update
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={handleClose}>
                                Close
                        </button>
                    </div>
                </div>
                    
                <AttachmentForm 
                    isOpen={showViewForm}
                    onClose={closeViewForm}
                    modalName={attachmentType}
                    data={selectedData}
                />
                </>
            )}
            </div>
        </>
    );
}
function EditChangeScheduleForm({isOpen, 
    onClose,
    employeePersonalInformationFullNameChangeSchedule, 
    dateFromChangeSchedule, 
    dateToChangeSchedule, 
    shiftScheduleFromId, 
    shiftScheduleToId, 
    reasonChangeSchedule,
    setDateFromChangeSchedule,
    setDateToChangeSchedule,
    setShiftScheduleFromId,
    setReasonChangeSchedule,
    setShiftScheduleToId,
    handleUpdate,
    files,
    setFiles,
    viewImage
})
{
    const handleClose = () => {
        onClose();
    };

    // for upload
    const handleBrowse = (e) => {
        const fileList = Array.from(e.target.files);

        if (fileList.length > 0) {
            if(!fileList[0].type.startsWith("image/")){
                alert("Please select an image file.");
                setFiles("");
                return;
            }
        }

        setFiles(fileList);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        
        const fileList = Array.from(e.dataTransfer.files);
        e.currentTarget.style.backgroundColor = "white";

        if (fileList.length > 0) {
            if(!fileList[0].type.startsWith("image/")){
                alert("Please select an image file.");
                setFiles("");
                return;
            }
        }

        setFiles(fileList);
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#bdbdbd7d";
    };
    const handleDragOut = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "white";
    };
    const clearFiles = () => {
        // Clear the files state
        setFiles([]);
        // Reset the value of the file input
        document.getElementById('fileInput').value = '';
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Update Details</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Employee</div>
                            <div className="info-item-input">
                                <input
                                readOnly={true}
                                id="employeePersonalInformationFullNameChangeSchedule"
                                placeholder="Employee"
                                value={employeePersonalInformationFullNameChangeSchedule}
                                />
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Date From</div>
                                <div className="info-item-input">
                                    <DateTimeInput date={dateFromChangeSchedule} setDate={setDateFromChangeSchedule} isView={false} />
                                    {/* {DateTimeInput(dateFromChangeSchedule, setDateFromChangeSchedule, false)} */}
                                </div>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Date To</div>
                                <div className="info-item-input">
                                    <DateTimeInput date={dateToChangeSchedule} setDate={setDateToChangeSchedule} isView={false} />
                                    {/* {DateTimeInput(dateToChangeSchedule, setDateToChangeSchedule, false)} */}
                                </div>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Shift Schedule From</div>
                                <div className="info-item-input">
                                    {ShiftScheduleIdSelect(shiftScheduleFromId, setShiftScheduleFromId, false)}
                                </div>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Shift Schedule To</div>
                                <div className="info-item-input">
                                    {ShiftScheduleIdSelect(shiftScheduleToId, setShiftScheduleToId, false)}
                                </div>
                            </div>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Reason</div>
                            <div className="info-item-input">
                                <textarea id="tamper" className="filterSelect"
                                        style={{width:"100%",minHeight:"50px", borderRadius:"3px", border:"1px solid #80808080",color: "rgb(104, 104, 104)"}}
                                        value={reasonChangeSchedule}
                                        onChange={(e) => setReasonChangeSchedule(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Upload</div>
                            <div className="info-item-input">
                                <label htmlFor="fileInput" className='browse'>Browse...</label>
                                <input
                                    type="file"
                                    id="fileInput"
                                    onChange={(e)=> handleBrowse(e)}
                                    style={{ display: 'none' }}
                                />
                                
                                {files.length > 0 ? (
                                    <div style={{border:"1px solid #97979745", padding:"10px"}}>
                                        <span>Uploaded File:</span>
                                        <ul>
                                            {files.map((file, index) => (
                                            <img src={file ? URL.createObjectURL(file) : "images/sample.jpg"} alt="" style={{width: "150px", height: "auto"}} onClick={() => viewImage({ content: file })}></img>
                                            ))}
                                        </ul>
                                        <div className="buttons row" style={{display:"flex", justifyContent:"end"}}>
                                            <button id="add-family" 
                                            className="cancel row"
                                            onClick={()=>clearFiles()}
                                            style={{marginRight:"5px"}}>
                                                CLEAR
                                            </button>
                                        </div>
                                    </div>
                                )
                                :
                                (
                                    <div
                                        id='drop-files-here'
                                        onDrop={(e)=>handleDrop(e)}
                                        onDragOver={(e)=>handleDragOver(e)}
                                        onDragLeave={(e)=>handleDragOut(e)}
                                        style={{
                                        border: '2px dashed #ccc',
                                        borderRadius: '5px',
                                        padding: '20px',
                                        marginTop: '10px',
                                        textAlign: 'center',
                                        }}
                                    >
                                        Drop files here
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            style={{marginRight: "5px"}}
                            onClick={handleUpdate}>
                                Update
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={handleClose}>
                                Close
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EditChangeLogRequestForm({isOpen, 
    onClose, 
    employeePersonalInformationFullNameChangeLogRequest,
    timeTypeChangeLogRequest,
    dateChangeLogRequest,
    timeRequestedChangeLogRequest,
    reasonChangeLogRequest,
    setTimeTypeChangeLogRequest,
    setDateChangeLogRequest,
    setTimeRequestedChangeLogRequest,
    setReasonChangeLogRequest,
    handleUpdate,
    files,
    setFiles,
    itineraryTimeIn, 
    setItineraryTimeIn,
    itineraryTimeOut, 
    setItineraryTimeOut,
    itineraryLocation, 
    setItineraryLocation,
    isItinerayAddState, 
    setIsItinerayAddState,
    isItinerayUpdateState, 
    setIsItinerayUpdateState,
    isItinerayDeleteState, 
    setIsItinerayDeleteState,
    data,
    setData,
    viewImage,

    content, setContent,
    gpsCam, setGPSCam,
})
{
    var header = [
        "Time In",
        "Time Out",
        "Location",
        ""
    ]
    var accessor = [
        "timeIn",
        "timeOut",
        "location",
        "manage",
    ]

    const [attachmentType, setAttachmentType] = useState(null)
    const [showViewForm, setShowViewForm] = useState(false)
    const [selectedData, setSelectedData] = useState(null)

    const openViewForm = () => {
        setShowViewForm(true)
    }
    const closeViewForm = () => {
        setShowViewForm(false)
    }

    const viewHandleClick = async (_data, _type) => {
        setSelectedData(_data)
        setAttachmentType(_type)
        openViewForm();
    }
    
    

    const [fileNameGPS, setFileNameGPS] = useState("")
    const [fileNameContent, setFileNameContent] = useState("")
    const handleBrowseGPSCam = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const reader = new FileReader();

        reader.onload = () => {
            const base64 = reader.result.split(",")[1];

            setGPSCam(base64);
            setFileNameGPS(file.name)
        };

        reader.readAsDataURL(file);
    };
    const handleBrowseProofApproval = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const reader = new FileReader();

        reader.onload = () => {
            const base64 = reader.result.split(",")[1];

            setContent(base64);
            setFileNameContent(file.name)
        };

        reader.readAsDataURL(file);
    };

    const handleClose = () => {
        onClose();
        setItineraryTimeIn("");
        setItineraryTimeOut("");
        setItineraryLocation("");
        setIsItinerayAddState(false);
        setIsItinerayUpdateState(false);
        setIsItinerayDeleteState(false);
        setAttachmentType(null)
        setShowViewForm(false)
        setSelectedData(null)
        setFileNameGPS("")
        setFileNameContent("")
    };

    // for upload
    const handleBrowse = (e) => {
        const fileList = Array.from(e.target.files);

        if (fileList.length > 0) {
            if(!fileList[0].type.startsWith("image/")){
                alert("Please select an image file.");
                setFiles("");
                return;
            }
        }

        setFiles(fileList);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        
        const fileList = Array.from(e.dataTransfer.files);
        e.currentTarget.style.backgroundColor = "white";

        if (fileList.length > 0) {
            if(!fileList[0].type.startsWith("image/")){
                alert("Please select an image file.");
                setFiles("");
                return;
            }
        }

        setFiles(fileList);
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#bdbdbd7d";
    };
    const handleDragOut = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "white";
    };
    const clearFiles = () => {
        // Clear the files state
        setFiles([]);
        // Reset the value of the file input
        document.getElementById('fileInput').value = '';
    };

    const addClick = () =>{
        setIsItinerayAddState(true);
    }
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <>
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Update Details</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Employee</div>
                                <div className="info-item-input">
                                    <input
                                    readOnly={true}
                                    id="employeePersonalInformationFullNameChangeSchedule"
                                    placeholder="Employee"
                                    value={employeePersonalInformationFullNameChangeLogRequest}
                                    />
                                </div>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Time Type</div>
                                <div className="info-item-input">
                                    <TimeTypeSelect timeType={timeTypeChangeLogRequest} setTimeType={setTimeTypeChangeLogRequest} isView={false}/>
                                </div>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Date</div>
                                <div className="info-item-input">
                                    <DateInput date={dateChangeLogRequest} setDate={setDateChangeLogRequest} isView={false}/>
                                    {/* {DateInput(dateChangeLogRequest, setDateChangeLogRequest, false)} */}
                                </div>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Time Requested</div>
                                <div className="info-item-input">
                                    <TimeInput date={timeRequestedChangeLogRequest} setDate={setTimeRequestedChangeLogRequest} isView={false}/>
                                </div>
                            </div>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Reason</div>
                            <div className="info-item-input">
                                <textarea id="tamper" className="filterSelect"
                                        style={{width:"100%",minHeight:"50px", borderRadius:"3px", border:"1px solid #80808080",color: "rgb(104, 104, 104)"}}
                                        value={reasonChangeLogRequest}
                                        onChange={(e) => setReasonChangeLogRequest(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="popUp-item info-item column hidden">
                            <div className="info-item-label">Upload</div>
                            <div className="info-item-input">
                                <label htmlFor="fileInput" className='browse'>Browse...</label>
                                <input
                                    type="file"
                                    id="fileInput"
                                    onChange={(e)=> handleBrowse(e)}
                                    style={{ display: 'none' }}
                                />
                                
                                {files.length > 0 ? (
                                    <div style={{border:"1px solid #97979745", padding:"10px"}}>
                                        <span>Uploaded File:</span>
                                        <ul>
                                            {files.map((file, index) => (
                                            <img src={file ? URL.createObjectURL(file) : "images/sample.jpg"} alt="" style={{width: "150px", height: "auto"}} onClick={() => viewImage({ content: file })}></img>
                                            ))}
                                        </ul>
                                        <div className="buttons row" style={{display:"flex", justifyContent:"end"}}>
                                            <button id="add-family" 
                                            className="cancel row"
                                            onClick={()=>clearFiles()}
                                            style={{marginRight:"5px"}}>
                                                CLEAR
                                            </button>
                                        </div>
                                    </div>
                                )
                                :
                                (
                                    <div
                                        id='drop-files-here'
                                        onDrop={(e)=>handleDrop(e)}
                                        onDragOver={(e)=>handleDragOver(e)}
                                        onDragLeave={(e)=>handleDragOut(e)}
                                        style={{
                                        border: '2px dashed #ccc',
                                        borderRadius: '5px',
                                        padding: '20px',
                                        marginTop: '10px',
                                        textAlign: 'center',
                                        }}
                                    >
                                        Drop files here
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className='flex flex-col gap-5'>

                            {/* GPS CAM */}
                            <div className='flex flex-col gap-1'>
                                <div className='flex flex-row gap-2 items-center'>
                                    <div className="info-item-label">GPS Cam</div>

                                    <button
                                        type="button"
                                        className='cursor-pointer rounded-sm bg-sky-400 hover:bg-sky-500 text-white px-2 py-1'
                                        onClick={() => viewHandleClick(gpsCam, "GPS Cam")}
                                        disabled={!gpsCam}
                                    >
                                        View
                                    </button>

                                    <button
                                        type="button"
                                        className='cursor-pointer rounded-sm bg-green-400 hover:bg-green-500 text-white px-2 py-1'
                                        onClick={() => document.getElementById("gpsCamInput").click()}
                                    >
                                        Browse
                                    </button>

                                    <input
                                        id="gpsCamInput"
                                        type="file"
                                        className="hidden"
                                        accept="image/*,.pdf"
                                        onChange={handleBrowseGPSCam}
                                    />
                                </div>

                                <div className="!border !border-gray-300 rounded-md text-xs text-gray-500 mt-1 px-2 py-1">
                                    {gpsCam instanceof File
                                        ? gpsCam.name
                                        : gpsCam
                                            ? fileNameGPS || "Existing GPS Cam file"
                                            : "No file"
                                    }
                                </div>
                            </div>


                            {/* PROOF OF APPROVAL */}
                            <div className='flex flex-col gap-1'>
                                <div className='flex flex-row gap-2 items-center'>
                                    <div className="info-item-label">Proof of Approval</div>

                                    <button
                                        type="button"
                                        className='cursor-pointer rounded-sm bg-sky-400 hover:bg-sky-500 text-white px-2 py-1'
                                        onClick={() => viewHandleClick(content, "Proof of Approval")}
                                        disabled={!content}
                                    >
                                        View
                                    </button>

                                    <button
                                        type="button"
                                        className='cursor-pointer rounded-sm bg-green-400 hover:bg-green-500 text-white px-2 py-1'
                                        onClick={() => document.getElementById("contentInput").click()}
                                    >
                                        Browse
                                    </button>

                                    <input
                                        id="contentInput"
                                        type="file"
                                        className="hidden"
                                        accept="image/*,.pdf,.doc,.docx,.xls,.xlsx"
                                        onChange={handleBrowseProofApproval}
                                    />
                                </div>

                                <div className="!border !border-gray-300 rounded-md text-xs text-gray-500 mt-1 px-2 py-1">
                                    {content instanceof File
                                        ? content.name
                                        : content
                                            ? fileNameContent || "Existing Proof of Approval file"
                                            : "No file"
                                    }
                                </div>
                            </div>

                        </div>

                        <div className="popUp-item info-item column mt-5">
                            <div className="info-item-label">Itinerary</div>
                            <div className="transaction-addBtn row" style={{margin: "10px 0"}}>
                                {CreateButton("", "add row", addClick, "ADD", NoteAddIcon)}
                            </div>
                            <div className="info-item-input">
                                <div className="users-table container" style={{overflow:"unset"}}>
                                    <CreateTableItinerary
                                        dataList={data}
                                        setDataList={setData}
                                        dataHeader={header}
                                        dataAccessor={accessor}
                                        isItinerayAddState={isItinerayAddState}
                                        setIsItinerayAddState={setIsItinerayAddState}
                                        isItinerayUpdateState={isItinerayUpdateState}
                                        setIsItinerayUpdateState={setIsItinerayUpdateState}
                                        isItinerayDeleteState={isItinerayDeleteState}
                                        setIsItinerayDeleteState={setIsItinerayDeleteState}
                                        itineraryTimeIn={itineraryTimeIn}
                                        setItineraryTimeIn={setItineraryTimeIn}
                                        itineraryTimeOut={itineraryTimeOut}
                                        setItineraryTimeOut={setItineraryTimeOut}
                                        itineraryLocation={itineraryLocation}
                                        setItineraryLocation={setItineraryLocation}
                                    />
                                </div>
                                {data && data.length > 0 ? (
                                <div></div>
                                )
                                :
                                (
                                    <div style={{display:"flex", alignItems:"center", justifyContent:"center"}}> {/*<p>No records to display</p>*/}</div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            style={{marginRight: "5px"}}
                            onClick={handleUpdate}>
                                Update
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            style={{height: "34px", borderRadius: "3px"}}
                            onClick={handleClose}>
                                Close
                        </button>
                    </div>
                </div>
                
                    
                <AttachmentForm 
                    isOpen={showViewForm}
                    onClose={closeViewForm}
                    modalName={attachmentType}
                    data={selectedData}
                />
                </>
            )}
            </div>
        </>
    );
}
function OvertimeTypeSelect({overtimeType, setOvertimeType, isView}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
        setIsSelected(true);
        setOvertimeType(event.target.value);
    };

    useEffect(() => {
        if(overtimeType !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [overtimeType]);

    return (
        <div>
            <select id="employee-select-PagibigReport" disabled={isView} value={overtimeType} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose overtime type</option>
            <option value="Regular">Regular</option>
            {/* <option value="Restday">Restday</option>
            <option value="SpecialHoliday">Special Holiday</option>
            <option value="RegularHoliday">Regular Holiday</option>
            <option value="RestdaySpecialHoliday">Restday Special Holiday</option>
            <option value="RestdayRegularHoliday">Restday Regular Holiday</option> */}
            </select>
        </div>
    );
};
function LeaveTypeSelect({leaveType, setLeaveType, isView}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
        setIsSelected(true);
        setLeaveType(event.target.value);

    };

    const [leaveTypes, setLeaveTypes] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/LeaveType";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setLeaveTypes(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(leaveType !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [leaveType]);

    return (
        <div>
            <select id="employee-select-PagibigReport" disabled={isView} value={leaveType} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose leave type</option>
            {leaveTypes.map((leaveType) => ( 
                SetLeaveType(leaveType)
            ))}
            </select>
        </div>
    );
};
function SetLeaveType(leaveType){
    return(
        <option id={"leaveType" + leaveType.id} value={leaveType.id}>{
            leaveType.id + " - " + leaveType.description}
        </option>
    )
    
}
function DateTimeInput({date, setDate, isView}) {
    const [isSelected, setIsSelected] = useState(false);

    const handleDateTimeChange = (event) => {
        setDate(event.target.value);
        setIsSelected(true);
    };

    useEffect(() => {
        if(date !== undefined && date !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [date]);

    return (
        <div>
            <input
            readOnly={isView}
            type="datetime-local"
            id={"datetime-"}
            name="datetime"
            value={date.slice(0, 16)} // Exclude milliseconds
            onChange={handleDateTimeChange}
            style={{width:"90%",
                height:"30px", 
                borderRadius:"3px", 
                border:"1px solid #80808080",
                color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
                fontFamily: "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif"
            }}
            />
        </div>
    );
}
function DateInput({date, setDate, isView}) {
    const [isSelected, setIsSelected] = useState(false);

    const handleDateTimeChange = (event) => {
        setDate(event.target.value);
        setIsSelected(true);
    };

    useEffect(() => {
        if(date !== undefined && date !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [date]);

    let formattedDate = "";

    if(date){
        formattedDate = date.split('T')[0];
    }

    return (
        <div>
            <input
            readOnly={isView}
            type="date"
            id={"datetime-"}
            name="datetime"
            value={formattedDate} // Exclude milliseconds
            onChange={handleDateTimeChange}
            style={{width:"90%",
                height:"30px", 
                borderRadius:"3px", 
                border:"1px solid #80808080",
                color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
                fontFamily: "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif"
            }}
            />
        </div>
    );
}
function ShiftScheduleIdSelect(shiftScheduleId, setShiftScheduleId, isView){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
        setIsSelected(true);
        setShiftScheduleId(event.target.value);
    };

    const [shiftScheduleIds, setShiftScheduleIds] = useState([]);

    const apiUrl =  domain + "/api/ShiftSchedule";

    const fetchData = useCallback(async () => {
        await axios.get(apiUrl, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setShiftScheduleIds(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }, [apiUrl]);

    useEffect(() => {
        fetchData();

        if(shiftScheduleId !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
        
    }, [fetchData, shiftScheduleId]);

    return (
        <div>
            <select id="overtime-employee-name" disabled={isView} value={shiftScheduleId} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose shift schedule</option>
            {shiftScheduleIds.map((shiftScheduleId) => ( 
                SetShiftScheduleId(shiftScheduleId)
            ))}
            </select>
        </div>
    );
};
function SetShiftScheduleId(shiftScheduleId){
    const formatTime = (time) => {
        let timeParts;
        let formattedTime;

        if (globalTimeFormat === "Standard Time"){
            const timeSplit = time.split('T');
            if (timeSplit.length > 1) {
                timeParts = timeSplit[1].substr(0, 5).split(':');
            } else {
                timeParts = [];
            }
            let hours = parseInt(timeParts[0], 10);
            const minutes = timeParts[1];

            // Convert 24-hour format to 12-hour format and determine AM or PM
            const amPm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

            formattedTime = `${hours}:${minutes} ${amPm}`;
        } else if (globalTimeFormat === "Military Time"){
            const timeSplit = time.split('T');
            if (timeSplit.length > 1) {
                timeParts = timeSplit[1].substr(0, 5).split(':');
            } else {
                timeParts = [];
            }
            let hours = parseInt(timeParts[0], 10);
            const minutes = timeParts[1];

            formattedTime = `${hours}:${minutes}`;
        }

        return formattedTime;
    }

    return(
        <option id={"overtimeAdd" + shiftScheduleId.id} value={shiftScheduleId.id}>{`${shiftScheduleId.id} -  ${shiftScheduleId.shiftName} (${formatTime(shiftScheduleId.timeFrom)} - ${formatTime(shiftScheduleId.timeTo)}) `}</option>
    )
    
}
function TimeInput({ date, setDate, isView }) {
    const [isSelected, setIsSelected] = useState(false);

    const handleDateTimeChange = (event) => {
        const newTime = event.target.value; // Get "HH:mm"
        
        if (date && date.includes("T")) {
            const datePart = date.split("T")[0]; // Extract "YYYY-MM-DD"
            setDate(`${datePart}T${newTime}:00`); // Keep full ISO format
        } else {
            setDate(`2025-02-07T${newTime}:00`); // Fallback default date
        }

        setIsSelected(true);
    };

    useEffect(() => {
        setIsSelected(date !== undefined && date !== "");
    }, [date]);

    let timePart = "";
    if (date && date.includes("T")) {
        timePart = date.split("T")[1].substring(0, 5); // Extract HH:mm
    }

    console.log(date); // Ensure logging shows full datetime

    return (
        <div>
            <input
                readOnly={isView}
                type="time"
                id="datetime-input"
                name="datetime"
                value={timePart}
                onChange={handleDateTimeChange}
                style={{
                    width: "90%",
                    height: "30px",
                    borderRadius: "3px",
                    border: "1px solid #80808080",
                    color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
                    fontFamily: "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif"
                }}
            />
        </div>
    );
}

function TimeTypeSelect({timeType, setTimeType}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
        setIsSelected(true);
        setTimeType(event.target.value);
    };

    return (
        <div>
            <select id="timeType" value={timeType} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }} className='!text-gray-500'>
            <option value="" disabled hidden>Choose Time Type</option>
            <option value="In">Time-In</option>
            <option value="Out">Time-Out</option>
            <option value="NoIn">No-In</option>
            <option value="NoOut">No-Out</option>
            </select>
        </div>
    );
};
const CustomTooltip = ({ active, payload }) => {
    if (!active || !tooltip)    return null
    for (const bar of payload)
        if (bar.dataKey === tooltip)
            return <div className="tooltipCustom">{ bar.name }<br/>{ bar.value.toFixed(2) }</div>
    return null
}
const TypingAnimation = ({wordings}) => {
    const [text, setText] = useState('');
    const [index, setIndex] = useState(0);
    const words = wordings;
    const typingSpeed = 50; // Adjust typing speed here
    const repeatInterval = 5000; // Repeat every x seconds

    useEffect(() => {
        let typingInterval;
    
        if (index < words.length) {
            typingInterval = setInterval(() => {
            setText(words.slice(0, index + 1));
            setIndex(index + 1);
            }, typingSpeed);
        } else {
            setTimeout(() => {
            setText('');
            setIndex(0);
            }, repeatInterval);
        }
    
        return () => clearInterval(typingInterval);
    }, [index, words, typingSpeed, repeatInterval]);

    return (
        <div className="typing-animation">
        <span>{text}</span>
        </div>
    );
};
function CreateTable({ dataList = [], dataHeader = [], dataAccessor = [], currentPage, setCurrentPage, editHandleClick}) {
    const itemsPerPage = 7;

    const columns = React.useMemo(() =>
        dataHeader.map((header, index) => ({
            Header: header,
            accessor: dataAccessor[index]
        })),
        [dataHeader, dataAccessor]
    );

    const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setSortBy
    } = useTable(
        {
            columns,
            data: dataList,
            initialState: {
                sortBy: sortHeaderValue.isDefault
                    ? []  // No sorting if it's default
                    : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
            }
        },
        useSortBy
    );

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    //Sorting Feature
    const sortState = [
        { id: 0, state: "default", textValue: "" },
        { id: 1, state: "ascending", textValue: "↑" },
        { id: 2, state: "descending", textValue: "↓" }
    ];

    const headerClick = (column) => {
        if (sortHeaderValue.id !== column.id) {
            // New column selected, start with ascending order
            setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
            setSortBy([{ id: column.id, desc: false }]);
        } else {
            // Toggle between sorting states (default -> ascending -> descending -> default)
            if (sortHeaderValue.isDefault) {
                setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
                setSortBy([{ id: column.id, desc: false }]);
            } else if (!sortHeaderValue.desc) {
                setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
                setSortBy([{ id: column.id, desc: true }]);
            } else {
                setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
                setSortBy([]); // Clear sorting
            }
        }
    };

    // Ensure sorting is reapplied on dataList reload
    useEffect(() => {
        if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
            setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
        }
    }, [dataList, setSortBy, sortHeaderValue]);

    return (
        <div>
            <table {...getTableProps()}>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th
                                    {...column.getHeaderProps()}
                                    onClick={() => headerClick(column)}
                                    className="sortable-header"
                                >
                                    {`${column.render("Header")} ${
                                        sortHeaderValue.id === column.id
                                            ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                                            : ""
                                    }`}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {dataList.length <= 0 &&
                        <tr>
                            <td colSpan={columns.length} style={{ textAlign: "center" }}>
                                No data to display
                            </td>
                        </tr>
                    }
                    {currentItems.map((row) => {
                        prepareRow(row)
                        return (
                            <tr key={row.original.id}
                            {...row.getRowProps()}
                            >
                                {row.cells.map((cell) => (
                                    SetInfo(cell.render("Cell").props.column.Header, 
                                            cell,
                                            editHandleClick)
                                ))}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            {rows.length > itemsPerPage ? (
            <div>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px" }}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px" }}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"26px"}}>
                        &gt;&gt;
                    </button>
                </div>
                {`${currentPage}/${totalPages}`}
            </div>
            ) :
            <></>}
        </div>
    )
}
function SetInfo(header, _cell, editHandleClick) {
    const data = _cell.render("Cell").props.row.original;
    const value = _cell.render("Cell").props.value;

    if (header === "Photo") {
        if (header === "Photo") {
            if(data.photo){
                const imageSrc = 'data:image/jpeg;base64,' + data.photo;
    
                return(
                    <td>
                        <img className="avatarImg" src={imageSrc} alt=""/>
                    </td>
                )
            }
            return(
                <td>
                    <img className="avatarImg" src="images/sample.jpg" alt=""/>
                </td>
            )
        }
        
        if(value === "" || value === null || value === undefined){
            return(
                <td>
                    <img className="avatarImg" src="images/sample.jpg" alt=""/>
                </td>
            )
        } else {
            return(
                <td>
                    <img className="avatarImg" src="images/sample.jpg" alt=""/>
                </td>
            )
        }
    }

    if (
        header === "Time From" ||
        header === "Time To" ||
        header === "Time In" ||
        header === "Time Out"
      ) {
        const time = _cell.render("Cell").props.value;
        if (!time) {
          return <td>-</td>;
        }
    
        let timeParts;
        let formattedTime;
    
        if (globalTimeFormat === "Standard Time") {
          const timeSplit = time.split("T");
          if (timeSplit?.length > 1) {
            timeParts = timeSplit[1].substr(0, 5).split(":");
          } else {
            timeParts = [];
          }
          let hours = parseInt(timeParts[0], 10);
          const minutes = timeParts[1];
    
          // Convert 24-hour format to 12-hour format and determine AM or PM
          const amPm = hours >= 12 ? "PM" : "AM";
          hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format
    
          formattedTime = `${hours}:${minutes} ${amPm}`;
        } else if (globalTimeFormat === "Military Time") {
          const timeSplit = time.split("T");
          if (timeSplit?.length > 1) {
            timeParts = timeSplit[1].substr(0, 5).split(":");
          } else {
            timeParts = [];
          }
          let hours = parseInt(timeParts[0], 10);
          const minutes = timeParts[1];
    
          formattedTime = `${hours}:${minutes}`;
        }
    
        return <td>{formattedTime}</td>;
      }

    if(header === "Date"
    || header === "Date From"
    || header === "Date To"
    || header === "Date Processed"
    || header === "Request Date"
    ){
        const date = new Date(_cell.render("Cell").props.value);
        if(!date) {
            return (
                <td>
                    null
                </td>
            );
        }

        const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
        const dd = date.getDate();
        const yyyy = date.getFullYear();

        const formattedDateFrom = `${mm}/${dd}/${yyyy}`;
        
        return(
            <td>
                {formattedDateFrom}
            </td>
        )
    }

    if (header === "") {
        return(
            <td>
                <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                    <TooltipManage text="View">
                        <div style={{padding:"0 5px"}} onClick={()=>editHandleClick(data)}><RemoveRedEyeIcon/></div>
                    </TooltipManage>
                </div>
            </td>
        )
    }

    return (
        <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>
    )
}
function CreateTableTransaction({ dataList = [], 
    dataHeader = [], 
    dataAccessor = [], 
    viewHandleClick, 
    editHandleClick,
    deleteHandleClick,
    viewImage,
    approvals, 
    hierarchy, 
    listOfEmployees,
    overtimeRequestData,
    leaveRequestData,
    changeOfScheduleData,
    changeLogRequestData,
    
    currentPage, setCurrentPage
}) {
    const itemsPerPage = 7;

    const columns = React.useMemo(() =>
        dataHeader.map((header, index) => ({
            Header: header,
            accessor: dataAccessor[index]
        })),
        [dataHeader, dataAccessor]
    );

    const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setSortBy
    } = useTable(
        {
            columns,
            data: dataList,
            initialState: {
                sortBy: sortHeaderValue.isDefault
                    ? []  // No sorting if it's default
                    : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
            }
        },
        useSortBy
    );

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    //Sorting Feature
    const sortState = [
        { id: 0, state: "default", textValue: "" },
        { id: 1, state: "ascending", textValue: "↑" },
        { id: 2, state: "descending", textValue: "↓" }
    ];

    const headerClick = (column) => {
        if (sortHeaderValue.id !== column.id) {
            // New column selected, start with ascending order
            setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
            setSortBy([{ id: column.id, desc: false }]);
        } else {
            // Toggle between sorting states (default -> ascending -> descending -> default)
            if (sortHeaderValue.isDefault) {
                setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
                setSortBy([{ id: column.id, desc: false }]);
            } else if (!sortHeaderValue.desc) {
                setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
                setSortBy([{ id: column.id, desc: true }]);
            } else {
                setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
                setSortBy([]); // Clear sorting
            }
        }
    };

    // Ensure sorting is reapplied on dataList reload
    useEffect(() => {
        if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
            setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
        }
    }, [dataList, setSortBy, sortHeaderValue]);

    return (
        <div>
            <table {...getTableProps()}>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th
                                    {...column.getHeaderProps()}
                                    onClick={() => headerClick(column)}
                                    className="sortable-header"
                                >
                                    {`${column.render("Header")} ${
                                        sortHeaderValue.id === column.id
                                            ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                                            : ""
                                    }`}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {dataList.length <= 0 &&
                        <tr>
                            <td colSpan={columns.length} style={{ textAlign: "center" }}>
                                No data to display
                            </td>
                        </tr>
                    }
                    {currentItems.map((row) => {
                        prepareRow(row)
                        return (
                            <tr key={row.original.id}
                            {...row.getRowProps()}
                            >
                                {row.cells.map((cell) => (
                                    <SetInfoTransaction header={cell.render("Cell").props.column.Header} 
                                        _cell={cell}
                                        viewHandleClick={viewHandleClick}
                                        editHandleClick={editHandleClick}
                                        deleteHandleClick={deleteHandleClick}
                                        viewImage={viewImage}
                                        approvals={approvals}
                                        hierarchy={hierarchy}
                                        listOfEmployees={listOfEmployees}
                                        dataList={dataList}
                                        overtimeRequestData={overtimeRequestData}
                                        leaveRequestData={leaveRequestData}
                                        changeOfScheduleData={changeOfScheduleData}
                                        changeLogRequestData={changeLogRequestData}
                                    />
                                ))}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            {rows.length > itemsPerPage ? (
            <div>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px" }}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px" }}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"26px"}}>
                        &gt;&gt;
                    </button>
                </div>
                {`${currentPage}/${totalPages}`}
            </div>
            ) :
            <></>}
        </div>
    )
}
function SetInfoTransaction({header, 
    _cell, 
    viewHandleClick, 
    editHandleClick,
    deleteHandleClick,
    viewImage,
    approvals, 
    hierarchy, 
    listOfEmployees, 
    dataList,
    overtimeRequestData,
    leaveRequestData,
    changeOfScheduleData,
    changeLogRequestData,
}) {
    const data = _cell.render("Cell").props.row.original;
    const value = _cell.render("Cell").props.value;

    if (header === "Photo") {
        if (header === "Photo") {
            if(data.photo){
                const imageSrc = 'data:image/jpeg;base64,' + data.photo;
    
                return(
                    <td>
                        <img className="avatarImg" src={imageSrc} alt=""/>
                    </td>
                )
            }
            return(
                <td>
                    <img className="avatarImg" src="images/sample.jpg" alt=""/>
                </td>
            )
        }
        
        if(value === "" || value === null || value === undefined){
            return(
                <td>
                    <img className="avatarImg" src="images/sample.jpg" alt=""/>
                </td>
            )
        } else {
            return(
                <td>
                    <img className="avatarImg" src="images/sample.jpg" alt=""/>
                </td>
            )
        }
    }

    if (header === "Track Approvers") {
        const trackApproval = data.approval;
        
        if(!trackApproval){
            return(
                <td>
                    <>
                        {`Primary Approver: Pending`}
                        <br />
                        <br />
                        {`Secondary Approver: Pending`}
                        <br />
                        <br />
                        {`Tertiary Approver: Pending`}
                        <br />
                        <br />
                    </>
                </td>
            )
        }

        return(
            <td>
                    <>

                        { trackApproval.primaryApproverId !== undefined &&
                            <>
                                <span>{`Primary Approver: `}</span>
                                <span style={{padding: "1px 5px"}} className={trackApproval.primaryApproverStatus}>{`${trackApproval.primaryApproverStatus !== "" ? trackApproval.primaryApproverStatus : "Pending"}`}</span>
                                { (trackApproval.primaryApproverStatus === "Approved" || trackApproval.primaryApproverStatus === "Disapproved") &&
                                trackApproval.primaryApproverFullName &&
                                    <span style={{padding: "1px 5px"}}>{`- ${trackApproval.primaryApproverFullName}`}</span>
                                }
                                <br />
                                <br />
                            </>
                        }
                        { trackApproval.secondaryApproverId !== undefined &&
                            <>
                                <span>{`Secondary Approver: `}</span>
                                <span style={{padding: "1px 5px"}} className={trackApproval.secondaryApproverStatus}>{`${trackApproval.secondaryApproverStatus !== "" ? trackApproval.secondaryApproverStatus : "Pending"}`}</span>
                                { (trackApproval.secondaryApproverStatus === "Approved" || trackApproval.secondaryApproverStatus === "Disapproved") &&
                                trackApproval.secondaryApproverFullName &&
                                    <span style={{padding: "1px 5px"}}>{`- ${trackApproval.secondaryApproverFullName}`}</span>
                                }
                                <br />
                                <br />
                            </>
                        }
                        { trackApproval.tertiaryApproverId !== undefined &&
                            <>
                                <span>{`Tertiary Approver: `}</span>
                                <span style={{padding: "1px 5px"}} className={trackApproval.tertiaryApproverStatus}>{`${trackApproval.tertiaryApproverStatus !== "" ? trackApproval.tertiaryApproverStatus : "Pending"}`}</span>
                                { (trackApproval.tertiaryApproverStatus === "Approved" || trackApproval.tertiaryApproverStatus === "Disapproved") &&
                                trackApproval.tertiaryApproverFullName &&
                                    <span style={{padding: "1px 5px"}}>{`- ${trackApproval.tertiaryApproverFullName}`}</span>
                                }
                                <br />
                                <br />
                            </>
                        }
                    </>
            </td>
        )
    }

    if(header === "Uploaded Image"){
        if(data.requestTypeId === 1){ //Leave
            if(leaveRequestData.length <= 0){ return(<td></td>) }
            const foundData = leaveRequestData.find(_data => _data.id === data.id)
            if(foundData.content){
                return(
                    <td>
                        <div className="emp-transac-manage row"  style={{alignItems:"center", justifyContent:"center"}}>
                            <TooltipManage text="View Image">
                                <div style={{padding:"0 5px"}} onClick={()=>viewImage(foundData)}><ImageIcon/></div>
                            </TooltipManage>
                        </div>
                    </td>
                )
            }
            return(
                <td>
                </td>
            )
        } else if(data.requestTypeId === 2){ //Change Schedule
            if(changeOfScheduleData.length <= 0){ return(<td></td>) }
            const foundData = changeOfScheduleData.find(_data => _data.id === data.id)
            if(foundData.content){
                return(
                    <td>
                        <div className="emp-transac-manage row"  style={{alignItems:"center", justifyContent:"center"}}>
                            <TooltipManage text="View Image">
                                <div style={{padding:"0 5px"}} onClick={()=>viewImage(foundData)}><ImageIcon/></div>
                            </TooltipManage>
                        </div>
                    </td>
                )
            }
            return(
                <td>
                </td>
            )
        } else if(data.requestTypeId === 3){ //OT
            if(overtimeRequestData.length <= 0){ return(<td></td>) }
            const foundData = overtimeRequestData.find(_data => _data.id === data.id)
            if(foundData.content){
                return(
                    <td>
                        <div className="emp-transac-manage row"  style={{alignItems:"center", justifyContent:"center"}}>
                            <TooltipManage text="View Image">
                                <div style={{padding:"0 5px"}} onClick={()=>viewImage(foundData)}><ImageIcon/></div>
                            </TooltipManage>
                        </div>
                    </td>
                )
            }
            return(
                <td>
                </td>
            )
        } else if(data.requestTypeId === 4){ // Change Log
            if(changeLogRequestData.length <= 0){ return(<td></td>) }
            const foundData = changeLogRequestData.find(_data => _data.id === data.id)
            if(foundData.content){
                return(
                    <td>
                        <div className="emp-transac-manage row"  style={{alignItems:"center", justifyContent:"center"}}>
                            <TooltipManage text="View Image">
                                <div style={{padding:"0 5px"}} onClick={()=>viewImage(foundData)}><ImageIcon/></div>
                            </TooltipManage>
                        </div>
                    </td>
                )
            }
            return(
                <td>
                </td>
            )
        }
    }

    if(header === "Reference No."){
        const formattedNumber = value.toString().padStart(6, '0');

        if(data.requestTypeId === 1){
            return (
                <td>
                    LV-{formattedNumber}
                </td>
            );
        } else if(data.requestTypeId === 2){
            return (
                <td>
                    CS-{formattedNumber}
                </td>
            );
        } else if(data.requestTypeId === 3){
            return (
                <td>
                    OT-{formattedNumber}
                </td>
            );
        } else if(data.requestTypeId === 4){
            return (
                <td>
                    CH-{formattedNumber}
                </td>
            );
        } else if(data.requestTypeId === 5){
            return (
                <td>
                    OS-{formattedNumber}
                </td>
            );
        } else if(data.requestTypeId === 6){
            return (
                <td>
                    OB-{formattedNumber}
                </td>
            );
        } 
    }

    if(header === "Type"){
        const foundData = dataList.find(dataInfo => (dataInfo.requestTypeId === data.requestTypeId) && (dataInfo.id === data.id)) 

        if(foundData.requestTypeId === 1) { // Leave
            if(leaveRequestData.length <= 0){ return(<td></td>) }
            const foundDataLeave = leaveRequestData.find(request => request.id === foundData.id);
            return (
                <td>
                    {foundDataLeave.leaveTypeDescription}
                </td>
            );
        } else if(foundData.requestTypeId === 2) { // Change Schedule
            return (
                <td>
                    {"-"}
                </td>
            );
        } else if(foundData.requestTypeId === 3) { // OT
            if(overtimeRequestData.length <= 0){ return(<td></td>) }
            const foundDataOT = overtimeRequestData.find(request => request.id === foundData.id);
            return (
                <td>
                    {foundDataOT.overtimeType}
                </td>
            );
        } else if(foundData.requestTypeId === 4) { // Change Log
            if(changeLogRequestData.length <= 0){ return(<td></td>) }
            const foundDataChangeLog = changeLogRequestData.find(request => request.id === foundData.id);
            return (
                <td>
                    {`Time - ${foundDataChangeLog.timeType}`}
                </td>
            );
        }
    }

    if (header === "Status") {
        let convertedValue = value;

        if(convertedValue === "Sent"){
            convertedValue = "Pending";
        }
        return(
            <td className={convertedValue}>
                {convertedValue}
            </td>
        )
    }

    if( header === "Time In"
    || header === "Time Out"
    || header === "Time Rendered"
    ){
        const time = _cell.render("Cell").props.value;

        if (!time) {
            return (
                <td>
                    null
                </td>
            );
        }
    
        let formattedTime = '';
    
        // Attempt to parse the time if it’s not already in ISO format
        let date;
        if (time.includes('T')) {
            date = new Date(time);
        } else {
            // If the time is not in ISO format, manually create the date
            const currentDate = new Date(); // Get current date for the date portion
            const [hours, minutes] = time.split(':').map(part => parseInt(part, 10));
    
            if (isNaN(hours) || isNaN(minutes)) {
                return (
                    <td>
                        Invalid time format
                    </td>
                );
            }
    
            date = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), hours, minutes);
        }
    
        if (isNaN(date.getTime())) {
            return (
                <td>
                    Invalid time format
                </td>
            );
        }
    
        // Convert to desired format YYYY-MM-DDTHH:mm
        // const year = date.getFullYear();
        // const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        // const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
    
        // const formattedDateTime = `${year}-${month}-${day}T${hours}:${minutes}`;
    
        // console.log(formattedDateTime); // Logs the converted time for debugging
    
        // Further formatting based on globalTimeFormat
        if (globalTimeFormat === "Standard Time") {
            const amPm = date.getHours() >= 12 ? 'PM' : 'AM';
            const standardHours = (date.getHours() % 12) || 12; // Convert 0 to 12 for 12-hour format
    
            formattedTime = `${standardHours}:${minutes} ${amPm}`;
        } else if (globalTimeFormat === "Military Time") {
            formattedTime = `${hours}:${minutes}`;
        }
    
        return (
            <td>
                {formattedTime}
            </td>
        );
    }

    if(header === "Date"
    || header === "Date From"
    || header === "Date To"
    || header === "Date Processed"
    || header === "Request Date"
    ){
        const date = new Date(_cell.render("Cell").props.value);
        if(!date) {
            return (
                <td>
                    null
                </td>
            );
        }

        const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
        const dd = date.getDate();
        const yyyy = date.getFullYear();

        const formattedDateFrom = `${mm}/${dd}/${yyyy}`;
        
        return(
            <td>
                {formattedDateFrom}
            </td>
        )
    }

    if (header === "") {
        return(
            <td>
                <div className="emp-transac-manage row"  style={{alignItems:"center", justifyContent:"center"}}>
                    <TooltipManage text="Update">
                        <div style={{padding:"0 5px"}} onClick={()=>editHandleClick(data)}><EditIcon/></div>
                    </TooltipManage>
                    <TooltipManage text="Cancel">
                        <div style={{padding:"0 5px"}} onClick={()=>deleteHandleClick(data)}><NotInterestedIcon/></div>
                    </TooltipManage>
                    <TooltipManage text="View">
                        <div style={{padding:"0 5px"}} onClick={()=>viewHandleClick(data)}><RemoveRedEyeIcon/></div>
                    </TooltipManage>
                </div>
            </td>
        )
    }

    return (
        <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>
    )
}
function CreateTableItinerary({ dataList = [], 
    setDataList,
    dataHeader = [], 
    dataAccessor = [], 
    editHandleClick, 
    deleteHandleClick, 
    isItinerayAddState,
    setIsItinerayAddState,
    isItinerayUpdateState,
    setIsItinerayUpdateState,
    isItinerayDeleteState,
    setIsItinerayDeleteState,
    itineraryTimeIn,
    setItineraryTimeIn,
    itineraryTimeOut,
    setItineraryTimeOut,
    itineraryLocation,
    setItineraryLocation,
    openItinerary
}) {
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [idCounter, setIdCounter] = useState(0);
    const [recoveredData, setRecoveredData] = useState([]);

    const columns = React.useMemo(() =>
        dataHeader.map((header, index) => ({
            Header: header,
            accessor: dataAccessor[index]
        })),
        [dataHeader, dataAccessor]
    );

    const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setSortBy
    } = useTable(
        {
            columns,
            data: dataList,
            initialState: {
                sortBy: sortHeaderValue.isDefault
                    ? []  // No sorting if it's default
                    : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
            }
        },
        useSortBy
    );

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    const newData = {
        changeLogRequestId: idCounter + 1,
        timeIn: itineraryTimeIn,
        timeOut: itineraryTimeOut,
        location: itineraryLocation,
    }

    const saveAdd = () =>{
        setIdCounter(idCounter + 1);
        setIsItinerayAddState(false);
        setIsItinerayUpdateState(false);
        setDataList(prevDataList => [
            ...prevDataList, 
            newData
        ]);

        setItineraryTimeIn("");
        setItineraryTimeOut("");
        setItineraryLocation("");
    }

    const cancelAdd = () =>{
        setIsItinerayAddState(false);

        setItineraryTimeIn("");
        setItineraryTimeOut("");
        setItineraryLocation("");
    }

    const updateClick = (data) =>{
        setRecoveredData(data);
        setItineraryTimeIn(data.timeIn);
        setItineraryTimeOut(data.timeOut);
        setItineraryLocation(data.location);
        const foundData = dataList.find(_data => _data.changeLogRequestId === data.changeLogRequestId);

        setDataList(prevDataList => 
            prevDataList.filter(_data => _data.changeLogRequestId !== foundData.changeLogRequestId)
        );

        setIsItinerayUpdateState(true);
    }
    const cancelUpdate = () =>{
        setIdCounter(idCounter + 1);

        const oldData = {
            changeLogRequestId: recoveredData.changeLogRequestId,
            timeIn: recoveredData.timeIn,
            timeOut: recoveredData.timeOut,
            location: recoveredData.location,
        }

        setDataList(prevDataList => [
            ...prevDataList, 
            oldData
        ]);

        setItineraryTimeIn("");
        setItineraryTimeOut("");
        setItineraryLocation("");

        setIsItinerayUpdateState(false);
    }
    const deleteClick = (data) =>{
        const foundData = dataList.find(_data => _data.changeLogRequestId === data.changeLogRequestId);

        setDataList(prevDataList => 
            prevDataList.filter(_data => _data.changeLogRequestId !== foundData.changeLogRequestId)
        );
    }

    //Sorting Feature
    const sortState = [
        { id: 0, state: "default", textValue: "" },
        { id: 1, state: "ascending", textValue: "↑" },
        { id: 2, state: "descending", textValue: "↓" }
    ];

    const headerClick = (column) => {
        if (sortHeaderValue.id !== column.id) {
            // New column selected, start with ascending order
            setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
            setSortBy([{ id: column.id, desc: false }]);
        } else {
            // Toggle between sorting states (default -> ascending -> descending -> default)
            if (sortHeaderValue.isDefault) {
                setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
                setSortBy([{ id: column.id, desc: false }]);
            } else if (!sortHeaderValue.desc) {
                setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
                setSortBy([{ id: column.id, desc: true }]);
            } else {
                setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
                setSortBy([]); // Clear sorting
            }
        }
    };

    // Ensure sorting is reapplied on dataList reload
    useEffect(() => {
        if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
            setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
        }
    }, [dataList, setSortBy, sortHeaderValue]);

    return (
        <div>
            <table {...getTableProps()}>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th
                                    {...column.getHeaderProps()}
                                    onClick={() => headerClick(column)}
                                    className="sortable-header"
                                >
                                    {`${column.render("Header")} ${
                                        sortHeaderValue.id === column.id
                                            ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                                            : ""
                                    }`}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {isItinerayAddState &&
                        <tr>
                            <td>
                                <TimeInput date={itineraryTimeIn} setDate={setItineraryTimeIn}/>
                            </td>
                            <td>
                                <TimeInput date={itineraryTimeOut} setDate={setItineraryTimeOut}/>
                            </td>
                            <td>
                                <input
                                    placeholder="Enter location"
                                    value={itineraryLocation}
                                    onChange={(e) => setItineraryLocation(e.target.value)}
                                    style={{color: "gray",
                                        height: "30px",
                                        borderRadius: "3px",
                                        border: "1px solid #80808080",
                                        outline: "none",
                                        width: "90%"
                                    }}
                                />
                            </td>
                            <td>
                                <div className="row itinerary-manage"  style={{alignItems:"center", justifyContent:"center"}}>
                                    <TooltipManage text="Save">
                                        <div style={{padding:"0 5px"}} onClick={saveAdd}><SaveIcon/></div>
                                    </TooltipManage>
                                    <TooltipManage text="Cancel">
                                        <div style={{padding:"0 5px"}} onClick={cancelAdd}><DoDisturbIcon/></div>
                                    </TooltipManage>
                                </div>
                            </td>
                        </tr>
                    }
                    {isItinerayUpdateState &&
                        <tr>
                            <td>
                                <TimeInput date={itineraryTimeIn} setDate={setItineraryTimeIn}/>
                            </td>
                            <td>
                                <TimeInput date={itineraryTimeOut} setDate={setItineraryTimeOut}/>
                            </td>
                            <td>
                                <input
                                    placeholder="Enter location"
                                    value={itineraryLocation}
                                    onChange={(e) => setItineraryLocation(e.target.value)}
                                    style={{color: "gray",
                                        height: "30px",
                                        borderRadius: "3px",
                                        border: "1px solid #80808080",
                                        outline: "none",
                                        width: "90%"
                                    }}
                                />
                            </td>
                            <td>
                                <div className="row itinerary-manage"  style={{alignItems:"center", justifyContent:"center"}}>
                                    <TooltipManage text="Save">
                                        <div style={{padding:"0 5px"}} onClick={saveAdd}><SaveIcon/></div>
                                    </TooltipManage>
                                    <TooltipManage text="Cancel">
                                        <div style={{padding:"0 5px"}} onClick={cancelUpdate}><DoDisturbIcon/></div>
                                    </TooltipManage>
                                </div>
                            </td>
                        </tr>
                    }
                    {currentItems.map((row) => {
                        prepareRow(row)
                        return (
                            <tr key={row.original.id}
                            {...row.getRowProps()}
                            >
                                {row.cells.map((cell) => (
                                    SetInfoItinerary(cell.render("Cell").props.column.Header, 
                                            cell,
                                            updateClick,
                                            deleteClick,
                                            openItinerary)
                                ))}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            {rows.length > itemsPerPage ? (
            <div>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px", height:"26px" }}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"26px"}}>
                        &gt;&gt;
                    </button>
                </div>
                {`${currentPage}/${totalPages}`}
            </div>
            ) :
            <></>}
        </div>
    )
}
function SetInfoItinerary(header, _cell, editHandleClick, deleteHandleClick, openItinerary) {
    const data = _cell.render("Cell").props.row.original;

    if (header === "") {
        return(
            <td>
                <div className="itinerary row"  style={{alignItems:"center", justifyContent:"center"}}>
                    <TooltipManage text="Update">
                        <div style={{padding:"0 5px"}} onClick={()=>editHandleClick(data)}><ModeEditIcon/></div>
                    </TooltipManage>
                    { deleteHandleClick ? 
                    <TooltipManage text="Delete">
                        <div style={{padding:"0 5px"}} onClick={()=>deleteHandleClick(data)}><DeleteForeverIcon/></div>
                    </TooltipManage>
                    :
                    <></>
                    }
                </div>
            </td>
        )
    }

    if (header === "Itinerary") {
        return(
            <td>
                <div className="itineary-control row"  style={{alignItems:"center", justifyContent:"center"}}>
                    <TooltipManage text="View">
                        <div style={{padding:"0 5px"}} onClick={()=>openItinerary(data)}><ListIcon/></div>
                    </TooltipManage>
                </div>
            </td>
        )
    }

    if(header === "Uploaded Image"){
        if(data.content){
            const imageSrc = 'data:image/jpeg;base64,' + data.content;

            return(
                <td>
                    <img className="" src={imageSrc} alt="" style={{width: "250px", height: "auto"}}/>
                </td>
            )
        }
        return(
            <td>
                <img className="" src="" alt=""/>
            </td>
        )
    }

    if( header === "Time In"
    || header === "Time Out"
    || header === "Time Rendered"
    ){
        const time = _cell.render("Cell").props.value;

        if (!time) {
            return (
                <td>
                    null
                </td>
            );
        }
    
        let formattedTime = '';
    
        // Attempt to parse the time if it’s not already in ISO format
        let date;
        if (time.includes('T')) {
            date = new Date(time);
        } else {
            // If the time is not in ISO format, manually create the date
            const currentDate = new Date(); // Get current date for the date portion
            const [hours, minutes] = time.split(':').map(part => parseInt(part, 10));
    
            if (isNaN(hours) || isNaN(minutes)) {
                return (
                    <td>
                        Invalid time format
                    </td>
                );
            }
    
            date = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), hours, minutes);
        }
    
        if (isNaN(date.getTime())) {
            return (
                <td>
                    Invalid time format
                </td>
            );
        }
    
        // Convert to desired format YYYY-MM-DDTHH:mm
        // const year = date.getFullYear();
        // const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        // const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
    
        // const formattedDateTime = `${year}-${month}-${day}T${hours}:${minutes}`;
    
        // console.log(formattedDateTime); // Logs the converted time for debugging
    
        // Further formatting based on globalTimeFormat
        if (globalTimeFormat === "Standard Time") {
            const amPm = date.getHours() >= 12 ? 'PM' : 'AM';
            const standardHours = (date.getHours() % 12) || 12; // Convert 0 to 12 for 12-hour format
    
            formattedTime = `${standardHours}:${minutes} ${amPm}`;
        } else if (globalTimeFormat === "Military Time") {
            formattedTime = `${hours}:${minutes}`;
        }
    
        return (
            <td>
                {formattedTime}
            </td>
        );
    }

    if(header === "Date"
    || header === "Date From"
    || header === "Date To"
    || header === "Date Processed"
    || header === "Request Date"
    || header === "Date Requested"
    ){
        const date = new Date(_cell.render("Cell").props.value);
        if(!date) {
            return (
                <td>
                    null
                </td>
            );
        }

        const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
        const dd = date.getDate();
        const yyyy = date.getFullYear();

        const formattedDateFrom = `${mm}/${dd}/${yyyy}`;
        
        return(
            <td>
                {formattedDateFrom}
            </td>
        )
    }

    return (
        <td {..._cell.getCellProps()}> {
            _cell.render("Cell")
            }
        </td>
    )
}
function Filter(setFilterDataIndex){
    const [selectedOption, setSelectedOption] = useState('');

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "EmployeeId":
                setFilterDataIndex(1);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange} style={{color: "rgb(104, 104, 104)"}}>
            <option value="All">All</option>
            <option value="EmployeeId">Employee Id</option>
        </select>
    );
};
function ClassificationFilter1({classificationId, setClassificationId}){
    const handleSelectChange = (event) => {
        setClassificationId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = useCallback(async () => {
        const apiUrl = domain + "/api/Classification/active";
        
        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // Include other headers if needed
                }
            });

            setData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return (
        <select id="employee-select-PagibigReport" value={classificationId} onChange={handleSelectChange} style={{color: "rgb(104, 104, 104)"}}>
            <option value={"0"}>All</option>
            {data.map((classificationId) => ( 
                SetClassificationId(classificationId)
            ))}
        </select>
    );
};
function SetClassificationId(classificationId){
    return(
        <option value={classificationId.id}>{
            classificationId.description}
        </option>
    )
}
function LocationIdSelect({locationId, setLocationId}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setLocationId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Location/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.description.localeCompare(b.description));
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(locationId !== "" && locationId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [locationId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={locationId} onChange={handleSelectChange}style={{ height: "30px", color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="0" >All</option>
            {data.map((locationId) => ( 
                SetLocationId(locationId)
            ))}
            </select>
        </div>
    );
};
function SetLocationId(locationId){
    return(
        <option value={locationId.id}>{
            locationId.description}
        </option>
    )

}
const TooltipManage = ({ text, children }) => {
    const [show, setShow] = useState(false);

    const handleMouseEnter = () => {
        setShow(true);
    };

    const handleMouseLeave = () => {
        setShow(false);
    };

    return (
        <div style={{ position: 'relative', display: 'inline-block',zIndex:"1" }}>
            <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            {children}
            </div>
            {show && (
            <div
                style={{
                position: 'absolute',
                top: '50%',
                left: '-50%',
                transform: 'translateX(-50%)',
                backgroundColor: 'white',
                color: 'gray',
                padding: '5px',
                borderRadius: '5px',
                pointerEvents: "none",
                boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
                }}
            >
                {text}
            </div>
            )}
        </div>
    );
};
function ClearGeneralForm({isOpen, 
    onClose, 
    handleDelete}
){
    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Cancel!</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <span>Are you sure you want to cancel this request?</span>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>{handleDelete(e); handleClose()}}
                            style={{marginRight:"5px"}}>
                                YES
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={()=>handleClose()}>
                                NO
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function ViewImage({isOpen, 
    onClose,
    viewImageData
})
{
    const [imageSource, setImageSource] = useState("");

    const handleClose = () => {
        onClose();
    };

    useEffect(() => {
        if (isOpen && viewImageData.content instanceof File) {
            const reader = new FileReader();
            
            reader.onloadend = () => {
                // Once the file is read, set the image source to the base64 data
                setImageSource(reader.result);
            };
    
            // Read the file as a Data URL (which includes the base64 encoding)
            reader.readAsDataURL(viewImageData.content);
        }
    }, [isOpen, viewImageData]);

    const [isImageModalOpen, setIsImageModalOpen] = useState(false);
    const openImage = () => {
        setIsImageModalOpen(true); // Open image in full view
    };
    
    const closeImageModal = () => {
        setIsImageModalOpen(false); // Close full image modal
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Uploaded Image</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                            <img className="modal-events-image" src={imageSource} alt="" style={{width: "250px", height: "auto"}} onClick={openImage}/>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="cancel row"
                            style={{height: "34px", borderRadius: "3px"}}
                            onClick={handleClose}>
                                Close
                        </button>
                    </div>
                </div>
            )}
            </div>

            {/* Full Image Modal */}
            {isImageModalOpen && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0, 0, 0, 0.8)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 9999
                    }}
                    onClick={closeImageModal} // Click outside to close
                >
                    <img
                        src={imageSource}
                        alt="Full view"
                        style={{ maxWidth: "90%", maxHeight: "90%" }}
                    />
                </div>
            )}
        </>
    );
}
function AnnouncementModal({isOpen, 
    onClose,
    content,
    image
})
{
    const [imageSrc, setImageSrc] = useState(null);

    useEffect(() => {
        const fetchImage = async () => {
            if (image) {
                const src = await convertImage(image);
                setImageSrc(src);
            }
        };

        fetchImage();
    }, [image]);

    const convertImage = async (crpytImage) => {
        if (crpytImage) {
            const imageSrc = 'data:image/jpeg;base64,' + crpytImage;
            return imageSrc;
        }
        return null;
    };
    
    const handleClose = () => {
        onClose();
    };

    const [isImageModalOpen, setIsImageModalOpen] = useState(false);
    const openImage = () => {
        setIsImageModalOpen(true); // Open image in full view
    };
    
    const closeImageModal = () => {
        setIsImageModalOpen(false); // Close full image modal
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Announcement</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div dangerouslySetInnerHTML={{ __html: content.replace(/\n/g, "<br />") }} />
                        <div style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                padding: "20px 0"
                            }}
                        >
                            {imageSrc && (
                                <img className="modal-events-image" src={imageSrc} alt="" style={{ width: "250px", height: "auto" }} onClick={openImage}/>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={handleClose}>
                                Close
                        </button>
                    </div>
                </div>
            )}
            </div>

            {/* Full Image Modal */}
            {isImageModalOpen && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0, 0, 0, 0.8)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 9999
                    }}
                    onClick={closeImageModal} // Click outside to close
                >
                    <img
                        src={imageSrc}
                        alt="Full view"
                        style={{ maxWidth: "90%", maxHeight: "90%" }}
                    />
                </div>
            )}
        </>
    );
}
function MemoModal({isOpen, 
    onClose,
    content,
    image
})
{
    const [imageSrc, setImageSrc] = useState(null);

    useEffect(() => {
        const fetchImage = async () => {
            if (image) {
                const src = await convertImage(image);
                setImageSrc(src);
            }
        };

        fetchImage();
    }, [image]);

    const convertImage = async (crpytImage) => {
        if (crpytImage) {
            const imageSrc = 'data:image/jpeg;base64,' + crpytImage;
            return imageSrc;
        }
        return null;
    };

    const handleClose = () => {
        onClose();
    };

    const [isImageModalOpen, setIsImageModalOpen] = useState(false);
    const openImage = () => {
        setIsImageModalOpen(true); // Open image in full view
    };
    
    const closeImageModal = () => {
        setIsImageModalOpen(false); // Close full image modal
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Memo</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div dangerouslySetInnerHTML={{ __html: content.replace(/\n/g, "<br />") }} />
                        <div style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                padding: "20px 0"
                            }}
                        >
                            {imageSrc && (
                                <img className="modal-events-image" src={imageSrc} alt="" style={{ width: "250px", height: "auto" }} onClick={openImage}/>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={handleClose}>
                                Close
                        </button>
                    </div>
                </div>
            )}
            </div>

            {/* Full Image Modal */}
            {isImageModalOpen && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0, 0, 0, 0.8)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 9999
                    }}
                    onClick={closeImageModal} // Click outside to close
                >
                    <img
                        src={imageSrc}
                        alt="Full view"
                        style={{ maxWidth: "90%", maxHeight: "90%" }}
                    />
                </div>
            )}
        </>
    );
}
function AttachmentForm({
    isOpen,
    onClose,
    modalName,
    data
}) {

    // console.log({data})

    const handleClose = () => {
        onClose();
    };

    const base64Data = data;

    // Detect file type from Base64 signature
    const getMimeType = (base64) => {
        if (!base64) return null;

        if (base64.startsWith("/9j/")) {
            return "image/jpeg";
        }

        if (base64.startsWith("iVBORw0KGgo")) {
            return "image/png";
        }

        if (base64.startsWith("R0lGOD")) {
            return "image/gif";
        }

        if (base64.startsWith("JVBERi0")) {
            return "application/pdf";
        }

        // Excel XLSX / DOCX / other Office files
        if (base64.startsWith("UEsDB")) {
            return "application/zip";
        }

        return "application/octet-stream";
    };

    const mimeType = getMimeType(base64Data);

    const fileUrl = base64Data
        ? `data:${mimeType};base64,${base64Data}`
        : null;

    const isImage = mimeType?.startsWith("image/");
    const isPdf = mimeType === "application/pdf";

    const downloadFile = () => {
        if (!fileUrl) return;

        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = "attachment";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
                {isOpen && (
                    <div className="modal">

                        {/* HEADER */}
                        <div className="popUp-header row">
                            <div className="popUp-title">
                                <h3 style={{ color: "#668fca" }}>
                                    {modalName}
                                </h3>
                            </div>

                            <div className="popUp-close">
                                <CloseIcon onClick={handleClose} />
                            </div>
                        </div>


                        {/* BODY */}
                        <div className="popUp-body loan-history-table user-template-body">

                            <div className="flex flex-col items-center justify-center w-full min-h-[400px] p-6">

                                {!base64Data && (
                                    <div className="text-gray-500">
                                        No attachment available.
                                    </div>
                                )}


                                {/* IMAGE */}
                                {isImage && fileUrl && (
                                    <div className="flex items-center justify-center w-full">

                                        <img
                                            src={fileUrl}
                                            alt="Attachment"
                                            className="max-w-full max-h-[600px] object-contain rounded-lg shadow"
                                        />

                                    </div>
                                )}


                                {/* PDF */}
                                {isPdf && fileUrl && (
                                    <iframe
                                        src={fileUrl}
                                        title="PDF Attachment"
                                        className="w-full h-[600px] border rounded-lg"
                                    />
                                )}


                                {/* OTHER FILES */}
                                {base64Data && !isImage && !isPdf && (
                                    <div className="flex flex-col items-center justify-center text-center">

                                        <div className="w-20 h-20 flex items-center justify-center bg-gray-100 rounded-full mb-4">
                                            <span className="text-4xl">
                                                📄
                                            </span>
                                        </div>

                                        <h4 className="text-lg font-semibold text-gray-700 mb-4">
                                            Attachment
                                        </h4>

                                        <button
                                            type="button"
                                            onClick={downloadFile}
                                            className="px-5 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
                                        >
                                            Download File
                                        </button>

                                    </div>
                                )}

                            </div>

                        </div>


                        {/* FOOTER */}
                        <div
                            className="buttons row"
                            style={{
                                justifyContent: "center",
                                padding: "40px 40px 20px 40px"
                            }}
                        >
                        </div>

                    </div>
                )}
            </div>
        </>
    );
}


function DateTimeInput2({date, setDate, isView}) {
    const [isSelected, setIsSelected] = useState(false);

    const handleDateTimeChange = (event) => {
        setDate(event.target.value);
        setIsSelected(true);
    };

    useEffect(() => {
        if(date !== undefined && date !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [date]);

    let formattedDate = "";

    if(date){
        formattedDate = date.split('T')[0];
    }

    return (
        <div>
            <input
            readOnly={isView}
            type="date"
            id={"datetime-"}
            name="datetime"
            value={formattedDate} // Exclude milliseconds
            onChange={handleDateTimeChange}
            style={{width:"90%",
                height:"30px", 
                borderRadius:"3px", 
                border:"1px solid #80808080",
                color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
                fontFamily: "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif"
            }}
            />
        </div>
    );
}
function ViewOffsetForm({
    isOpen,
    onClose,
    employeePersonalInformationFullName, setEmployeePersonalInformationFullName,
    employeePersonalInformationId, setEmployeePersonalInformationId,
    references, setReferences,
    date, setDate,
    hours, setHours,
    type, setType,
    dateFrom, setDateFrom,
    dateTo, setDateTo,
    days, setDays,
    reason, setReason,
    files, setFiles,
    viewImage,
    

    content, setContent,
    gpsCam, setGPSCam,
}) {
    const [attachmentType, setAttachmentType] = useState(null)
    const [showViewForm, setShowViewForm] = useState(false)
    const [selectedData, setSelectedData] = useState(null)

    const openViewForm = () => {
        setShowViewForm(true)
    }
    const closeViewForm = () => {
        setShowViewForm(false)
    }

    const viewHandleClick = async (_data, _type) => {
        setSelectedData(_data)
        setAttachmentType(_type)
        openViewForm();
    }

    const handleClose = () => {
        onClose();
        setAttachmentType(null)
        setShowViewForm(false)
        setSelectedData(null)
    };

    const formatTime = (time) => {
        if(!time){
        return ""
        }

        let timeParts;
        let formattedTime;

        const timeSplit = time.split('T');
        if (timeSplit.length > 1) {
            timeParts = timeSplit[1].substr(0, 5).split(':');
        } else {
            timeParts = [];
        }
        let hours = parseInt(timeParts[0], 10);
        const minutes = timeParts[1];

        // Convert 24-hour format to 12-hour format and determine AM or PM
        const amPm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

        formattedTime = `${hours}:${minutes} ${amPm}`;

        return formattedTime
    }

    return (
        <>
        <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
            {isOpen && (
            <>
                <div className="modal">
                    <div className="popUp-header row">
                    <div className="popUp-title">
                        <h3 style={{ color: "#668fca" }}>Request Details</h3>
                    </div>
                    <div className="popUp-close">
                        <CloseIcon onClick={() => handleClose()} />
                    </div>
                    </div>
                    <div className="popUp-body">
                    <div className="popUp-item info-item column">
                        <div className="info-item-label">Employee</div>
                        <div className="info-item-input">
                        <input
                            readOnly={true}
                            id="employeePersonalInformationFullName"
                            placeholder="Employee"
                            value={employeePersonalInformationFullName}
                            onChange={(e) =>
                            setEmployeePersonalInformationFullName(e.target.value)
                            }
                            style={{ cursor: "not-allowed" }}
                        />
                        </div>
                    </div>
                    <div className="info-item-holder row">
                        {/* <div className="popUp-item info-item column">
                            <div className="info-item-label">References</div>
                            <div className="info-item-input">
                                {references.map((item) => {
                                    return (
                                    <div key={item.id} className="flex flex-row gap-5">
                                        <span>{item?.referenceDate ? `Date: ${item.referenceDate.split("T")[0]}` : ""}</span>
                                        <span>{item?.hours ? `Hours: ${item.hours}` : ""}</span>
                                    </div>
                                );
                                })}
                            </div>
                        </div> */}
                        
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">References</div>
                            <div className="info-item-input">
                                {references.map((item) => {
                                    return (
                                    <div key={item.id} className="attendance-card" style={{padding: "0", width: "90%"}}>
                                    <div className="attendance-info" style={{margin: "12px 12px"}}>
                                    {/* Date Section */}
                                        <div className="info-group">
                                            <span className="label label-date">Date</span>
                                            <span className="value">
                                            {item?.date ? item.date.split("T")[0] : "—"}
                                            </span>
                                        </div>

                                        {/* Time In Section */}
                                        <div className="info-group">
                                            <span className="label label-in">Time In</span>
                                            <span className="value font-bold">
                                            {item?.timeIn ? formatTime(item?.timeIn) : "—"}
                                            </span>
                                        </div>

                                        {/* Time Out Section */}
                                        <div className="info-group">
                                            <span className="label label-out">Time Out</span>
                                            <span className="value font-bold">
                                            {item?.timeOut ? formatTime(item?.timeOut) : "—"}
                                            </span>
                                        </div>
                                        </div>
                                    </div>
                                );
                                })}
                            </div>
                        </div>
                    </div>
                    <div className="info-item-holder row">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Date (To Use)</div>
                            <div className="info-item-input">
                            <DateTimeInput2 date={date} setDate={setDate} isView={true} />
                            </div>
                        </div>
                    </div>
                    <div className="popUp-item info-item column">
                        <div className="info-item-label">Reason</div>
                        <div className="info-item-input">
                        <textarea
                            id="tamper"
                            className="filterSelect"
                            style={{
                            width: "90%",
                            minHeight: "50px",
                            borderRadius: "3px",
                            border: "1px solid #80808080",
                            color: "rgb(104, 104, 104)",
                            }}
                            value={reason}
                            readOnly={true}
                        />
                        </div>
                    </div>
                    <div className="popUp-item info-item column hidden">
                        <div className="info-item-label">Upload</div>
                        <div className="info-item-input">
                        {files.length > 0 && (
                            <div
                            style={{ border: "1px solid #97979745", padding: "10px" }}
                            >
                            <span>Uploaded File:</span>
                            <ul>
                                {files.map((file, index) => (
                                <img
                                    src={file ? URL.createObjectURL(file) : ""}
                                    alt=""
                                    style={{ width: "150px", height: "auto" }}
                                    onClick={() => viewImage({ content: file })}
                                ></img>
                                ))}
                            </ul>
                            </div>
                        )}
                        </div>
                    </div>

                    

                    <div className='flex flex-col gap-5'>

                        {/* GPS CAM */}
                        <div className='flex flex-col gap-1'>
                            <div className='flex flex-row gap-2 items-center'>
                                <div className="info-item-label">GPS Cam</div>

                                <button
                                    type="button"
                                    className='cursor-pointer rounded-sm bg-sky-400 hover:bg-sky-500 text-white px-2 py-1'
                                    onClick={() => viewHandleClick(gpsCam, "GPS Cam")}
                                    disabled={!gpsCam}
                                >
                                    View
                                </button>
                            </div>

                            <div className="!border !border-gray-300 rounded-md text-xs text-gray-500 mt-1 px-2 py-1">
                                {gpsCam instanceof File
                                    ? gpsCam.name
                                    : gpsCam
                                        ? "Existing GPS Cam file"
                                        : "No file"
                                }
                            </div>
                        </div>


                        {/* PROOF OF APPROVAL */}
                        <div className='flex flex-col gap-1'>
                            <div className='flex flex-row gap-2 items-center'>
                                <div className="info-item-label">Proof of Approval</div>

                                <button
                                    type="button"
                                    className='cursor-pointer rounded-sm bg-sky-400 hover:bg-sky-500 text-white px-2 py-1'
                                    onClick={() => viewHandleClick(content, "Proof of Approval")}
                                    disabled={!content}
                                >
                                    View
                                </button>
                            </div>

                            <div className="!border !border-gray-300 rounded-md text-xs text-gray-500 mt-1 px-2 py-1">
                                {content instanceof File
                                    ? content.name
                                    : content
                                        ? "Existing Proof of Approval file"
                                        : "No file"
                                }
                            </div>
                        </div>

                    </div>
                    </div>
                    <div
                    className="buttons row"
                    style={{ justifyContent: "end", padding: "20px 40px" }}
                    >
                    <button
                        id="add-family"
                        className="cancel row"
                        onClick={handleClose}
                    >
                        Close
                    </button>
                    </div>
                </div>
                    
                <AttachmentForm 
                    isOpen={showViewForm}
                    onClose={closeViewForm}
                    modalName={attachmentType}
                    data={selectedData}
                />
            </>
            )}
        </div>
        </>
    );
}
function EditOffsetForm({
    isOpen,
    onClose,
    editData,
    employeePersonalInformationFullName, setEmployeePersonalInformationFullName,
    employeePersonalInformationId, setEmployeePersonalInformationId,
    references, setReferences,
    date, setDate,
    hours, setHours,
    type, setType,
    dateFrom, setDateFrom,
    dateTo, setDateTo,
    days, setDays,
    reason, setReason,
    files, setFiles,
    viewImage,
    isApprove,
    handleUpdate,
    user,

    content, setContent,
    gpsCam, setGPSCam,
}) {
    const [offsetDate, setOffsetDate] = useState([]);

    const [attachmentType, setAttachmentType] = useState(null)
    const [showViewForm, setShowViewForm] = useState(false)
    const [selectedData, setSelectedData] = useState(null)

    const openViewForm = () => {
        setShowViewForm(true)
    }
    const closeViewForm = () => {
        setShowViewForm(false)
    }

    const viewHandleClick = async (_data, _type) => {
        setSelectedData(_data)
        setAttachmentType(_type)
        openViewForm();
    }
    
    

    const [fileNameGPS, setFileNameGPS] = useState("")
    const [fileNameContent, setFileNameContent] = useState("")
    const handleBrowseGPSCam = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const reader = new FileReader();

        reader.onload = () => {
            const base64 = reader.result.split(",")[1];

            setGPSCam(base64);
            setFileNameGPS(file.name)
        };

        reader.readAsDataURL(file);
    };
    const handleBrowseProofApproval = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const reader = new FileReader();

        reader.onload = () => {
            const base64 = reader.result.split(",")[1];

            setContent(base64);
            setFileNameContent(file.name)
        };

        reader.readAsDataURL(file);
    };

    const handleClose = () => {
        onClose();
        closeReferenceDateForm()
        setOffsetDate([])
        setAttachmentType(null)
        setShowViewForm(false)
        setSelectedData(null)
        setFileNameGPS("")
        setFileNameContent("")
    };

    const generateNewData = useCallback(async () => {
        const apiUrl = domain + `/api/OffsetRequest/generate-offset-date/employee/${editData.employeePersonalInformationEmployeeId}/selection/${true}`;

        try {
        const response = await axios.post(apiUrl, {}, {
            headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // You can include other headers if needed
            },
        });

        console.log("response", response.data, apiUrl)
        return response.data
        } catch (error) {
        console.error("Error fetching data:", error);
        return null
        }
    }, [editData.employeePersonalInformationEmployeeId]);

    useEffect(() => {
        if(isOpen){
            const fetch = async () => {
                const _data = await generateNewData();

                setOffsetDate(_data);
            }

            fetch();
        }
    } , [isOpen, generateNewData])

    // for upload
    const handleBrowse = (e) => {
        const fileList = Array.from(e.target.files);

        if (fileList.length > 0) {
            if(!fileList[0].type.startsWith("image/")){
                alert("Please select an image file.");
                setFiles("");
                return;
            }
        }

        setFiles(fileList);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        
        const fileList = Array.from(e.dataTransfer.files);
        e.currentTarget.style.backgroundColor = "white";

        if (fileList.length > 0) {
            if(!fileList[0].type.startsWith("image/")){
                alert("Please select an image file.");
                setFiles("");
                return;
            }
        }

        setFiles(fileList);
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#bdbdbd7d";
    };
    const handleDragOut = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "white";
    };
    const clearFiles = () => {
        // Clear the files state
        setFiles([]);
        // Reset the value of the file input
        document.getElementById('fileInput').value = '';
    };
    const [showReferenceDateForm, setShowReferenceDateForm] = useState(false);
    const openReferenceDateForm = () => {
    setShowReferenceDateForm(true);
    };
    const closeReferenceDateForm = () => {
    setShowReferenceDateForm(false);
    };

    const formatTime = (time) => {
        if(!time){
        return ""
        }

        let timeParts;
        let formattedTime;

        const timeSplit = time.split('T');
        if (timeSplit.length > 1) {
            timeParts = timeSplit[1].substr(0, 5).split(':');
        } else {
            timeParts = [];
        }
        let hours = parseInt(timeParts[0], 10);
        const minutes = timeParts[1];

        // Convert 24-hour format to 12-hour format and determine AM or PM
        const amPm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

        formattedTime = `${hours}:${minutes} ${amPm}`;

        return formattedTime
    }
    const removeReferenceDate = (id) => {
        setReferences((prev) => prev.filter((item) => item.id !== id));
    };

    return (
        <>
        <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
            {isOpen && (
            <>
                <div className="modal">
                    <div className="popUp-header row">
                    <div className="popUp-title">
                        <h3 style={{ color: "#668fca" }}>Request Details</h3>
                    </div>
                    <div className="popUp-close">
                        <CloseIcon onClick={() => handleClose()} />
                    </div>
                    </div>
                    <div className="popUp-body">
                    <div className="popUp-item info-item column">
                        <div className="info-item-label">Employee</div>
                        <div className="info-item-input">
                        <input
                            readOnly={true}
                            id="employeePersonalInformationFullName"
                            placeholder="Employee"
                            value={employeePersonalInformationFullName}
                            onChange={(e) =>
                            setEmployeePersonalInformationFullName(e.target.value)
                            }
                            style={{ cursor: "not-allowed" }}
                        />
                        </div>
                    </div>
                    <div className="info-item-holder row">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">References</div>
                            { references.length <= 0 &&
                                <div>
                                {CreateButton(
                                    "overtime-add-button",
                                    "add-reference row",
                                    openReferenceDateForm,
                                    "ADD REFERENCE",
                                    AddIcon
                                )}
                                </div>
                            }
                            <div className="info-item-input">
                                {references.map((item) => {
                                    return (
                                <div key={item.id} className="attendance-card" style={{width: "90%", padding: "0"}}>
                                    <div className="attendance-info" style={{margin: "12px"}}>
                                        {/* Date Section */}
                                        <div className="info-group">
                                        <span className="label label-date">Date</span>
                                        <span className="value">
                                            {item?.date ? item.date.split("T")[0] : "—"}
                                        </span>
                                        </div>

                                        {/* Time In Section */}
                                        <div className="info-group">
                                        <span className="label label-in">Time In</span>
                                        <span className="value font-bold">
                                            {item?.timeIn ? formatTime(item?.timeIn) : "—"}
                                        </span>
                                        </div>

                                        {/* Time Out Section */}
                                        <div className="info-group">
                                        <span className="label label-out">Time Out</span>
                                        <span className="value font-bold">
                                            {item?.timeOut ? formatTime(item?.timeOut) : "—"}
                                        </span>
                                        </div>
                                    </div>

                                    {/* Action Button */}
                                    <button 
                                        className="remove-btn"
                                        onClick={() => removeReferenceDate(item.id)}
                                    >
                                        Remove
                                    </button>
                                </div>
                                );
                                })}
                            </div>
                        </div>
                    
                    </div>
                    <div className="info-item-holder row">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Date (To Use)</div>
                            <div className="info-item-input">
                            <DateTimeInput2 date={date} setDate={setDate} isView={false} />
                            </div>
                        </div>
                    </div>
                    
                    <div className="popUp-item info-item column">
                        <div className="info-item-label">Reason</div>
                        <div className="info-item-input">
                            <textarea id="tamper" className="filterSelect"
                                    style={{width:"90%",minHeight:"50px", borderRadius:"3px", border:"1px solid #80808080",color: "rgb(104, 104, 104)"}}
                                    value={reason}
                                    onChange={(e) => setReason(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="popUp-item info-item column hidden">
                        <div className="info-item-label">Upload</div>
                        <div className="info-item-input">
                            <label htmlFor="fileInput" className='browse'>Browse...</label>
                            <input
                                type="file"
                                id="fileInput"
                                onChange={(e)=> handleBrowse(e)}
                                style={{ display: 'none' }}
                            />
                            
                            {files.length > 0 ? (
                                <div style={{border:"1px solid #97979745", padding:"10px"}}>
                                    <span>Uploaded File:</span>
                                    <ul>
                                        {files.map((file, index) => (
                                        <img src={file ? URL.createObjectURL(file) : "images/sample.jpg"} alt="" style={{width: "150px", height: "auto"}} onClick={() => viewImage({ content: file })}></img>
                                        ))}
                                    </ul>
                                    <div className="buttons row" style={{display:"flex", justifyContent:"end"}}>
                                        <button id="add-family" 
                                        className="cancel row"
                                        onClick={()=>clearFiles()}
                                        style={{marginRight:"5px"}}>
                                            CLEAR
                                        </button>
                                    </div>
                                </div>
                            )
                            :
                            (
                                <div
                                    id='drop-files-here'
                                    onDrop={(e)=>handleDrop(e)}
                                    onDragOver={(e)=>handleDragOver(e)}
                                    onDragLeave={(e)=>handleDragOut(e)}
                                    style={{
                                    border: '2px dashed #ccc',
                                    borderRadius: '5px',
                                    padding: '20px',
                                    marginTop: '10px',
                                    textAlign: 'center',
                                    }}
                                >
                                    Drop files here
                                </div>
                            )}
                        </div>
                    </div>
                    
                    
                    <div className='flex flex-col gap-5'>

                        {/* GPS CAM */}
                        <div className='flex flex-col gap-1'>
                            <div className='flex flex-row gap-2 items-center'>
                                <div className="info-item-label">GPS Cam</div>

                                <button
                                    type="button"
                                    className='cursor-pointer rounded-sm bg-sky-400 hover:bg-sky-500 text-white px-2 py-1'
                                    onClick={() => viewHandleClick(gpsCam, "GPS Cam")}
                                    disabled={!gpsCam}
                                >
                                    View
                                </button>

                                <button
                                    type="button"
                                    className='cursor-pointer rounded-sm bg-green-400 hover:bg-green-500 text-white px-2 py-1'
                                    onClick={() => document.getElementById("gpsCamInput").click()}
                                >
                                    Browse
                                </button>

                                <input
                                    id="gpsCamInput"
                                    type="file"
                                    className="hidden"
                                    accept="image/*,.pdf"
                                    onChange={handleBrowseGPSCam}
                                />
                            </div>

                            <div className="!border !border-gray-300 rounded-md text-xs text-gray-500 mt-1 px-2 py-1">
                                {gpsCam instanceof File
                                    ? gpsCam.name
                                    : gpsCam
                                        ? fileNameGPS || "Existing GPS Cam file"
                                        : "No file"
                                }
                            </div>
                        </div>


                        {/* PROOF OF APPROVAL */}
                        <div className='flex flex-col gap-1'>
                            <div className='flex flex-row gap-2 items-center'>
                                <div className="info-item-label">Proof of Approval</div>

                                <button
                                    type="button"
                                    className='cursor-pointer rounded-sm bg-sky-400 hover:bg-sky-500 text-white px-2 py-1'
                                    onClick={() => viewHandleClick(content, "Proof of Approval")}
                                    disabled={!content}
                                >
                                    View
                                </button>

                                <button
                                    type="button"
                                    className='cursor-pointer rounded-sm bg-green-400 hover:bg-green-500 text-white px-2 py-1'
                                    onClick={() => document.getElementById("contentInput").click()}
                                >
                                    Browse
                                </button>

                                <input
                                    id="contentInput"
                                    type="file"
                                    className="hidden"
                                    accept="image/*,.pdf,.doc,.docx,.xls,.xlsx"
                                    onChange={handleBrowseProofApproval}
                                />
                            </div>

                            <div className="!border !border-gray-300 rounded-md text-xs text-gray-500 mt-1 px-2 py-1">
                                {content instanceof File
                                    ? content.name
                                    : content
                                        ? fileNameContent || "Existing Proof of Approval file"
                                        : "No file"
                                }
                            </div>
                        </div>

                    </div>
                    </div>
                    <div
                    className="buttons row"
                    style={{ justifyContent: "end", padding: "20px 40px" }}
                    >
                    <button
                        id="add-family"
                        className="save row"
                        style={{ marginRight: "5px" }}
                        onClick={(e) =>
                        handleUpdate(e)
                        }
                    >
                        UPDATE
                    </button>
                    <button
                        id="add-family"
                        className="cancel row"
                        onClick={handleClose}
                    >
                        Close
                    </button>
                    </div>
                </div>
                    
                <AttachmentForm 
                    isOpen={showViewForm}
                    onClose={closeViewForm}
                    modalName={attachmentType}
                    data={selectedData}
                />
            </>
            )}
        </div>
        { showReferenceDateForm &&
            <ReferenceOffsetDateSelectForm
                isOpen={showReferenceDateForm}
                onClose={closeReferenceDateForm}
                overtimeData={offsetDate}
                reference={references}
                setReference={setReferences}
                setHours={setHours}
                user={user}
            ></ReferenceOffsetDateSelectForm>
        }
        </>
    );
}
function ReferenceOffsetDateSelectForm({ isOpen, onClose, overtimeData, reference, setReference, setHours, user }) {
  var header = [
    "Date",
    "Time In",
    "Time Out",
  ];
  var accessor = [
    "date",
    "timeIn",
    "timeOut",
  ];

  // const [data, setData] = useState([]);
  const [selectedReference, setSelectedReference] = useState(null);

  const handleClose = () => {
    onClose();
    // fetchData();
  };
  
  const handleProceed = () => {
    if (selectedReference?.length !== 0) {
      const foundReference = reference.find(i => i.id === selectedReference.id)

      if(foundReference){
        alert("Already added this reference");
      } else 
      {
        setReference((prev) => [...prev, selectedReference]);
        // fetchData();
        onClose();
      }
    }
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Select Reference Date</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body selectModal">
              <div className="select-employee-table">
                <CreateTableForReferenceSelect
                  dataList={overtimeData ?? []}
                  dataHeader={header}
                  dataAccessor={accessor}
                  setSelectedReference={setSelectedReference}
                  // viewHandleClick={viewHandleClick}
                />
                {overtimeData?.data?.length > 0 ? (
                  <div></div>
                ) : (
                  <div> {/*<p>No records to display</p>*/}</div>
                )}
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "50px 20px 0 20px" }}
            >
              <button
                id="add-family"
                className="save row"
                onClick={handleProceed}
              >
                PROCEED
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function EditOBRequestForm({isOpen, 
    onClose, 
    employeePersonalInformationFullNameOB, setEmployeePersonalInformationFullNameOB,
    reasonOB, setReasonOB,
    locationOB, setLocationOB,
    dateFromOB, setDateFromOB,
    dateToOB, setDateToOB,
    timeFromOB, setTimeFromOB,
    timeToOB, setTimeToOB,

    handleUpdate,

    content, setContent,
    gpsCam, setGPSCam,
})
{
    const [attachmentType, setAttachmentType] = useState(null)
    const [showViewForm, setShowViewForm] = useState(false)
    const [selectedData, setSelectedData] = useState(null)

    const openViewForm = () => {
        setShowViewForm(true)
    }
    const closeViewForm = () => {
        setShowViewForm(false)
    }

    const viewHandleClick = async (_data, _type) => {
        setSelectedData(_data)
        setAttachmentType(_type)
        openViewForm();
    }
    
    

    const [fileNameGPS, setFileNameGPS] = useState("")
    const [fileNameContent, setFileNameContent] = useState("")
    const handleBrowseGPSCam = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const reader = new FileReader();

        reader.onload = () => {
            const base64 = reader.result.split(",")[1];

            setGPSCam(base64);
            setFileNameGPS(file.name)
        };

        reader.readAsDataURL(file);
    };
    const handleBrowseProofApproval = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const reader = new FileReader();

        reader.onload = () => {
            const base64 = reader.result.split(",")[1];

            setContent(base64);
            setFileNameContent(file.name)
        };

        reader.readAsDataURL(file);
    };

    const handleClose = () => {
        onClose();
        setAttachmentType(null)
        setShowViewForm(false)
        setSelectedData(null)
        setFileNameGPS("")
        setFileNameContent("")
    };
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <>
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Update Details</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Employee</div>
                                <div className="info-item-input">
                                    <input
                                    readOnly={true}
                                    id="employeePersonalInformationFullNameChangeSchedule"
                                    placeholder="Employee"
                                    value={employeePersonalInformationFullNameOB}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Location</div>
                            <div className="info-item-input">
                                <input
                                    value={locationOB}
                                    onChange={(e)=>setLocationOB(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Date From</div>
                                <div className="info-item-input">
                                    <DateInput date={dateFromOB} setDate={setDateFromOB} isView={false}/>
                                    {/* {DateInput(dateChangeLogRequest, setDateChangeLogRequest, false)} */}
                                </div>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Date To</div>
                                <div className="info-item-input">
                                    <DateInput date={dateToOB} setDate={setDateToOB} isView={false}/>
                                    {/* {DateInput(dateChangeLogRequest, setDateChangeLogRequest, false)} */}
                                </div>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Time From</div>
                                <div className="info-item-input">
                                    <TimeInput date={timeFromOB} setDate={setTimeFromOB} isView={false}/>
                                    {/* {DateInput(dateChangeLogRequest, setDateChangeLogRequest, false)} */}
                                </div>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Time To</div>
                                <div className="info-item-input">
                                    <TimeInput date={timeToOB} setDate={setTimeToOB} isView={false}/>
                                    {/* {DateInput(dateChangeLogRequest, setDateChangeLogRequest, false)} */}
                                </div>
                            </div>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Reason</div>
                            <div className="info-item-input">
                                <textarea id="tamper" className="filterSelect"
                                        style={{width:"100%",minHeight:"50px", borderRadius:"3px", border:"1px solid #80808080",color: "rgb(104, 104, 104)"}}
                                        value={reasonOB}
                                        onChange={(e) => setReasonOB(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className='flex flex-col gap-5'>

                            {/* GPS CAM */}
                            <div className='flex flex-col gap-1'>
                                <div className='flex flex-row gap-2 items-center'>
                                    <div className="info-item-label">GPS Cam</div>

                                    <button
                                        type="button"
                                        className='cursor-pointer rounded-sm bg-sky-400 hover:bg-sky-500 text-white px-2 py-1'
                                        onClick={() => viewHandleClick(gpsCam, "GPS Cam")}
                                        disabled={!gpsCam}
                                    >
                                        View
                                    </button>

                                    <button
                                        type="button"
                                        className='cursor-pointer rounded-sm bg-green-400 hover:bg-green-500 text-white px-2 py-1'
                                        onClick={() => document.getElementById("gpsCamInput").click()}
                                    >
                                        Browse
                                    </button>

                                    <input
                                        id="gpsCamInput"
                                        type="file"
                                        className="hidden"
                                        accept="image/*,.pdf"
                                        onChange={handleBrowseGPSCam}
                                    />
                                </div>

                                <div className="!border !border-gray-300 rounded-md text-xs text-gray-500 mt-1 px-2 py-1">
                                    {gpsCam instanceof File
                                        ? gpsCam.name
                                        : gpsCam
                                            ? fileNameGPS || "Existing GPS Cam file"
                                            : "No file"
                                    }
                                </div>
                            </div>


                            {/* PROOF OF APPROVAL */}
                            <div className='flex flex-col gap-1'>
                                <div className='flex flex-row gap-2 items-center'>
                                    <div className="info-item-label">Proof of Approval</div>

                                    <button
                                        type="button"
                                        className='cursor-pointer rounded-sm bg-sky-400 hover:bg-sky-500 text-white px-2 py-1'
                                        onClick={() => viewHandleClick(content, "Proof of Approval")}
                                        disabled={!content}
                                    >
                                        View
                                    </button>

                                    <button
                                        type="button"
                                        className='cursor-pointer rounded-sm bg-green-400 hover:bg-green-500 text-white px-2 py-1'
                                        onClick={() => document.getElementById("contentInput").click()}
                                    >
                                        Browse
                                    </button>

                                    <input
                                        id="contentInput"
                                        type="file"
                                        className="hidden"
                                        accept="image/*,.pdf,.doc,.docx,.xls,.xlsx"
                                        onChange={handleBrowseProofApproval}
                                    />
                                </div>

                                <div className="!border !border-gray-300 rounded-md text-xs text-gray-500 mt-1 px-2 py-1">
                                    {content instanceof File
                                        ? content.name
                                        : content
                                            ? fileNameContent || "Existing Proof of Approval file"
                                            : "No file"
                                    }
                                </div>
                            </div>

                        </div>

                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            style={{marginRight: "5px"}}
                            onClick={handleUpdate}>
                                Update
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            style={{height: "34px", borderRadius: "3px"}}
                            onClick={handleClose}>
                                Close
                        </button>
                    </div>
                </div>
                
                    
                <AttachmentForm 
                    isOpen={showViewForm}
                    onClose={closeViewForm}
                    modalName={attachmentType}
                    data={selectedData}
                />
                </>
            )}
            </div>
        </>
    );
}
function ViewOBRequestForm({isOpen, 
    onClose, 
    employeePersonalInformationFullNameOB, setEmployeePersonalInformationFullNameOB,
    reasonOB, setReasonOB,
    locationOB, setLocationOB,
    dateFromOB, setDateFromOB,
    dateToOB, setDateToOB,
    timeFromOB, setTimeFromOB,
    timeToOB, setTimeToOB,

    handleUpdate,

    content, setContent,
    gpsCam, setGPSCam,
})
{
    const [attachmentType, setAttachmentType] = useState(null)
    const [showViewForm, setShowViewForm] = useState(false)
    const [selectedData, setSelectedData] = useState(null)

    const openViewForm = () => {
        setShowViewForm(true)
    }
    const closeViewForm = () => {
        setShowViewForm(false)
    }

    const viewHandleClick = async (_data, _type) => {
        setSelectedData(_data)
        setAttachmentType(_type)
        openViewForm();
    }

    const handleClose = () => {
        onClose();
        setAttachmentType(null)
        setShowViewForm(false)
        setSelectedData(null)
    };
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <>
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>View Details</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Employee</div>
                                <div className="info-item-input">
                                    <input
                                    readOnly={true}
                                    id="employeePersonalInformationFullNameChangeSchedule"
                                    placeholder="Employee"
                                    value={employeePersonalInformationFullNameOB}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Location</div>
                            <div className="info-item-input">
                                <input
                                    value={locationOB}
                                    readOnly
                                    // onChange={(e)=>setLocationOB(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Date From</div>
                                <div className="info-item-input">
                                    <DateInput date={dateFromOB} setDate={setDateFromOB} isView={true}/>
                                    {/* {DateInput(dateChangeLogRequest, setDateChangeLogRequest, false)} */}
                                </div>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Date To</div>
                                <div className="info-item-input">
                                    <DateInput date={dateToOB} setDate={setDateToOB} isView={true}/>
                                    {/* {DateInput(dateChangeLogRequest, setDateChangeLogRequest, false)} */}
                                </div>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Time From</div>
                                <div className="info-item-input">
                                    <TimeInput date={timeFromOB} setDate={setTimeFromOB} isView={true}/>
                                    {/* {DateInput(dateChangeLogRequest, setDateChangeLogRequest, false)} */}
                                </div>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Time To</div>
                                <div className="info-item-input">
                                    <TimeInput date={timeToOB} setDate={setTimeToOB} isView={true}/>
                                    {/* {DateInput(dateChangeLogRequest, setDateChangeLogRequest, false)} */}
                                </div>
                            </div>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Reason</div>
                            <div className="info-item-input">
                                <textarea id="tamper" className="filterSelect"
                                        style={{width:"100%",minHeight:"50px", borderRadius:"3px", border:"1px solid #80808080",color: "rgb(104, 104, 104)"}}
                                        value={reasonOB}
                                        onChange={(e) => setReasonOB(e.target.value)}
                                        readOnly
                                />
                            </div>
                        </div>

                        <div className='flex flex-col gap-5'>

                            {/* GPS CAM */}
                            <div className='flex flex-col gap-1'>
                                <div className='flex flex-row gap-2 items-center'>
                                    <div className="info-item-label">GPS Cam</div>

                                    <button
                                        type="button"
                                        className='cursor-pointer rounded-sm bg-sky-400 hover:bg-sky-500 text-white px-2 py-1'
                                        onClick={() => viewHandleClick(gpsCam, "GPS Cam")}
                                        disabled={!gpsCam}
                                    >
                                        View
                                    </button>
                                </div>

                                <div className="!border !border-gray-300 rounded-md text-xs text-gray-500 mt-1 px-2 py-1">
                                    {gpsCam instanceof File
                                        ? gpsCam.name
                                        : gpsCam
                                            ? "Existing GPS Cam file"
                                            : "No file"
                                    }
                                </div>
                            </div>


                            {/* PROOF OF APPROVAL */}
                            <div className='flex flex-col gap-1'>
                                <div className='flex flex-row gap-2 items-center'>
                                    <div className="info-item-label">Proof of Approval</div>

                                    <button
                                        type="button"
                                        className='cursor-pointer rounded-sm bg-sky-400 hover:bg-sky-500 text-white px-2 py-1'
                                        onClick={() => viewHandleClick(content, "Proof of Approval")}
                                        disabled={!content}
                                    >
                                        View
                                    </button>
                                </div>

                                <div className="!border !border-gray-300 rounded-md text-xs text-gray-500 mt-1 px-2 py-1">
                                    {content instanceof File
                                        ? content.name
                                        : content
                                            ? "Existing Proof of Approval file"
                                            : "No file"
                                    }
                                </div>
                            </div>

                        </div>

                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row hidden"
                            style={{marginRight: "5px"}}
                            onClick={handleUpdate}>
                                Update
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            style={{height: "34px", borderRadius: "3px"}}
                            onClick={handleClose}>
                                Close
                        </button>
                    </div>
                </div>
                
                    
                <AttachmentForm 
                    isOpen={showViewForm}
                    onClose={closeViewForm}
                    modalName={attachmentType}
                    data={selectedData}
                />
                </>
            )}
            </div>
        </>
    );
}
export function CreateTableForReferenceSelect({
  dataList = [],
  dataHeader = [],
  dataAccessor = [],
  viewHandleClick,
  setSelectedReference,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [activeRowId, setActiveRowId] = useState(null);
  const itemsPerPage = 10;

  const columns = React.useMemo(
    () =>
      dataHeader.map((header, index) => ({
        Header: header,
        accessor: dataAccessor[index],
      })),
    [dataHeader, dataAccessor]
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data: dataList });

  const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
  const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows?.length);
  const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(rows?.length / itemsPerPage);
  const isLastPage = currentPage === totalPages;

  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const handleRowClick = (rowData) => {
    setSelectedReference(rowData); // Pass the clicked row data to the setSelectedEmployee function
    setActiveRowId(rowData.id);
  };

  return (
    <div>
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{column.render("Header")}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {dataList?.length <= 0 && (
            <tr>
              <td colSpan={columns?.length} style={{ textAlign: "center" }}>
                No data to display
              </td>
            </tr>
          )}
          {currentItems.map((row) => {
            prepareRow(row);
            return (
              <tr
                key={row.original.id}
                {...row.getRowProps()}
                onClick={() => handleRowClick(row.original)} // Attach onClick event handler to the row
                className={row.original.id === activeRowId ? "active" : ""}
              >
                {row.cells.map((cell) =>
                  SetInfo(
                    cell.render("Cell").props.column.Header,
                    cell,
                    viewHandleClick
                  )
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
      {rows?.length > itemsPerPage ? (
        <div>
          <div
            className="table-page row"
            style={{
              alignItems: "center",
              justifyContent: "end",
              padding: "20px 0 0 0",
            }}
          >
            <button
              className="prev row"
              onClick={() => paginate(1)}
              disabled={currentPage === 1}
              style={{
                visibility: currentPage === 1 ? "hidden" : "visible",
                marginRight: "5px",
                height: "26px",
              }}
            >
              &lt;&lt;
            </button>
            <button
              className="prev row"
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
              style={{
                visibility: currentPage === 1 ? "hidden" : "visible",
                marginRight: "5px",
                height: "26px",
              }}
            >
              <NavigateBeforeIcon style={{ marginRight: "5px" }} /> PREVIOUS
            </button>
            <button
              className="next row"
              onClick={() => paginate(currentPage + 1)}
              disabled={indexOfLastItem >= rows?.length}
              style={{
                visibility:
                  rows?.length > itemsPerPage && !isLastPage
                    ? "visible"
                    : "hidden",
                marginRight: "5px",
                height: "26px",
              }}
            >
              NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
            </button>
            <button
              className="next row"
              onClick={() => paginate(totalPages)}
              disabled={indexOfLastItem >= rows?.length}
              style={{
                visibility:
                  rows?.length > itemsPerPage && !isLastPage
                    ? "visible"
                    : "hidden",
                height: "26px",
              }}
            >
              &gt;&gt;
            </button>
          </div>
          <div
            style={{ textAlign: "center" }}
          >{`${currentPage}/${totalPages}`}</div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
function EmployeeStatus({employeeStatus, setEmployeeStatus, isEditMode}){
  const [isSelected, setIsSelected] = useState(false);
  
  const handleSelectChange = (event) => {
      setIsSelected(true);
      setEmployeeStatus(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
      const apiUrl =  domain + "/api/EmployeeStatusMaintenance/active";

      await axios.get(apiUrl , {
          headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json' // You can include other headers if needed
      }})
      .then(response => {
        response.data.sort((a, b) => a.description.localeCompare(b.description));
        setData(response.data); // Set the response data to the state
      })
      .catch(error => {
          console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
      fetchData();
      if(employeeStatus !== "" && employeeStatus !== 0){
          setIsSelected(true);
      } else {
          setIsSelected(false);
      }
  }, [employeeStatus]);

  return (
      <div>
          <select id="employee-select-PagibigReport" disabled={!isEditMode} value={employeeStatus || ""} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
          <option value="All" >All</option>
          {data.map((employeeStatus) => ( 
            <option value={employeeStatus.description}>{
              employeeStatus.description}
            </option>
          ))}
          </select>
      </div>
  );
};
export default Home
